
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("dsKht", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeRenderer", () => $1ef3d8d6757af3e2$export$e8934af6f19a3b7c);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $8J6rn = parcelRequire("8J6rn");

var $7CMCs = parcelRequire("7CMCs");

var $ACELo = parcelRequire("ACELo");

var $iXVV6 = parcelRequire("iXVV6");

var $fjrC9 = parcelRequire("fjrC9");

var $6BT89 = parcelRequire("6BT89");

var $4kqRp = parcelRequire("4kqRp");

var $ez5GD = parcelRequire("ez5GD");

var $5p9RM = parcelRequire("5p9RM");

var $aTWms = parcelRequire("aTWms");

var $8PpFm = parcelRequire("8PpFm");

var $ajgbf = parcelRequire("ajgbf");
const $1ef3d8d6757af3e2$var$TransitionHomeRendererInner = ()=>{
    const { isTransitionHomeModalOpen: isTransitionHomeModalOpen, openTransitionHomeModal: openTransitionHomeModal, closeTransitionHomeModal: closeTransitionHomeModal, isTransitionHomeLoading: isTransitionHomeLoading, isTransitionHomeActivated: isTransitionHomeActivated } = (0, $6BT89.useGlobalChangeboarding)();
    const { isTransitioning: isTransitioning, cohort: cohort } = (0, $8J6rn.useOgTenantInfo)();
    const { changeActiveContent: changeActiveContent } = (0, $4kqRp.useProgressActions)();
    const { data: data } = (0, $ez5GD.useOgConsolidationUserState)();
    const { clearQueryParams: clearQueryParams, queryParamsValid: queryParamsValid, activeTaskIndex: activeTaskIndex, activeContent: activeContent } = (0, $5p9RM.useTransitionHomeQueryParams)();
    (0, $5uXOq.useEffect)(()=>{
        const isTransitionHomeReady = !isTransitionHomeLoading && isTransitionHomeActivated && !isTransitionHomeModalOpen;
        const isTransitionHomeVisible = !data?.isTransitionHomeHidden;
        const isModalReady = isTransitionHomeReady && isTransitionHomeVisible;
        const shouldOpenAndActivateModal = isTransitioning && queryParamsValid;
        if (isModalReady && shouldOpenAndActivateModal) openTransitionHomeModal().then(()=>{
            if (activeContent) {
                changeActiveContent(activeContent, activeTaskIndex);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const nodes = document.querySelectorAll('.transition-home-content-box');
                const node = nodes[activeTaskIndex];
                if (node) node.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
                clearQueryParams();
            }
        });
    }, [
        activeContent,
        activeTaskIndex,
        changeActiveContent,
        clearQueryParams,
        cohort,
        data?.isTransitionHomeHidden,
        isTransitionHomeActivated,
        isTransitionHomeLoading,
        isTransitionHomeModalOpen,
        isTransitioning,
        openTransitionHomeModal,
        queryParamsValid
    ]);
    if (!isTransitioning || !isTransitionHomeActivated) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "transitionHomeModal",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8PpFm.TransitionHomeModal), {
        isOpen: isTransitionHomeModalOpen,
        onClose: closeTransitionHomeModal
    })), !data?.isTransitionHomeHidden && !isTransitionHomeModalOpen && cohort !== 'cohort4' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ACELo.JiraBottomRightCornerOutlet), {
        orderFromRight: 5,
        id: "servicedesk-eoc-transition-home-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ajgbf.TransitionHomeButton), {
        isLoading: isTransitionHomeLoading,
        onClick: openTransitionHomeModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: (0, $fjrC9.HELP_PANEL_SPOTLIGHT_NAME)
    }));
};
const $1ef3d8d6757af3e2$export$e8934af6f19a3b7c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "eoc.changeboarding.transition.home",
        packageName: "jiraEocChangeboarding",
        fallback: "flag",
        teamName: "alexstrasza"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTWms.ChangeboardingProviders), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ef3d8d6757af3e2$var$TransitionHomeRendererInner, null)));

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("fjrC9", function(module, exports) {

$parcel$export(module.exports, "emptyResource", () => $6e16d59f74f8efc1$export$6ed870441802d126);
$parcel$export(module.exports, "SLACK_CREATE_CONNECTION_EVENT_ID", () => $6e16d59f74f8efc1$export$f499a35a9a662ad8);
$parcel$export(module.exports, "SlackErrorCodes", () => $6e16d59f74f8efc1$export$ca77fcbf65183d7a);
$parcel$export(module.exports, "MstErrorCodes", () => $6e16d59f74f8efc1$export$7dd2cc6fd63b5d49);
$parcel$export(module.exports, "JIRA_SUPPORT_LINK", () => $6e16d59f74f8efc1$export$4dc85a478189d1be);
$parcel$export(module.exports, "SLACK_IMAGE_URL", () => $6e16d59f74f8efc1$export$c5dc119cdbeed3dc);
$parcel$export(module.exports, "MST_IMAGE_URL", () => $6e16d59f74f8efc1$export$31622a6434c822c0);
$parcel$export(module.exports, "SLACK_TEXT", () => $6e16d59f74f8efc1$export$d982cc6618dbc0f3);
$parcel$export(module.exports, "MST_TEXT", () => $6e16d59f74f8efc1$export$80d888715be28a18);
$parcel$export(module.exports, "MSTEAMS_CREATE_CONNECTION_EVENT_ID", () => $6e16d59f74f8efc1$export$37e742a41eacef56);
$parcel$export(module.exports, "ADMIN_CONSENT_REQUIRED_EVENT_ID", () => $6e16d59f74f8efc1$export$fe93b230923a5912);
$parcel$export(module.exports, "SLACK_APP_TYPE", () => $6e16d59f74f8efc1$export$2dfb4588bf1292d9);
$parcel$export(module.exports, "MST_APP_TYPE", () => $6e16d59f74f8efc1$export$6838a40356798ab0);
$parcel$export(module.exports, "MSTEAMS_USER_LEVEL_AUTH_EVENT_ID", () => $6e16d59f74f8efc1$export$d1ee2159a22b5eeb);
$parcel$export(module.exports, "SLACK_USER_LEVEL_AUTH_EVENT_ID", () => $6e16d59f74f8efc1$export$40d44b9e20d7bd23);
$parcel$export(module.exports, "TRANSITION_HOME_BUTTON_SPOTLIGHT_NAME", () => $6e16d59f74f8efc1$export$36dc24398b969929);
$parcel$export(module.exports, "HELP_PANEL_SPOTLIGHT_NAME", () => $6e16d59f74f8efc1$export$47504886f4581388);
$parcel$export(module.exports, "UNLOCK_LINK", () => $6e16d59f74f8efc1$export$25520e270c8e452f);
const $6e16d59f74f8efc1$export$6ed870441802d126 = {
    data: null,
    error: null,
    loading: false
};
const $6e16d59f74f8efc1$export$f499a35a9a662ad8 = 'slack_connection_creation_response';
const $6e16d59f74f8efc1$export$ca77fcbf65183d7a = {
    AUTH_CODE_MISSING: 'auth_code_missing',
    CONNECTION_ALREADY_EXIST: 'connection_already_exist',
    CONNECTION_CREATION_FAILED: 'connection_creation_failed',
    FETCH_TOKEN_FAILED: 'failed_to_fetch_token',
    FORBIDDEN_TENANT: 'forbidden_tenant',
    INVALID_STATE: 'invalid_state',
    LINK_EXPIRED: 'link_expired',
    STATE_DECRYPTION_FAILED: 'state_decryption_failed',
    WORKSPACE_MISSMATCH: 'workspace_mismatch'
};
const $6e16d59f74f8efc1$export$7dd2cc6fd63b5d49 = {
    TENANT_CONFLICT: 'tenant_conflict',
    TENANT_MISMATCH: 'tenant_mismatch'
};
const $6e16d59f74f8efc1$export$4dc85a478189d1be = 'https://support.atlassian.com/contact/';
const $6e16d59f74f8efc1$export$c5dc119cdbeed3dc = 'https://resources.opsgeni.us/resources/images/public/integration/logos/SlackApp.png';
const $6e16d59f74f8efc1$export$31622a6434c822c0 = 'https://resources.opsgeni.us/resources/images/public/integration/logos/MSTeams.png';
const $6e16d59f74f8efc1$export$d982cc6618dbc0f3 = 'Slack';
const $6e16d59f74f8efc1$export$80d888715be28a18 = 'Microsoft Teams';
const $6e16d59f74f8efc1$export$37e742a41eacef56 = 'microsoft_create_connection_response';
const $6e16d59f74f8efc1$export$fe93b230923a5912 = 'microsoft_admin_permission_response';
const $6e16d59f74f8efc1$export$2dfb4588bf1292d9 = 'jsm-it-service-desk';
const $6e16d59f74f8efc1$export$6838a40356798ab0 = 'jsm-msteams-app';
const $6e16d59f74f8efc1$export$d1ee2159a22b5eeb = 'microsoft_delegated_permission_response';
const $6e16d59f74f8efc1$export$40d44b9e20d7bd23 = 'slack_user_auth_response';
const $6e16d59f74f8efc1$export$36dc24398b969929 = 'eoc-changeboarding_transition_home_lozenge';
const $6e16d59f74f8efc1$export$47504886f4581388 = 'help-spotlight';
const $6e16d59f74f8efc1$export$25520e270c8e452f = '/jira/settings/products/ops/unlock';

});

parcelRegister("6BT89", function(module, exports) {

$parcel$export(module.exports, "useGlobalChangeboarding", () => $190423316351a626$export$e618620d6c810888);

var $5uXOq = parcelRequire("5uXOq");

var $8J6rn = parcelRequire("8J6rn");

var $pa9q9 = parcelRequire("pa9q9");

var $7jF6i = parcelRequire("7jF6i");


var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $9OXo1 = parcelRequire("9OXo1");

var $ieDtd = parcelRequire("ieDtd");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4iQaI = parcelRequire("4iQaI");

var $lLiTq = parcelRequire("lLiTq");

var $luBum = parcelRequire("luBum");

var $5fIfP = parcelRequire("5fIfP");

var $gPfYl = parcelRequire("gPfYl");

var $jbwqm = parcelRequire("jbwqm");

var $4UyCK = parcelRequire("4UyCK");

var $91lou = parcelRequire("91lou");

var $k9ufy = parcelRequire("k9ufy");

var $iA7nF = parcelRequire("iA7nF");

var $ez5GD = parcelRequire("ez5GD");


var $kkwlq = parcelRequire("kkwlq");
const $190423316351a626$var$initialState = {
    isTransitionHomeActivated: false,
    isTransitionHomeModalOpen: false,
    isWelcomeModalActivated: false,
    opsgenieBaseUrl: undefined
};
const $190423316351a626$var$Store = (0, $iXqE5.createStore)({
    initialState: $190423316351a626$var$initialState,
    actions: {
        openTransitionHomeModalAction: ()=>({ setState: setState })=>{
                setState({
                    isTransitionHomeModalOpen: true
                });
            },
        closeTransitionHomeModal: ()=>({ setState: setState })=>{
                setState({
                    isTransitionHomeModalOpen: false
                });
            },
        activateTransitionHome: ()=>({ setState: setState })=>{
                setState({
                    isTransitionHomeActivated: true
                });
            },
        activateWelcomeModal: ()=>({ setState: setState })=>{
                setState({
                    isWelcomeModalActivated: true
                });
            },
        deactivateWelcomeModal: ()=>({ setState: setState })=>{
                setState({
                    isWelcomeModalActivated: false
                });
            }
    },
    name: 'global-changeboarding'
});
const $190423316351a626$export$2285bd7a7d8d4d7b = (0, $3sQ5x.createHook)($190423316351a626$var$Store);
const $190423316351a626$export$e618620d6c810888 = ()=>{
    const [isTransitionHomeLoading, setIsTransitionHomeLoading] = (0, $5uXOq.useState)(false);
    const [{ isTransitionHomeActivated: isTransitionHomeActivated, isWelcomeModalActivated: isWelcomeModalActivated, isTransitionHomeModalOpen: isTransitionHomeModalOpen }, { openTransitionHomeModalAction: openTransitionHomeModalAction, closeTransitionHomeModal: closeTransitionHomeModal, activateTransitionHome: activateTransitionHome, activateWelcomeModal: activateWelcomeModal, deactivateWelcomeModal: deactivateWelcomeModal }] = $190423316351a626$export$2285bd7a7d8d4d7b();
    const [{ usersWithoutAdminRole: usersWithoutAdminRole, usersWithoutCustomRole: usersWithoutCustomRole, stakeholders: stakeholders }, { initialize: initializeUsersAndRoles }] = (0, $k9ufy.useUsersAndRolesStore)();
    const [{ counts: counts, syncedIntegrations: syncedIntegrations, discontinuedIntegrations: discontinuedIntegrations, deprecatedIntegrations: deprecatedIntegrations, incomingCallIntegrations: incomingCallIntegrations }, { initialize: initializeIntegrations, initializeForAdmin: initializeIntegrationsForAdmin }] = (0, $5fIfP.useIntegrationsStore)();
    const [{ notificationPolicies: notificationPolicies, groups: groups, heartbeats: heartbeats }, { initialize: initializeDeprecatedCounts }] = (0, $lLiTq.useDeprecatedCountsStore)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [{ integrations: integrations, connections: connections }, { initialize: initializeChatTools, initializeForTeamAdmin: initializeChatToolsForTeamAdmin }] = (0, $4iQaI.useChatToolsStore)();
    const [{ incidentsCopyStatus: incidentsCopyStatus }, { initialize: initializeIncidentsCopyStatus }] = (0, $luBum.useIncidentsStore)();
    const [{ loading: transitioningStatusLoading, error: transitioningStatusError }, { initialize: initializeTransitioningStatus }] = (0, $91lou.useTransitioningStatus)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const hasJsmAboveStandard = !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, $ldyPw.FREE_EDITION) && appEditions.serviceDesk !== (0, $ldyPw.STANDARD_EDITION);
    const [{ teams: teams }, { initialize: initializeTeams }] = (0, $4UyCK.useTeams)();
    const [{ loading: jnaAppStatusLoading, error: jnaAppStatusError }, { initialize: initializeJNAAppStatus }] = (0, $gPfYl.useJNAAppStatus)();
    const [{ teamAdminStatus: teamAdminStatus }, { initialize: initializeTeamAdminStatus }] = (0, $jbwqm.useTeamAdminStatus)();
    const [{ fetchStatus: fetchStatus, opsgenieBaseUrl: opsgenieBaseUrl }] = (0, $7jF6i.useOpsgenieBaseUrl)('eocChangeboarding');
    const isOpsgenieBaseUrlLoaded = fetchStatus === 'SUCCESS';
    const [ref] = (0, $ieDtd.useQueryParam)((0, $2829d585c82ec887$export$203403aefc029c66));
    const [isWelcomeModalOpen, setIsWelcomeModalOpen] = (0, $5uXOq.useState)(true);
    const { data: data, error: error } = (0, $ez5GD.useOgConsolidationUserState)();
    const { isTransitioning: isTransitioning, loading: tenantLoading, error: tenantError } = (0, $8J6rn.useOgTenantInfo)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isWelcomeModalDisplayedInitialValue = (0, $5uXOq.useRef)(data?.isWelcomeModalDisplayed);
    isWelcomeModalDisplayedInitialValue.current = isWelcomeModalDisplayedInitialValue.current ?? data?.isWelcomeModalDisplayed;
    const isTransitioningInitialValue = (0, $5uXOq.useRef)(isTransitioning);
    isTransitioningInitialValue.current = isTransitioningInitialValue.current ?? isTransitioning;
    // Both of the waiting states are loaded at the SSR and should be already fetched
    // when client starts to render but just in case we should check it
    const isAllWelcomeModalDataLoaded = isWelcomeModalOpen && !tenantLoading && !tenantError && // We need to wait for the data to decide on the final state
    data?.isWelcomeModalDisplayed !== undefined && isOpsgenieBaseUrlLoaded;
    // Do not show the welcome modal until everything is ready
    // This will also prevent a render if there is an error with the initial
    // loading.
    // // We only care for the initial value, it should not change if the
    // // displayed state changes later.
    const finalWelcomeModalIsOpen = isAllWelcomeModalDataLoaded && isTransitioningInitialValue.current && !isWelcomeModalDisplayedInitialValue.current;
    const handleCloseWelcomeModal = ()=>{
        setIsWelcomeModalOpen(false);
    };
    const initializeModalRequests = (0, $5uXOq.useCallback)(()=>{
        const minimalRequiredInitializations = [
            initializeTransitioningStatus(),
            initializeJNAAppStatus()
        ];
        const isUser = !isAdmin && !isSiteAdmin;
        if (isUser) {
            const optimalRequiredInitializations = [
                ...minimalRequiredInitializations,
                initializeTeamAdminStatus(),
                initializeChatToolsForTeamAdmin(),
                initializeIntegrations()
            ];
            return Promise.allSettled(optimalRequiredInitializations).then((0, $iA7nF.multiplePromiseSettler));
        }
        const minimalToolingRequests = [
            initializeChatTools(),
            initializeUsersAndRoles(hasJsmAboveStandard),
            ...minimalRequiredInitializations
        ];
        const optimalToolingRequests = [
            ...minimalToolingRequests,
            initializeTeams(),
            initializeTeamAdminStatus(),
            initializeIntegrationsForAdmin(),
            initializeDeprecatedCounts(),
            initializeIncidentsCopyStatus()
        ];
        return Promise.allSettled(optimalToolingRequests).then((0, $iA7nF.multiplePromiseSettler));
    }, [
        initializeTransitioningStatus,
        initializeJNAAppStatus,
        isAdmin,
        isSiteAdmin,
        initializeChatTools,
        initializeUsersAndRoles,
        hasJsmAboveStandard,
        initializeTeamAdminStatus,
        initializeChatToolsForTeamAdmin,
        initializeTeams,
        initializeIntegrations,
        initializeIntegrationsForAdmin,
        initializeDeprecatedCounts,
        initializeIncidentsCopyStatus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Close the modal if an error occurs after the initial load
        // If the initial load errors out we don't render the modal at all.
        // This means we generated an error later in the process, let's just
        // get rid of the welcome modal.
        if (data && error) setIsWelcomeModalOpen(false);
    }, [
        error,
        data
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // if the decision data is not loaded don't activate anything
        if (!isAllWelcomeModalDataLoaded) return;
        // If one of the request failed then silently fail and activate transition home
        if (usersWithoutAdminRole.error || usersWithoutCustomRole.error || integrations.error || connections.error || transitioningStatusError || jnaAppStatusError || teams.error || teamAdminStatus.error || counts.error || syncedIntegrations.error || discontinuedIntegrations.error || deprecatedIntegrations.error || incomingCallIntegrations.error || heartbeats.error || notificationPolicies.error || groups.error || incidentsCopyStatus.error || hasJsmAboveStandard && stakeholders.error) {
            deactivateWelcomeModal();
            activateTransitionHome();
            return;
        }
        // if one of the flow is activated or requests are loading then don't activate anything more
        if (isWelcomeModalActivated || isTransitionHomeActivated || usersWithoutAdminRole.loading || usersWithoutCustomRole.loading || integrations.loading || connections.loading || transitioningStatusLoading || jnaAppStatusLoading || teams.loading || teamAdminStatus.loading || counts.loading || syncedIntegrations.loading || discontinuedIntegrations.loading || deprecatedIntegrations.loading || incomingCallIntegrations.loading || heartbeats.loading || notificationPolicies.loading || groups.loading || incidentsCopyStatus.loading || hasJsmAboveStandard && stakeholders.loading) return;
        // if the ref is exist on query parameter, we should activate the modal
        if (ref === (0, $2829d585c82ec887$export$8638ff77a0e20f0f) && finalWelcomeModalIsOpen) {
            initializeModalRequests().then(()=>{
                activateWelcomeModal();
            });
            return;
        }
        // if the ref is not present or we should not display welcome modal and the user is in transitioning state at first then activate transition home
        if (isTransitioningInitialValue.current) {
            deactivateWelcomeModal();
            activateTransitionHome();
        }
    }, [
        activateTransitionHome,
        activateWelcomeModal,
        connections.loading,
        deactivateWelcomeModal,
        finalWelcomeModalIsOpen,
        initializeUsersAndRoles,
        integrations.loading,
        isAllWelcomeModalDataLoaded,
        isTransitionHomeActivated,
        isWelcomeModalActivated,
        ref,
        initializeModalRequests,
        usersWithoutAdminRole.loading,
        usersWithoutCustomRole.loading,
        counts.loading,
        syncedIntegrations.loading,
        discontinuedIntegrations.loading,
        deprecatedIntegrations.loading,
        incomingCallIntegrations.loading,
        transitioningStatusLoading,
        jnaAppStatusLoading,
        usersWithoutAdminRole.error,
        usersWithoutCustomRole.error,
        integrations.error,
        connections.error,
        transitioningStatusError,
        jnaAppStatusError,
        teams.error,
        teams.loading,
        teamAdminStatus.error,
        teamAdminStatus.loading,
        counts.error,
        syncedIntegrations.error,
        discontinuedIntegrations.error,
        deprecatedIntegrations.error,
        incomingCallIntegrations.error,
        heartbeats.error,
        notificationPolicies.error,
        groups.error,
        heartbeats.loading,
        notificationPolicies.loading,
        groups.loading,
        incidentsCopyStatus.loading,
        incidentsCopyStatus.error,
        stakeholders.error,
        stakeholders.loading,
        hasJsmAboveStandard
    ]);
    const openTransitionHomeModal = ()=>{
        setIsTransitionHomeLoading(true);
        return initializeModalRequests().then(()=>{
            activateTransitionHome();
            openTransitionHomeModalAction();
        }).catch(()=>{
            showFlag({
                type: 'error',
                title: (0, $kkwlq.default).errorTitleNonFinal,
                description: (0, $kkwlq.default).errorDescriptionNonFinal,
                actions: [
                    {
                        content: (0, $kkwlq.default).errorActionNonFinal,
                        onClick: openTransitionHomeModal
                    }
                ],
                messageId: 'eoc-changeboarding.controllers.store.global.show-flag.error',
                messageType: 'transactional'
            });
        }).finally(()=>{
            setIsTransitionHomeLoading(false);
        });
    };
    return {
        opsgenieBaseUrl: opsgenieBaseUrl,
        openTransitionHomeModal: openTransitionHomeModal,
        closeTransitionHomeModal: closeTransitionHomeModal,
        activateTransitionHome: activateTransitionHome,
        isTransitionHomeLoading: isTransitionHomeLoading,
        isTransitionHomeActivated: isTransitionHomeActivated,
        isWelcomeModalActivated: isWelcomeModalActivated,
        isTransitionHomeModalOpen: isTransitionHomeModalOpen,
        finalWelcomeModalIsOpen: finalWelcomeModalIsOpen,
        handleCloseWelcomeModal: handleCloseWelcomeModal,
        activateWelcomeModal: activateWelcomeModal
    };
};

});
parcelRegister("7jF6i", function(module, exports) {

$parcel$export(module.exports, "useOpsgenieBaseUrl", () => $1469318d2c6fedc9$export$60d311c8b1ba6c11);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8r6sb = parcelRequire("8r6sb");
const $1469318d2c6fedc9$export$d4c72bab9d6cc13a = {
    opsgenieBaseUrl: undefined,
    fetchStatus: undefined,
    error: undefined
};
const $1469318d2c6fedc9$var$opsgenieBaseUrlStore = (0, $iXqE5.createStore)({
    name: 'opsgenieBaseUrl',
    initialState: $1469318d2c6fedc9$export$d4c72bab9d6cc13a,
    actions: (0, $8r6sb.actions)
});
const $1469318d2c6fedc9$export$7d5869fb9c3cabbd = (0, $3sQ5x.createHook)($1469318d2c6fedc9$var$opsgenieBaseUrlStore);
const $1469318d2c6fedc9$export$60d311c8b1ba6c11 = (packageName)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [state, { fetchOpsgenieBaseUrl: fetchOpsgenieBaseUrl }] = $1469318d2c6fedc9$export$7d5869fb9c3cabbd();
    const fetchOgBaseUrl = (0, $5uXOq.useCallback)(()=>fetchOpsgenieBaseUrl(createAnalyticsEvent({}), packageName), [
        createAnalyticsEvent,
        fetchOpsgenieBaseUrl,
        packageName
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (state.opsgenieBaseUrl === undefined && !state.fetchStatus) fetchOgBaseUrl();
    }, [
        fetchOgBaseUrl,
        state.opsgenieBaseUrl,
        state.fetchStatus
    ]);
    return [
        state,
        {
            fetchOgBaseUrl: fetchOgBaseUrl
        }
    ];
};

});
parcelRegister("8r6sb", function(module, exports) {

$parcel$export(module.exports, "actions", () => $018567380165a957$export$e324594224ef24da);

var $66VJT = parcelRequire("66VJT");
const $018567380165a957$export$e324594224ef24da = {
    fetchOpsgenieBaseUrl: $66VJT.fetchOpsgenieBaseUrl
};

});
parcelRegister("66VJT", function(module, exports) {

$parcel$export(module.exports, "fetchOpsgenieBaseUrl", () => $0533b309ea677099$export$14e903f188de435b);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");

var $gaED7 = parcelRequire("gaED7");
const $0533b309ea677099$export$14e903f188de435b = (analyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
packageName)=>async ({ getState: getState, setState: setState })=>{
        const { opsgenieBaseUrl: currentOpsgenieBaseUrl, fetchStatus: currentFetchStatus } = getState();
        if (currentOpsgenieBaseUrl !== undefined || // @ts-expect-error - TS2345 - Argument of type 'FetchStatus | undefined' is not assignable to parameter of type '"SUCCESS" | "IN_PROGRESS_FETCH_STATUS"'.
        [
            (0, $gaED7.FETCH_STATUS).inProgress,
            (0, $gaED7.FETCH_STATUS).success
        ].includes(currentFetchStatus)) return;
        setState({
            fetchStatus: (0, $gaED7.FETCH_STATUS).inProgress,
            error: undefined
        });
        try {
            const { baseUrl: baseUrl } = await (0, $7f4tk.default)('/rest/internal/2/opsgenie-base-url');
            analyticsEvent && (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'fetchOgBaseUrl succeeded');
            setState({
                fetchStatus: (0, $gaED7.FETCH_STATUS).success,
                opsgenieBaseUrl: baseUrl
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.trackFetchErrors)({
                error: error,
                id: 'fetchOgBaseUrl',
                packageName: packageName,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                fetchStatus: (0, $gaED7.FETCH_STATUS).error,
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("gaED7", function(module, exports) {

$parcel$export(module.exports, "FETCH_STATUS", () => $9abe9043030eba9b$export$7279934be2ca35bc);
const $9abe9043030eba9b$export$7279934be2ca35bc = {
    inProgress: 'IN_PROGRESS_FETCH_STATUS',
    error: 'ERROR_FETCH_STATUS',
    success: 'SUCCESS'
};

});




const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';

parcelRegister("4iQaI", function(module, exports) {

$parcel$export(module.exports, "ChatToolsContainer", () => $f52f0ab06dfbc1fd$export$a144a4b0356ed94f);
$parcel$export(module.exports, "useChatToolsActions", () => $f52f0ab06dfbc1fd$export$bc3c9253d84bc2bf);
$parcel$export(module.exports, "useChatToolsStore", () => $f52f0ab06dfbc1fd$export$a1388873c4cbfadc);
$parcel$export(module.exports, "useChatToolsConnections", () => $f52f0ab06dfbc1fd$export$74071b1e2400c285);
$parcel$export(module.exports, "useChatToolsIntegrations", () => $f52f0ab06dfbc1fd$export$a985a8cf780397ec);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $pa9q9 = parcelRequire("pa9q9");

var $9OXo1 = parcelRequire("9OXo1");

var $fjrC9 = parcelRequire("fjrC9");

var $ahEC6 = parcelRequire("ahEC6");

var $2H916 = parcelRequire("2H916");

var $8NNKd = parcelRequire("8NNKd");
const $f52f0ab06dfbc1fd$export$d4c72bab9d6cc13a = {
    connections: (0, $fjrC9.emptyResource),
    integrations: (0, $fjrC9.emptyResource),
    loadingConnectionId: '',
    loadingIntegrationId: '',
    mstConnectionUrls: {}
};
const $f52f0ab06dfbc1fd$var$Store = (0, $iXqE5.createStore)({
    initialState: $f52f0ab06dfbc1fd$export$d4c72bab9d6cc13a,
    actions: $8NNKd.actions,
    name: 'chat-tools'
});
const $f52f0ab06dfbc1fd$export$a144a4b0356ed94f = (0, $eW6Xc.createContainer)($f52f0ab06dfbc1fd$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
            return {
                cloudId: cloudId,
                showFlag: showFlag
            };
        },
        useContainerHook: ()=>{
            const { initialize: initialize } = $f52f0ab06dfbc1fd$export$bc3c9253d84bc2bf();
            const { slackConnectHandler: slackConnectHandler, slackUserLevelAuthoriseHandler: slackUserLevelAuthoriseHandler } = (0, $2H916.useSlackConnection)({
                onSuccess: initialize
            });
            const { mstConnectHandler: mstConnectHandler, adminAuthoriseHandler: adminAuthoriseHandler, mstUserLevelAuthoriseHandler: mstUserLevelAuthoriseHandler } = (0, $ahEC6.useMSTConnection)({
                onSuccess: initialize
            });
            const connectHandler = (0, $5uXOq.useCallback)((event)=>{
                if (!event.data || !event.data.event_id) return;
                if (event.data.event_id === (0, $fjrC9.SLACK_CREATE_CONNECTION_EVENT_ID)) slackConnectHandler(event);
                else if (event.data.event_id === (0, $fjrC9.MSTEAMS_CREATE_CONNECTION_EVENT_ID)) mstConnectHandler(event);
                else if (event.data.event_id === (0, $fjrC9.ADMIN_CONSENT_REQUIRED_EVENT_ID)) adminAuthoriseHandler(event);
                else if (event.data.event_id === (0, $fjrC9.MSTEAMS_USER_LEVEL_AUTH_EVENT_ID)) mstUserLevelAuthoriseHandler(event);
                else if (event.data.event_id === (0, $fjrC9.SLACK_USER_LEVEL_AUTH_EVENT_ID)) slackUserLevelAuthoriseHandler(event);
            }, [
                slackConnectHandler,
                mstConnectHandler,
                adminAuthoriseHandler,
                mstUserLevelAuthoriseHandler,
                slackUserLevelAuthoriseHandler
            ]);
            (0, $5uXOq.useEffect)(()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.addEventListener('message', connectHandler);
                return ()=>{
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.removeEventListener('message', connectHandler);
                };
            }, [
                connectHandler
            ]);
        }
    })
});
const $f52f0ab06dfbc1fd$export$a1388873c4cbfadc = (0, $3sQ5x.createHook)($f52f0ab06dfbc1fd$var$Store);
const $f52f0ab06dfbc1fd$export$bc3c9253d84bc2bf = (0, $3sQ5x.createActionsHook)($f52f0ab06dfbc1fd$var$Store);
const $f52f0ab06dfbc1fd$export$74071b1e2400c285 = (0, $3sQ5x.createHook)($f52f0ab06dfbc1fd$var$Store, {
    selector: (state)=>state.connections
});
const $f52f0ab06dfbc1fd$export$a985a8cf780397ec = (0, $3sQ5x.createHook)($f52f0ab06dfbc1fd$var$Store, {
    selector: (state)=>state.integrations
});

});
parcelRegister("eW6Xc", function(module, exports) {

$parcel$export(module.exports, "createDefaultEocWrapper", () => $479853350fd92f18$export$a9264953429b0df);
$parcel$export(module.exports, "createContainer", () => $479853350fd92f18$export$26ae5ca175b4ec5a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
/**
 * This component runs the useContainerHook with props that are sent from useSyncContainerProps.
 * We can use all features of react hooks inside here. Also, we created this component outside of
 * the createDefaultEocWrapper due to if we use this inside of the createDefaultEocWrapper,
 * it'll re-render on every child have changed.
 */ function $479853350fd92f18$var$InnerElement({ children: children, useContainerHook: useContainerHook, containerProps: containerProps }) {
    useContainerHook?.(containerProps);
    return children;
}
function $479853350fd92f18$export$a9264953429b0df({ useSyncContainerProps: useSyncContainerProps, useContainerHook: useContainerHook }) {
    return ({ children: children })=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(children)) {
            const containerProps = useSyncContainerProps ? useSyncContainerProps(children.props) : {};
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(children, {
                ...children.props,
                ...containerProps
            }, useContainerHook ? /*#__PURE__*/ (0, $2OMIu.jsx)($479853350fd92f18$var$InnerElement, {
                useContainerHook: useContainerHook,
                containerProps: containerProps,
                children: children.props.children
            }) : children.props.children);
        }
        return null;
    };
}
const $479853350fd92f18$export$26ae5ca175b4ec5a = (store, options)=>{
    const OriginalContainer = (0, $gg7kZ.createContainer)(store, {
        ...options
    });
    const HOC = ({ ...props })=>{
        return options?.Wrapper ? /*#__PURE__*/ (0, $2OMIu.jsx)(options.Wrapper, {
            ...props,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(OriginalContainer, {
                ...props,
                children: props.children
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(OriginalContainer, {
            ...props,
            children: props.children
        });
    };
    HOC.displayName = OriginalContainer.displayName + '-HOC'; // To track if error occure because of HOC
    return HOC;
};

});

parcelRegister("ahEC6", function(module, exports) {

$parcel$export(module.exports, "useMSTConnection", () => $403306d7bad73714$export$4c0b85f07dbab21c);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fjrC9 = parcelRequire("fjrC9");

var $7EYmk = parcelRequire("7EYmk");

var $jTm7v = parcelRequire("jTm7v");
const $403306d7bad73714$export$4c0b85f07dbab21c = ({ onSuccess: onSuccess })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const mstConnectHandler = (0, $5uXOq.useCallback)((event)=>{
        (0, $7EYmk.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $fjrC9.MSTEAMS_CREATE_CONNECTION_EVENT_ID),
            onSuccessCallback: onSuccess,
            onFailedCallback: (errorCode)=>{
                switch(errorCode){
                    case (0, $fjrC9.MstErrorCodes).TENANT_CONFLICT:
                        showFlag({
                            type: 'error',
                            title: (0, $jTm7v.default).tenantConflictErrorTitleNonFinal,
                            description: (0, $jTm7v.default).tenantConflictErrorDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-mst-connection.show-flag.error.tenant-conflict',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.MstErrorCodes).TENANT_MISMATCH:
                        showFlag({
                            type: 'error',
                            title: (0, $jTm7v.default).tenantMissmatchErrorTitleNonFinal,
                            description: (0, $jTm7v.default).tenantMissmatchErrorDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-mst-connection.show-flag.error.tenant-mismatch',
                            messageType: 'transactional'
                        });
                        break;
                    default:
                        showFlag({
                            type: 'error',
                            title: (0, $jTm7v.default).teamsLoginErrorTitleNonFinal,
                            description: (0, $jTm7v.default).teamsLoginErrorTitleNonFinal,
                            actions: [
                                {
                                    content: (0, $jTm7v.default).contactSupportBtnLabelNonFinal,
                                    href: (0, $fjrC9.JIRA_SUPPORT_LINK),
                                    target: '_blank'
                                }
                            ],
                            messageId: 'eoc-changeboarding.services.use-mst-connection.show-flag.error.default',
                            messageType: 'transactional'
                        });
                }
            }
        });
    }, [
        onSuccess,
        showFlag
    ]);
    const adminAuthoriseHandler = (0, $5uXOq.useCallback)((event)=>{
        (0, $7EYmk.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $fjrC9.ADMIN_CONSENT_REQUIRED_EVENT_ID),
            onSuccessCallback: ()=>{
                onSuccess();
            },
            onFailedCallback: ()=>{
                showFlag({
                    messageId: 'eoc-changeboarding.services.use-mst-connection.show-flag.error.teams-login-error',
                    messageType: 'transactional',
                    type: 'error',
                    title: (0, $jTm7v.default).teamsLoginErrorTitleNonFinal,
                    description: (0, $jTm7v.default).teamsLoginErrorTitleNonFinal,
                    actions: [
                        {
                            content: (0, $jTm7v.default).contactSupportBtnLabelNonFinal,
                            href: (0, $fjrC9.JIRA_SUPPORT_LINK),
                            target: '_blank'
                        }
                    ]
                });
            }
        });
    }, [
        onSuccess,
        showFlag
    ]);
    const mstUserLevelAuthoriseHandler = (0, $5uXOq.useCallback)((event)=>{
        (0, $7EYmk.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $fjrC9.MSTEAMS_USER_LEVEL_AUTH_EVENT_ID),
            onSuccessCallback: ()=>{
                onSuccess();
            }
        });
    }, [
        onSuccess
    ]);
    return {
        mstConnectHandler: mstConnectHandler,
        adminAuthoriseHandler: adminAuthoriseHandler,
        mstUserLevelAuthoriseHandler: mstUserLevelAuthoriseHandler
    };
};

});
parcelRegister("7EYmk", function(module, exports) {

$parcel$export(module.exports, "chatOpsMessageHandler", () => $1e77709525354a34$export$6e5d249d884395f6);
const $1e77709525354a34$export$9fb6e800e02bf3ea = [
    'https://api-private.stg.atlassian.com',
    'https://api-private.atlassian.com'
];
const $1e77709525354a34$export$6e5d249d884395f6 = ({ event: event, onSuccessCallback: onSuccessCallback, onFailedCallback: onFailedCallback, requiredEventId: requiredEventId })=>{
    if (!$1e77709525354a34$export$9fb6e800e02bf3ea.includes(event.origin)) return;
    if (!event.data || !event.data.event_id || !event.data.data || event.data.event_id !== requiredEventId) return;
    const eventData = event.data;
    if (eventData?.data?.success === 'true') onSuccessCallback();
    else if (eventData?.data?.success === 'false') onFailedCallback?.(eventData.data.error);
};

});

parcelRegister("jTm7v", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9f7b988340afc65$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b9f7b988340afc65$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tenantConflictErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.tenant-conflict-error-title-non-final",
        "defaultMessage": "Couldn't connect your Microsoft tenant"
    },
    tenantConflictErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.tenant-conflict-error-description-non-final",
        "defaultMessage": "Your Microsoft tenant is connected to a different Jira Service Management site. Disconnect your tenant from the other site or connect a different Microsoft tenant to this Jira Service Management site."
    },
    teamsLoginErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.teams-login-error-title-non-final",
        "defaultMessage": "Couldn't sign in to your Microsoft account"
    },
    teamsLoginErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.teams-login-error-description-non-final",
        "defaultMessage": "Please try again or contact support for help."
    },
    contactSupportBtnLabelNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.contact-support-btn-label-non-final",
        "defaultMessage": "Contact support"
    },
    tenantMissmatchErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.tenant-missmatch-error-title-non-final",
        "defaultMessage": "You aren't a member of the Microsoft tenant"
    },
    tenantMissmatchErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-mst-connection.tenant-missmatch-error-description-non-final",
        "defaultMessage": "Looks like you aren't part of the Microsoft tenant you're trying to connect with Jira. Join the Microsoft tenant and try again."
    }
});

});


parcelRegister("2H916", function(module, exports) {

$parcel$export(module.exports, "useSlackConnection", () => $5e90d657d68ef7cf$export$3912d4b50c1e1942);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fjrC9 = parcelRequire("fjrC9");

var $7EYmk = parcelRequire("7EYmk");

var $hzun8 = parcelRequire("hzun8");
const $5e90d657d68ef7cf$export$3912d4b50c1e1942 = ({ onSuccess: onSuccess })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const slackConnectHandler = (0, $5uXOq.useCallback)((event)=>(0, $7EYmk.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $fjrC9.SLACK_CREATE_CONNECTION_EVENT_ID),
            onSuccessCallback: onSuccess,
            onFailedCallback: (errorCode)=>{
                switch(errorCode){
                    case (0, $fjrC9.SlackErrorCodes).AUTH_CODE_MISSING:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackNotConnectedTitleNonFinal,
                            description: (0, $hzun8.default).slackAuthoriseErrorDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.auth-code-missing',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).CONNECTION_ALREADY_EXIST:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackNotConnectedTitleNonFinal,
                            description: (0, $hzun8.default).connectionAlreadyExistsDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.connection-already-exist',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).CONNECTION_CREATION_FAILED:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackNotConnectedTitleNonFinal,
                            description: (0, $hzun8.default).connectionFailedDescriptionNonFinal,
                            actions: [
                                {
                                    content: (0, $hzun8.default).slackSupportBtnLabelNonFinal,
                                    href: (0, $fjrC9.JIRA_SUPPORT_LINK),
                                    target: '_blank'
                                }
                            ],
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.connection-creation-failed',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).FETCH_TOKEN_FAILED:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackNotConnectedTitleNonFinal,
                            description: (0, $hzun8.default).slackAuthoriseErrorDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.fetch-token-failed',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).FORBIDDEN_TENANT:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).somethingWentWrongTitleNonFinal,
                            description: (0, $hzun8.default).slackContactSupportDescriptionNonFinal,
                            actions: [
                                {
                                    content: (0, $hzun8.default).slackSupportBtnLabelNonFinal,
                                    href: (0, $fjrC9.JIRA_SUPPORT_LINK),
                                    target: '_blank'
                                }
                            ],
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.forbidden-tenant',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).INVALID_STATE:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackNotConnectedTitleNonFinal,
                            description: (0, $hzun8.default).slackConnectAgainDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.invalid-state',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).LINK_EXPIRED:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackSessionExpiredTitleNonFinal,
                            description: (0, $hzun8.default).slackConnectAgainDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.link-expired',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).STATE_DECRYPTION_FAILED:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackNotConnectedTitleNonFinal,
                            description: (0, $hzun8.default).slackConnectAgainDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.state-decryption-failed',
                            messageType: 'transactional'
                        });
                        break;
                    case (0, $fjrC9.SlackErrorCodes).WORKSPACE_MISSMATCH:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).slackWorkspaceMismatchTitleNonFinal,
                            description: (0, $hzun8.default).slackWorkSpaceMissmatchDescriptionNonFinal,
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.workspace-missmatch',
                            messageType: 'transactional'
                        });
                        break;
                    default:
                        showFlag({
                            type: 'error',
                            title: (0, $hzun8.default).somethingWentWrongTitleNonFinal,
                            description: (0, $hzun8.default).slackContactSupportDescriptionNonFinal,
                            actions: [
                                {
                                    content: (0, $hzun8.default).slackSupportBtnLabelNonFinal,
                                    href: (0, $fjrC9.JIRA_SUPPORT_LINK),
                                    target: '_blank'
                                }
                            ],
                            messageId: 'eoc-changeboarding.services.use-slack-connection.show-flag.error.default',
                            messageType: 'transactional'
                        });
                        break;
                }
            }
        }), [
        onSuccess,
        showFlag
    ]);
    const slackUserLevelAuthoriseHandler = (0, $5uXOq.useCallback)((event)=>{
        (0, $7EYmk.chatOpsMessageHandler)({
            event: event,
            requiredEventId: (0, $fjrC9.SLACK_USER_LEVEL_AUTH_EVENT_ID),
            onSuccessCallback: ()=>{
                onSuccess();
            }
        });
    }, [
        onSuccess
    ]);
    return {
        slackConnectHandler: slackConnectHandler,
        slackUserLevelAuthoriseHandler: slackUserLevelAuthoriseHandler
    };
};

});
parcelRegister("hzun8", function(module, exports) {

$parcel$export(module.exports, "default", () => $549a18cabad62593$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $549a18cabad62593$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    getSlackConfigurationErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.get-slack-configuration-error-title-non-final",
        "defaultMessage": "We couldn't connect the workspace"
    },
    getSlackConfigurationErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.get-slack-configuration-error-description-non-final",
        "defaultMessage": "Wait a moment or refresh the page before trying again."
    },
    slackNotConnectedTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-not-connected-title-non-final",
        "defaultMessage": "Couldn't connect your Slack workspace"
    },
    slackAuthoriseErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-authorise-error-description-non-final",
        "defaultMessage": "Your Slack workspace couldn't be authenticated. Please try again."
    },
    connectionAlreadyExistsDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.connection-already-exists-description-non-final",
        "defaultMessage": "Your Slack workspace is already connected to a different Jira Service Management site. Disconnect your workspace from the other site and try again."
    },
    connectionFailedDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.connection-failed-description-non-final",
        "defaultMessage": "Something went wrong. Please try connecting again or contact support for help."
    },
    slackSupportBtnLabelNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-support-btn-label-non-final",
        "defaultMessage": "Contact support"
    },
    somethingWentWrongTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.something-went-wrong-title-non-final",
        "defaultMessage": "Something went wrong"
    },
    slackContactSupportDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-contact-support-description-non-final",
        "defaultMessage": "Please try again or contact support for help."
    },
    slackConnectAgainDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-connect-again-description-non-final",
        "defaultMessage": "Please try connecting your workspace again."
    },
    slackSessionExpiredTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-session-expired-title-non-final",
        "defaultMessage": "Slack session expired"
    },
    slackWorkspaceMismatchTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-workspace-mismatch-title-non-final",
        "defaultMessage": "You aren't a member of the Slack workspace"
    },
    slackWorkSpaceMissmatchDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-slack-connection.slack-work-space-missmatch-description-non-final",
        "defaultMessage": "Looks like you aren't part of the Slack workspace you're trying to connect with Jira. Join the Slack workspace and try again."
    }
});

});


parcelRegister("8NNKd", function(module, exports) {

$parcel$export(module.exports, "actions", () => $dcbe28dff0425066$export$e324594224ef24da);

var $4R6GH = parcelRequire("4R6GH");

var $fjrC9 = parcelRequire("fjrC9");

var $1GqJn = parcelRequire("1GqJn");

var $iA7nF = parcelRequire("iA7nF");

var $jdPtr = parcelRequire("jdPtr");

var $eCYZp = parcelRequire("eCYZp");
const $dcbe28dff0425066$var$getChatToolsConnections = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            connections: {
                data: state.connections.data,
                error: null,
                loading: true
            }
        });
        return $jdPtr.getConnections(cloudId).then((res)=>setState({
                connections: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            // TODO we might display toast
            setState({
                connections: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $dcbe28dff0425066$var$authorizeSlackConnection = (chatSpaceId)=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            loadingConnectionId: chatSpaceId
        });
        $jdPtr.getAuthorizeSlackConnectionUrl({
            chatSpaceId: chatSpaceId,
            cloudId: cloudId
        }).then((res)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(res.data.url, '_blank');
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingConnectionId: ''
            });
        });
    };
const $dcbe28dff0425066$var$delegateMSTConnection = (chatSpaceId)=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            loadingConnectionId: chatSpaceId
        });
        $jdPtr.getDelegateMSTConnectionUrl({
            chatSpaceId: chatSpaceId,
            cloudId: cloudId
        }).then((res)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(res.data.url, '_blank');
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingConnectionId: ''
            });
        });
    };
const $dcbe28dff0425066$var$getAuthorizeMSTConnectionUrl = (chatSpaceId)=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        if (state.mstConnectionUrls[chatSpaceId]) return Promise.resolve(state.mstConnectionUrls[chatSpaceId]);
        setState({
            loadingConnectionId: chatSpaceId
        });
        return $jdPtr.getaAuthorizeMSTConnectionUrl({
            chatSpaceId: chatSpaceId,
            cloudId: cloudId
        }).then((res)=>{
            state.mstConnectionUrls[chatSpaceId] = res.data.url;
            return res.data.url;
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingConnectionId: ''
            });
        });
    };
const $dcbe28dff0425066$var$authorizeMSTConnection = (chatSpaceId)=>({ dispatch: dispatch })=>{
        dispatch($dcbe28dff0425066$var$getAuthorizeMSTConnectionUrl(chatSpaceId)).then((url)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        });
    };
const $dcbe28dff0425066$var$copyMSTAuthorizationLink = (chatSpaceId)=>({ dispatch: dispatch }, { showFlag: showFlag })=>{
        dispatch($dcbe28dff0425066$var$getAuthorizeMSTConnectionUrl(chatSpaceId)).then((url)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            ((0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? globalThis.navigator.clipboard : navigator.clipboard).writeText(url || '').then(()=>{
                showFlag?.({
                    messageId: 'eoc-changeboarding.services.store.chat-tools.actions.show-flag.success.copied-success',
                    messageType: 'transactional',
                    type: 'success',
                    title: (0, $eCYZp.default).copiedConfirmationTitleNonFinal,
                    description: (0, $eCYZp.default).copiedSuccessNonFinal
                });
            }).catch(()=>{
                showFlag?.({
                    messageId: 'eoc-changeboarding.services.store.chat-tools.actions.show-flag.error.copied-failed',
                    messageType: 'transactional',
                    type: 'error',
                    title: (0, $eCYZp.default).copiedConfirmationTitleNonFinal,
                    description: (0, $eCYZp.default).copiedFailedNonFinal
                });
            });
        });
    };
const $dcbe28dff0425066$var$getIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            integrations: {
                data: state.integrations.data,
                error: null,
                loading: true
            }
        });
        return $jdPtr.getOgIntegrations(cloudId).then((res)=>setState({
                integrations: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            // TODO we might display toast
            setState({
                integrations: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $dcbe28dff0425066$var$givePermissionToUser = (integration)=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            loadingIntegrationId: integration.id
        });
        $jdPtr.getUserAuthorizationUrl({
            cloudId: cloudId,
            chatSpaceType: integration.chatSpaceType,
            chatSpaceId: integration.chatSpaceId
        }).then((res)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(res.data.url, '_blank');
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingIntegrationId: ''
            });
        });
    };
const $dcbe28dff0425066$var$duplicateIntegration = (integration)=>({ setState: setState, dispatch: dispatch }, { cloudId: cloudId, showFlag: showFlag })=>{
        setState({
            loadingIntegrationId: integration.id
        });
        $jdPtr.duplicateIntegration({
            cloudId: cloudId,
            id: integration.id,
            channelId: integration.channelId,
            connectionId: integration.connectionId,
            msTeamsId: integration.msTeamsId
        }).then(()=>{
            dispatch($dcbe28dff0425066$var$getIntegrations());
        }).catch((error)=>{
            if (error.statusCode === 403) {
                showFlag?.({
                    messageId: 'eoc-changeboarding.services.store.chat-tools.actions.show-flag.error.duplicate-not-part-of-channel',
                    messageType: 'transactional',
                    type: 'error',
                    title: (0, $eCYZp.default).duplicateNotPartOfChannelTitleNonFinal,
                    description: (0, $eCYZp.default).duplicateNotPartOfChannelDescriptionNonFinal
                });
                return;
            }
            showFlag?.({
                messageId: 'eoc-changeboarding.services.store.chat-tools.actions.show-flag.error.duplicate-generic-error',
                messageType: 'transactional',
                type: 'error',
                title: (0, $eCYZp.default).duplicateGenericErrorTitleNonFinal,
                description: (0, $eCYZp.default).duplicateGenericErrorDescriptionNonFinal,
                actions: [
                    {
                        content: (0, $eCYZp.default).contactSupportBtnLabelNonFinal,
                        href: (0, $fjrC9.JIRA_SUPPORT_LINK),
                        target: '_blank'
                    }
                ]
            });
        })// TODO we might display toast
        .finally(()=>{
            setState({
                loadingIntegrationId: ''
            });
        });
    };
const $dcbe28dff0425066$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($dcbe28dff0425066$var$getChatToolsConnections()),
            dispatch($dcbe28dff0425066$var$getIntegrations())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $dcbe28dff0425066$var$initializeForTeamAdmin = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($dcbe28dff0425066$var$getIntegrations())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $dcbe28dff0425066$export$e324594224ef24da = {
    getChatToolsConnections: $dcbe28dff0425066$var$getChatToolsConnections,
    authorizeSlackConnection: $dcbe28dff0425066$var$authorizeSlackConnection,
    delegateMSTConnection: $dcbe28dff0425066$var$delegateMSTConnection,
    authorizeMSTConnection: $dcbe28dff0425066$var$authorizeMSTConnection,
    copyMSTAuthorizationLink: $dcbe28dff0425066$var$copyMSTAuthorizationLink,
    getIntegrations: $dcbe28dff0425066$var$getIntegrations,
    givePermissionToUser: $dcbe28dff0425066$var$givePermissionToUser,
    duplicateIntegration: $dcbe28dff0425066$var$duplicateIntegration,
    initialize: $dcbe28dff0425066$var$initialize,
    initializeForTeamAdmin: $dcbe28dff0425066$var$initializeForTeamAdmin
};

});
parcelRegister("1GqJn", function(module, exports) {

$parcel$export(module.exports, "createErrorResponse", () => $513a18ba2d1aff95$export$d27409b579447857);
$parcel$export(module.exports, "createDataResponse", () => $513a18ba2d1aff95$export$65a48814b87e4478);
const $513a18ba2d1aff95$export$d27409b579447857 = (error)=>({
        data: null,
        error: error,
        loading: false
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $513a18ba2d1aff95$export$65a48814b87e4478 = (data)=>({
        data: data,
        error: null,
        loading: false
    });

});

parcelRegister("iA7nF", function(module, exports) {

$parcel$export(module.exports, "multiplePromiseSettler", () => $585fda433702dced$export$be72b6e68f6d7c8f);
const $585fda433702dced$export$be72b6e68f6d7c8f = (results)=>{
    if (results.length > 0) {
        const error = results.find((result)=>result.status === 'rejected');
        if (error) throw 'reason' in error ? error.reason : new Error('Unknown error occurred during fetch resource');
        return results;
    }
    return results;
};

});

parcelRegister("jdPtr", function(module, exports) {

$parcel$export(module.exports, "getConnections", () => $4fe7c11842caba6c$export$82b9f8f75cc709b4);
$parcel$export(module.exports, "getAuthorizeSlackConnectionUrl", () => $4fe7c11842caba6c$export$2a70ab934b694f17);
$parcel$export(module.exports, "getOgIntegrations", () => $4fe7c11842caba6c$export$f2efa3535e8bb631);
$parcel$export(module.exports, "getDelegateMSTConnectionUrl", () => $4fe7c11842caba6c$export$58c33fd2c801ef0b);
$parcel$export(module.exports, "getaAuthorizeMSTConnectionUrl", () => $4fe7c11842caba6c$export$d44eb3398b5db37);
$parcel$export(module.exports, "getUserAuthorizationUrl", () => $4fe7c11842caba6c$export$4df1f26230bcb7c);
$parcel$export(module.exports, "duplicateIntegration", () => $4fe7c11842caba6c$export$67ff1e867c2131aa);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $fjrC9 = parcelRequire("fjrC9");
const $4fe7c11842caba6c$export$82b9f8f75cc709b4 = (cloudId)=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/connections`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getConnectionsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4fe7c11842caba6c$export$2a70ab934b694f17 = ({ chatSpaceId: chatSpaceId, cloudId: cloudId })=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/slack/connection/create?chatSpaceId=${chatSpaceId}&appType=jsm-it-service-desk&container=transition`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'authorizeSlackConnection',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4fe7c11842caba6c$export$f2efa3535e8bb631 = (cloudId)=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/integrations`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getOgIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4fe7c11842caba6c$export$58c33fd2c801ef0b = ({ chatSpaceId: chatSpaceId, cloudId: cloudId })=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/msteams/delegated?chatSpaceId=${chatSpaceId}&appType=jsm-msteams-app&container=transition&createConnection=true`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'delegateMSTConnection',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4fe7c11842caba6c$export$d44eb3398b5db37 = ({ chatSpaceId: chatSpaceId, cloudId: cloudId })=>{
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/msteams/admin?chatSpaceId=${chatSpaceId}&appType=jsm-msteams-app&container=transition`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'authorizeMSTConnection',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4fe7c11842caba6c$export$4df1f26230bcb7c = ({ cloudId: cloudId, chatSpaceType: chatSpaceType, chatSpaceId: chatSpaceId })=>{
    const appType = chatSpaceType === 'slack' ? (0, $fjrC9.SLACK_APP_TYPE) : (0, $fjrC9.MST_APP_TYPE);
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorise/user?chatSpaceId=${chatSpaceId}&appType=${appType}&source=transition`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getUserAuthorizationUrl',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4fe7c11842caba6c$export$67ff1e867c2131aa = (body)=>{
    const { cloudId: cloudId, id: id, ...restOfBody } = body;
    const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/integration/duplicate/${id}`;
    return (0, $eusud.performPostRequest)(url, {
        body: JSON.stringify(restOfBody)
    }).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'duplicateIntegration',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});

parcelRegister("eCYZp", function(module, exports) {

$parcel$export(module.exports, "default", () => $163319dc0b12cde7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $163319dc0b12cde7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copiedConfirmationTitleNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.copied-confirmation-title-non-final",
        "defaultMessage": "Copied link"
    },
    copiedSuccessNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.copied-success-non-final",
        "defaultMessage": "Share it with your Teams Administrator to ask for their authorization to give permission."
    },
    copiedFailedNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.copied-failed-non-final",
        "defaultMessage": "Something went wrong, please try again? If you need help, contact support."
    },
    duplicateNotPartOfChannelTitleNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-not-part-of-channel-title-non-final",
        "defaultMessage": "You aren't a member of the connected channel"
    },
    duplicateNotPartOfChannelDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-not-part-of-channel-description-non-final",
        "defaultMessage": "This integration is connected to a chat channel or conversation that you aren't a member of. Join the channel and try again."
    },
    duplicateGenericErrorTitleNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-generic-error-title-non-final",
        "defaultMessage": "Couldn't copy your integration"
    },
    duplicateGenericErrorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.duplicate-generic-error-description-non-final",
        "defaultMessage": "Something went wrong while copying your integration to Jira. Try again in some time. If you still need help, contact support."
    },
    contactSupportBtnLabelNonFinal: {
        "id": "eoc-changeboarding.services.store.chat-tools.actions.contact-support-btn-label-non-final",
        "defaultMessage": "Contact support"
    }
});

});



parcelRegister("lLiTq", function(module, exports) {

$parcel$export(module.exports, "DeprecatedCountsContainer", () => $f93024f97192e9da$export$46cb9574b46bee08);
$parcel$export(module.exports, "useDeprecatedCountsStore", () => $f93024f97192e9da$export$7ccc6df7e431e9d5);
$parcel$export(module.exports, "useDeprecatedGroups", () => $f93024f97192e9da$export$a683813e834f13f1);
$parcel$export(module.exports, "useDeprecatedNotificationPolicies", () => $f93024f97192e9da$export$6dd4db40d5822337);
$parcel$export(module.exports, "useDeprecatedHeartbeats", () => $f93024f97192e9da$export$48cc63620d55f335);

var $eW6Xc = parcelRequire("eW6Xc");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $pa9q9 = parcelRequire("pa9q9");

var $9OXo1 = parcelRequire("9OXo1");

var $fjrC9 = parcelRequire("fjrC9");

var $f2DMU = parcelRequire("f2DMU");
const $f93024f97192e9da$export$d4c72bab9d6cc13a = {
    groups: (0, $fjrC9.emptyResource),
    notificationPolicies: (0, $fjrC9.emptyResource),
    heartbeats: (0, $fjrC9.emptyResource)
};
const $f93024f97192e9da$var$Store = (0, $iXqE5.createStore)({
    initialState: $f93024f97192e9da$export$d4c72bab9d6cc13a,
    actions: $f2DMU.actions,
    name: 'deprecated-counts'
});
const $f93024f97192e9da$export$46cb9574b46bee08 = (0, $eW6Xc.createContainer)($f93024f97192e9da$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
            return {
                cloudId: cloudId,
                showFlag: showFlag
            };
        }
    })
});
const $f93024f97192e9da$export$7ccc6df7e431e9d5 = (0, $3sQ5x.createHook)($f93024f97192e9da$var$Store);
const $f93024f97192e9da$export$a683813e834f13f1 = (0, $3sQ5x.createHook)($f93024f97192e9da$var$Store, {
    selector: (state)=>({
            groups: state.groups,
            hasDeprecatedGroups: (state.groups.data?.count || 0) > 0
        })
});
const $f93024f97192e9da$export$6dd4db40d5822337 = (0, $3sQ5x.createHook)($f93024f97192e9da$var$Store, {
    selector: (state)=>({
            notificationPolicies: state.notificationPolicies,
            hasDeprecatedNotificationPolicies: (state.notificationPolicies.data?.count || 0) > 0
        })
});
const $f93024f97192e9da$export$48cc63620d55f335 = (0, $3sQ5x.createHook)($f93024f97192e9da$var$Store, {
    selector: (state)=>({
            heartbeats: state.heartbeats,
            hasDeprecatedGlobalHeartbeats: (state.heartbeats.data?.globalHeartbeatCount || 0) > 0,
            hasDeprecatedTotalHeartbeats: (state.heartbeats.data?.totalHeartbeatCount || 0) > 0,
            isExceedHeartbeatLimit: (state.heartbeats.data?.totalHeartbeatCount || 0) > 2000
        })
});

});
parcelRegister("f2DMU", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e67700634072e137$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1GqJn = parcelRequire("1GqJn");

var $iA7nF = parcelRequire("iA7nF");

var $jMK2J = parcelRequire("jMK2J");
const $e67700634072e137$var$getDeprecatedGroupsCount = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            groups: {
                data: state.groups.data,
                error: null,
                loading: true
            }
        });
        return $jMK2J.getDeprecatedGroupsCount(cloudId).then((res)=>setState({
                groups: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                groups: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $e67700634072e137$var$getDeprecatedHeartbeatsCount = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            heartbeats: {
                data: state.heartbeats.data,
                error: null,
                loading: true
            }
        });
        return $jMK2J.getDeprecatedHeartbeatsCount(cloudId).then((res)=>setState({
                heartbeats: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                heartbeats: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $e67700634072e137$var$getDeprecatedNotificationPoliciesCount = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            notificationPolicies: {
                data: state.notificationPolicies.data,
                error: null,
                loading: true
            }
        });
        return $jMK2J.getDeprecatedNotificationPoliciesCount(cloudId).then((res)=>setState({
                notificationPolicies: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                notificationPolicies: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $e67700634072e137$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($e67700634072e137$var$getDeprecatedGroupsCount()),
            dispatch($e67700634072e137$var$getDeprecatedHeartbeatsCount()),
            dispatch($e67700634072e137$var$getDeprecatedNotificationPoliciesCount())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $e67700634072e137$export$e324594224ef24da = {
    getDeprecatedGroupsCount: $e67700634072e137$var$getDeprecatedGroupsCount,
    getDeprecatedHeartbeatsCount: $e67700634072e137$var$getDeprecatedHeartbeatsCount,
    getDeprecatedNotificationPoliciesCount: $e67700634072e137$var$getDeprecatedNotificationPoliciesCount,
    initialize: $e67700634072e137$var$initialize
};

});
parcelRegister("jMK2J", function(module, exports) {

$parcel$export(module.exports, "getDeprecatedGroupsCount", () => $dd71ffe8646c0283$export$67b822a517f03dfe);
$parcel$export(module.exports, "getDeprecatedNotificationPoliciesCount", () => $dd71ffe8646c0283$export$55e3f0e3955ec140);
$parcel$export(module.exports, "getDeprecatedHeartbeatsCount", () => $dd71ffe8646c0283$export$241c0dafce985f59);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $dd71ffe8646c0283$export$67b822a517f03dfe = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/changeboarding/groups`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getDeprecatedGroupsCountEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $dd71ffe8646c0283$export$55e3f0e3955ec140 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/changeboarding/policies`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getDeprecatedNotificationPoliciesCountEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $dd71ffe8646c0283$export$241c0dafce985f59 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/heartbeats/changeboarding`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getDeprecatedHeartbeatsCountEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("luBum", function(module, exports) {

$parcel$export(module.exports, "IncidentsContainer", () => $afaad1410f35f665$export$f504e9eea1c23a86);
$parcel$export(module.exports, "useIncidentsStore", () => $afaad1410f35f665$export$7dfe7cf41f5c2f79);
$parcel$export(module.exports, "useIncidents", () => $afaad1410f35f665$export$23e9cad190e56aee);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $9OXo1 = parcelRequire("9OXo1");

var $fjrC9 = parcelRequire("fjrC9");

var $5axFq = parcelRequire("5axFq");
const $afaad1410f35f665$export$d4c72bab9d6cc13a = {
    incidentsCopyStatus: (0, $fjrC9.emptyResource)
};
const $afaad1410f35f665$var$Store = (0, $iXqE5.createStore)({
    initialState: $afaad1410f35f665$export$d4c72bab9d6cc13a,
    actions: $5axFq.actions,
    name: 'incidents'
});
const $afaad1410f35f665$export$f504e9eea1c23a86 = (0, $eW6Xc.createContainer)($afaad1410f35f665$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            return {
                cloudId: cloudId
            };
        }
    })
});
const $afaad1410f35f665$export$7dfe7cf41f5c2f79 = (0, $3sQ5x.createHook)($afaad1410f35f665$var$Store);
const $afaad1410f35f665$export$43131cb4b87347a9 = (0, $3sQ5x.createActionsHook)($afaad1410f35f665$var$Store);
const $afaad1410f35f665$export$23e9cad190e56aee = (0, $3sQ5x.createHook)($afaad1410f35f665$var$Store, {
    selector: (state)=>{
        const { incidentsCopyStatus: incidentsCopyStatus } = state;
        const projectKey = incidentsCopyStatus.data?.payload?.projectKey;
        const status = incidentsCopyStatus.data?.status;
        const errorLength = incidentsCopyStatus.data?.error?.length ?? 0;
        const hasCopyOperationError = errorLength > 0 || status === 'ERROR';
        const isCopied = status === 'SUCCESS' && !!projectKey && errorLength === 0;
        const isCopying = status === 'IN_PROGRESS';
        const canMigrateAgain = incidentsCopyStatus.data?.canMigrateAgain;
        const isEligibleForCopy = (status === 'SUCCESS' || hasCopyOperationError) && canMigrateAgain || status === 'NOT_STARTED';
        const shouldDisplaySuccessBanner = isCopied && canMigrateAgain === false;
        return {
            projectKey: projectKey,
            hasCopyOperationError: hasCopyOperationError,
            isCopied: isCopied,
            isCopying: isCopying,
            isEligibleForCopy: isEligibleForCopy,
            shouldDisplaySuccessBanner: shouldDisplaySuccessBanner
        };
    }
});

});
parcelRegister("5axFq", function(module, exports) {

$parcel$export(module.exports, "actions", () => $365580d5c0599be0$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1GqJn = parcelRequire("1GqJn");

var $iA7nF = parcelRequire("iA7nF");

var $ls6ny = parcelRequire("ls6ny");
const $365580d5c0599be0$var$getIncidentsCopyStatus = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            incidentsCopyStatus: {
                ...state.incidentsCopyStatus,
                loading: true
            }
        });
        return $ls6ny.getIncidentsCopyStatus(cloudId).then((res)=>setState({
                incidentsCopyStatus: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                incidentsCopyStatus: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
// Get status after copy is started and update the state
const $365580d5c0599be0$var$copyIncidents = ()=>({ dispatch: dispatch }, { cloudId: cloudId })=>$ls6ny.copyIncidents(cloudId).then(()=>dispatch($365580d5c0599be0$var$getIncidentsCopyStatus()));
const $365580d5c0599be0$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($365580d5c0599be0$var$getIncidentsCopyStatus())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $365580d5c0599be0$export$e324594224ef24da = {
    getIncidentsCopyStatus: $365580d5c0599be0$var$getIncidentsCopyStatus,
    copyIncidents: $365580d5c0599be0$var$copyIncidents,
    initialize: $365580d5c0599be0$var$initialize
};

});
parcelRegister("ls6ny", function(module, exports) {

$parcel$export(module.exports, "getIncidentsCopyStatus", () => $1aa4ab063840354a$export$c027992a439e850d);
$parcel$export(module.exports, "copyIncidents", () => $1aa4ab063840354a$export$583821603355a6e2);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $1aa4ab063840354a$export$c027992a439e850d = (cloudId)=>{
    const url = `/gateway/api/jsd/escalator/${cloudId}/api/im-tooling/status`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getIncidentCopyStatusEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $1aa4ab063840354a$export$583821603355a6e2 = (cloudId)=>{
    const url = `/gateway/api/jsd/escalator/${cloudId}/api/im-tooling/start`;
    return (0, $eusud.performPostRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'copyIncidentsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("5fIfP", function(module, exports) {

$parcel$export(module.exports, "IntegrationsContainer", () => $422ec97ec7702e9c$export$a82408dc976aed12);
$parcel$export(module.exports, "useIntegrationsStore", () => $422ec97ec7702e9c$export$20dfa6771a354e6b);
$parcel$export(module.exports, "useIntegrationCounts", () => $422ec97ec7702e9c$export$d42a7d921bccf5ad);
$parcel$export(module.exports, "useSyncedIntegrations", () => $422ec97ec7702e9c$export$f79da416c7d67657);
$parcel$export(module.exports, "useDiscontinuedIntegrations", () => $422ec97ec7702e9c$export$7145e9baa0c24277);
$parcel$export(module.exports, "useDeprecatedIntegrations", () => $422ec97ec7702e9c$export$1525890f71cafb3f);
$parcel$export(module.exports, "useIncomingCallIntegrations", () => $422ec97ec7702e9c$export$f3c44b9fdca261f2);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $pa9q9 = parcelRequire("pa9q9");

var $9OXo1 = parcelRequire("9OXo1");

var $fjrC9 = parcelRequire("fjrC9");

var $a1OoE = parcelRequire("a1OoE");
const $422ec97ec7702e9c$export$d4c72bab9d6cc13a = {
    counts: (0, $fjrC9.emptyResource),
    syncedIntegrations: (0, $fjrC9.emptyResource),
    discontinuedIntegrations: (0, $fjrC9.emptyResource),
    deprecatedIntegrations: (0, $fjrC9.emptyResource),
    incomingCallIntegrations: (0, $fjrC9.emptyResource)
};
const $422ec97ec7702e9c$var$Store = (0, $iXqE5.createStore)({
    initialState: $422ec97ec7702e9c$export$d4c72bab9d6cc13a,
    actions: $a1OoE.actions,
    name: 'integrations'
});
const $422ec97ec7702e9c$export$a82408dc976aed12 = (0, $eW6Xc.createContainer)($422ec97ec7702e9c$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
            return {
                cloudId: cloudId,
                showFlag: showFlag
            };
        }
    })
});
const $422ec97ec7702e9c$export$20dfa6771a354e6b = (0, $3sQ5x.createHook)($422ec97ec7702e9c$var$Store);
const $422ec97ec7702e9c$export$eb083cb7fb078478 = (0, $3sQ5x.createActionsHook)($422ec97ec7702e9c$var$Store);
const $422ec97ec7702e9c$export$d42a7d921bccf5ad = (0, $3sQ5x.createHook)($422ec97ec7702e9c$var$Store, {
    selector: (state)=>({
            counts: state.counts,
            hasIntegrations: (state.counts.data?.totalCount || 0) > 0
        })
});
const $422ec97ec7702e9c$export$f79da416c7d67657 = (0, $3sQ5x.createHook)($422ec97ec7702e9c$var$Store, {
    selector: (state)=>({
            syncedIntegrations: state.syncedIntegrations,
            hasSyncedIntegration: (state.syncedIntegrations.data?.count || 0) > 0
        })
});
const $422ec97ec7702e9c$export$7145e9baa0c24277 = (0, $3sQ5x.createHook)($422ec97ec7702e9c$var$Store, {
    selector: (state)=>({
            discontinuedIntegrations: state.discontinuedIntegrations,
            hasDiscontinuedIntegration: (state.discontinuedIntegrations.data?.count || 0) > 0
        })
});
const $422ec97ec7702e9c$export$1525890f71cafb3f = (0, $3sQ5x.createHook)($422ec97ec7702e9c$var$Store, {
    selector: (state)=>({
            deprecatedIntegrations: state.deprecatedIntegrations,
            hasDeprecatedIntegration: (state.deprecatedIntegrations.data?.count || 0) > 0
        })
});
const $422ec97ec7702e9c$export$f3c44b9fdca261f2 = (0, $3sQ5x.createHook)($422ec97ec7702e9c$var$Store, {
    selector: (state)=>({
            incomingCallIntegrations: state.incomingCallIntegrations,
            hasIncomingCallIntegration: (state.incomingCallIntegrations.data?.count || 0) > 0
        })
});

});
parcelRegister("a1OoE", function(module, exports) {

$parcel$export(module.exports, "actions", () => $280bbd03a95fd3a3$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1GqJn = parcelRequire("1GqJn");

var $iA7nF = parcelRequire("iA7nF");

var $axqwP = parcelRequire("axqwP");
const $280bbd03a95fd3a3$var$getIntegrationCounts = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            counts: {
                ...state.counts,
                loading: true
            }
        });
        return $axqwP.getIntegrationCounts(cloudId).then((res)=>setState({
                counts: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                counts: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $280bbd03a95fd3a3$var$getSyncedIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            syncedIntegrations: {
                ...state.syncedIntegrations,
                loading: true
            }
        });
        return $axqwP.getSyncedIntegrations(cloudId).then((res)=>setState({
                syncedIntegrations: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                syncedIntegrations: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $280bbd03a95fd3a3$var$getDiscontinuedIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            discontinuedIntegrations: {
                ...state.discontinuedIntegrations,
                loading: true
            }
        });
        return $axqwP.getDiscontinuedIntegrations(cloudId).then((res)=>setState({
                discontinuedIntegrations: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                discontinuedIntegrations: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $280bbd03a95fd3a3$var$getDeprecatedIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            deprecatedIntegrations: {
                ...state.deprecatedIntegrations,
                loading: true
            }
        });
        return $axqwP.getDeprecatedIntegrations(cloudId).then((res)=>setState({
                deprecatedIntegrations: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                deprecatedIntegrations: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $280bbd03a95fd3a3$var$getIncomingCallIntegrations = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            incomingCallIntegrations: {
                ...state.incomingCallIntegrations,
                loading: true
            }
        });
        return $axqwP.getIncomingCallIntegrations(cloudId).then((res)=>setState({
                incomingCallIntegrations: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                incomingCallIntegrations: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $280bbd03a95fd3a3$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($280bbd03a95fd3a3$var$getIntegrationCounts()),
            dispatch($280bbd03a95fd3a3$var$getSyncedIntegrations()),
            dispatch($280bbd03a95fd3a3$var$getDeprecatedIntegrations()),
            dispatch($280bbd03a95fd3a3$var$getDiscontinuedIntegrations())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $280bbd03a95fd3a3$var$initializeForAdmin = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($280bbd03a95fd3a3$var$getIntegrationCounts()),
            dispatch($280bbd03a95fd3a3$var$getSyncedIntegrations()),
            dispatch($280bbd03a95fd3a3$var$getDeprecatedIntegrations()),
            dispatch($280bbd03a95fd3a3$var$getDiscontinuedIntegrations()),
            dispatch($280bbd03a95fd3a3$var$getIncomingCallIntegrations())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $280bbd03a95fd3a3$export$e324594224ef24da = {
    initialize: $280bbd03a95fd3a3$var$initialize,
    initializeForAdmin: $280bbd03a95fd3a3$var$initializeForAdmin
};

});
parcelRegister("axqwP", function(module, exports) {

$parcel$export(module.exports, "getIntegrationCounts", () => $4a633d532959c7d6$export$77778a0ed0c6fa6e);
$parcel$export(module.exports, "getSyncedIntegrations", () => $4a633d532959c7d6$export$832e854d2572cc2f);
$parcel$export(module.exports, "getDiscontinuedIntegrations", () => $4a633d532959c7d6$export$fd29039ae6c0f299);
$parcel$export(module.exports, "getDeprecatedIntegrations", () => $4a633d532959c7d6$export$37a9d02f12612e7c);
$parcel$export(module.exports, "getIncomingCallIntegrations", () => $4a633d532959c7d6$export$269a90dd370437b8);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $4a633d532959c7d6$export$77778a0ed0c6fa6e = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/count`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getIntegrationCountsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4a633d532959c7d6$export$832e854d2572cc2f = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/sync`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getSyncedIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4a633d532959c7d6$export$fd29039ae6c0f299 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/discontinued`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getDiscontinuedIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4a633d532959c7d6$export$37a9d02f12612e7c = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v3/integrations/unified/transition/deprecated`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getDeprecatedIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};
const $4a633d532959c7d6$export$269a90dd370437b8 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/incoming-call`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getIncomingCallIntegrationsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("gPfYl", function(module, exports) {

$parcel$export(module.exports, "JNAAppStatusContainer", () => $168808b2276040e7$export$ea2d0ab423a74686);
$parcel$export(module.exports, "useJNAAppStatus", () => $168808b2276040e7$export$5d602c3d2ce99e4d);

var $eW6Xc = parcelRequire("eW6Xc");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $pa9q9 = parcelRequire("pa9q9");

var $9OXo1 = parcelRequire("9OXo1");

var $2osG0 = parcelRequire("2osG0");
const $168808b2276040e7$export$d4c72bab9d6cc13a = {
    loading: false,
    error: null
};
const $168808b2276040e7$var$Store = (0, $iXqE5.createStore)({
    initialState: $168808b2276040e7$export$d4c72bab9d6cc13a,
    actions: $2osG0.actions,
    name: 'jna-app-status'
});
// We have a separate store for this b/c we need to fetch the data higher up in the tree
const $168808b2276040e7$export$ea2d0ab423a74686 = (0, $eW6Xc.createContainer)($168808b2276040e7$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
            return {
                cloudId: cloudId,
                showFlag: showFlag
            };
        }
    })
});
const $168808b2276040e7$export$5d602c3d2ce99e4d = (0, $3sQ5x.createHook)($168808b2276040e7$var$Store);

});
parcelRegister("2osG0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $b5d1450971772bb8$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6QXBz = parcelRequire("6QXBz");
const $b5d1450971772bb8$var$getData = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const { loading: loading } = getState();
        if (loading) // We are already fetching and will receive results, no need to start another request
        return;
        setState({
            loading: true
        });
        return (0, $6QXBz.listJNAAppsEndpoint)(cloudId)// Drop any unnecessary fields
        .then(({ values: values })=>({
                values: values
            })).then(setState).catch((error)=>{
            // TODO: we might display toast
            setState({
                error: error
            });
            throw error;
        }).finally(()=>{
            setState({
                loading: false
            });
        });
    };
const $b5d1450971772bb8$var$initialize = $b5d1450971772bb8$var$getData;
const $b5d1450971772bb8$export$e324594224ef24da = {
    initialize: $b5d1450971772bb8$var$initialize
};

});
parcelRegister("6QXBz", function(module, exports) {

$parcel$export(module.exports, "listJNAAppsEndpoint", () => $585f8a9ffc29380f$export$89c8c108742e6641);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $585f8a9ffc29380f$export$89c8c108742e6641 = (cloudId)=>(0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/notification/devices`).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'listJNAAppsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });

});



parcelRegister("jbwqm", function(module, exports) {

$parcel$export(module.exports, "TeamAdminStatusContainer", () => $d393a57ef66828a1$export$1c30a658c5f5a989);
$parcel$export(module.exports, "useTeamAdminStatus", () => $d393a57ef66828a1$export$8e6e1b9570cbbe18);
$parcel$export(module.exports, "useIsTeamAdmin", () => $d393a57ef66828a1$export$1e85709af32c9e77);

var $eW6Xc = parcelRequire("eW6Xc");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $9OXo1 = parcelRequire("9OXo1");

var $fjrC9 = parcelRequire("fjrC9");

var $u313a = parcelRequire("u313a");
const $d393a57ef66828a1$export$d4c72bab9d6cc13a = {
    teamAdminStatus: (0, $fjrC9.emptyResource)
};
const $d393a57ef66828a1$var$Store = (0, $iXqE5.createStore)({
    initialState: $d393a57ef66828a1$export$d4c72bab9d6cc13a,
    actions: $u313a.actions,
    name: 'team-admin-status'
});
const $d393a57ef66828a1$export$1c30a658c5f5a989 = (0, $eW6Xc.createContainer)($d393a57ef66828a1$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            return {
                cloudId: cloudId
            };
        }
    })
});
const $d393a57ef66828a1$export$8e6e1b9570cbbe18 = (0, $3sQ5x.createHook)($d393a57ef66828a1$var$Store);
const $d393a57ef66828a1$export$1e85709af32c9e77 = (0, $3sQ5x.createHook)($d393a57ef66828a1$var$Store, {
    selector: (state)=>({
            isTeamAdmin: state.teamAdminStatus.data?.isTeamAdmin
        })
});

});
parcelRegister("u313a", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e9ada8a126ed29ad$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1GqJn = parcelRequire("1GqJn");

var $iA7nF = parcelRequire("iA7nF");

var $4NBj0 = parcelRequire("4NBj0");
const $e9ada8a126ed29ad$var$getTeamAdminStatus = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        const state = getState();
        setState({
            teamAdminStatus: {
                data: state.teamAdminStatus.data,
                error: null,
                loading: true
            }
        });
        return $4NBj0.getTeamAdminStatus(cloudId).then((res)=>setState({
                teamAdminStatus: (0, $1GqJn.createDataResponse)(res)
            })).catch((error)=>{
            setState({
                teamAdminStatus: (0, $1GqJn.createErrorResponse)(error)
            });
            throw error;
        });
    };
const $e9ada8a126ed29ad$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($e9ada8a126ed29ad$var$getTeamAdminStatus())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $e9ada8a126ed29ad$export$e324594224ef24da = {
    getTeamAdminStatus: $e9ada8a126ed29ad$var$getTeamAdminStatus,
    initialize: $e9ada8a126ed29ad$var$initialize
};

});
parcelRegister("4NBj0", function(module, exports) {

$parcel$export(module.exports, "getTeamAdminStatus", () => $139f0b131a39dfb8$export$454301be74c0d0f5);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $139f0b131a39dfb8$export$454301be74c0d0f5 = (cloudId)=>{
    const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/teams/has-any-team-admin-role`;
    return (0, $eusud.performGetRequest)(url).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getTeamAdminStatusEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("4UyCK", function(module, exports) {

$parcel$export(module.exports, "TeamsContainer", () => $68ff89a0c54ca969$export$1af14301d7a47977);
$parcel$export(module.exports, "useTeams", () => $68ff89a0c54ca969$export$6fe02dcc2001dcb0);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $pa9q9 = parcelRequire("pa9q9");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $fjrC9 = parcelRequire("fjrC9");

var $61UG4 = parcelRequire("61UG4");
const $68ff89a0c54ca969$export$d4c72bab9d6cc13a = {
    teams: (0, $fjrC9.emptyResource),
    hasTeams: false
};
const $68ff89a0c54ca969$var$Store = (0, $iXqE5.createStore)({
    initialState: $68ff89a0c54ca969$export$d4c72bab9d6cc13a,
    actions: $61UG4.actions,
    name: 'teams-step'
});
const $68ff89a0c54ca969$export$1af14301d7a47977 = (0, $eW6Xc.createContainer)($68ff89a0c54ca969$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { data: orgId } = (0, $14XJw.useOrgId)();
            const { atlassianAccountId: atlassianAccountId, cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
            return {
                orgId: orgId,
                accountId: atlassianAccountId,
                siteId: cloudId,
                showFlag: showFlag
            };
        }
    })
});
const $68ff89a0c54ca969$export$381ea4f5dcfe14e8 = (0, $3sQ5x.createHook)($68ff89a0c54ca969$var$Store);
const $68ff89a0c54ca969$export$61c2ead0c7de7c67 = (0, $3sQ5x.createActionsHook)($68ff89a0c54ca969$var$Store);
const $68ff89a0c54ca969$export$6fe02dcc2001dcb0 = (0, $3sQ5x.createHook)($68ff89a0c54ca969$var$Store, {
    selector: (state)=>({
            teams: state.teams,
            hasTeams: (state.teams.data?.entities.length || 0) > 0
        })
});

});
parcelRegister("61UG4", function(module, exports) {

$parcel$export(module.exports, "actions", () => $8b1c9aa8723d62ee$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1GqJn = parcelRequire("1GqJn");

var $iA7nF = parcelRequire("iA7nF");

var $pjOsd = parcelRequire("pjOsd");
const $8b1c9aa8723d62ee$var$getTeams = ()=>({ setState: setState, getState: getState }, { orgId: orgId, siteId: siteId, accountId: accountId })=>{
        if (!orgId) throw new Error('TeamsContainer-actions-getTeams-orgId must be defined to search teams');
        if (!accountId) {
            const error = new Error('TeamsContainer-useSyncContainerProps-atlassianAccountId must be defined to search teams');
            error.skipSentry = true;
            throw error;
        }
        const state = getState();
        setState({
            teams: {
                data: state.teams.data,
                error: null,
                loading: true
            }
        });
        return $pjOsd.searchTeamsEndpoint({
            orgId: orgId,
            siteId: siteId,
            accountId: accountId
        }).then((res)=>setState({
                teams: (0, $1GqJn.createDataResponse)(res)
            })).catch((err)=>{
            setState({
                teams: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $8b1c9aa8723d62ee$var$initialize = ()=>({ dispatch: dispatch })=>Promise.allSettled([
            dispatch($8b1c9aa8723d62ee$var$getTeams())
        ]).then((0, $iA7nF.multiplePromiseSettler));
const $8b1c9aa8723d62ee$export$e324594224ef24da = {
    getTeams: $8b1c9aa8723d62ee$var$getTeams,
    initialize: $8b1c9aa8723d62ee$var$initialize
};

});
parcelRegister("pjOsd", function(module, exports) {

$parcel$export(module.exports, "searchTeamsEndpoint", () => $ef017c4083dc5c7f$export$b6cad9b1c9a0c16e);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $ef017c4083dc5c7f$export$b6cad9b1c9a0c16e = ({ orgId: orgId, siteId: siteId, accountId: accountId })=>{
    const url = '/gateway/api/v4/teams/search';
    return (0, $eusud.performPostRequest)(url, {
        method: 'POST',
        body: JSON.stringify({
            organizationId: orgId,
            siteId: siteId,
            membership: {
                memberAccountIds: [
                    accountId
                ]
            },
            sortBy: [
                {
                    field: 'displayName',
                    order: 'asc'
                }
            ],
            limit: 100
        })
    }).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'searchTeamsEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
};

});



parcelRegister("91lou", function(module, exports) {

$parcel$export(module.exports, "TransitioningStatusContainer", () => $b8070b541c362c00$export$99720b5470b975d9);
$parcel$export(module.exports, "useTransitioningStatus", () => $b8070b541c362c00$export$534e97dc293df05a);
$parcel$export(module.exports, "useTransitioningStatusActions", () => $b8070b541c362c00$export$5097f959a9aa62ee);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $pa9q9 = parcelRequire("pa9q9");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $9OXo1 = parcelRequire("9OXo1");

var $8ALXm = parcelRequire("8ALXm");
const $b8070b541c362c00$export$d4c72bab9d6cc13a = {
    loading: false,
    error: null,
    isJnaAppDownloaded: false,
    ogAppExistsAtTransitioningStart: false,
    isRBNEnabled: true,
    areOgRulesDuplicated: false,
    areOgAppsDeactivated: false,
    jnaAppDownloadedRatio: 0,
    jnaAppDownloadedUsersCount: 0
};
const $b8070b541c362c00$var$Store = (0, $iXqE5.createStore)({
    initialState: $b8070b541c362c00$export$d4c72bab9d6cc13a,
    actions: $8ALXm.actions,
    name: 'transitioning-status'
});
const $b8070b541c362c00$export$99720b5470b975d9 = (0, $eW6Xc.createContainer)($b8070b541c362c00$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
            const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
            const isPrimaryAdmin = (0, $itmJb.useIsAdmin)();
            return {
                cloudId: cloudId,
                showFlag: showFlag,
                isAdmin: isSiteAdmin || isPrimaryAdmin
            };
        }
    })
});
const $b8070b541c362c00$export$534e97dc293df05a = (0, $3sQ5x.createHook)($b8070b541c362c00$var$Store);
const $b8070b541c362c00$export$5097f959a9aa62ee = (0, $3sQ5x.createActionsHook)($b8070b541c362c00$var$Store);

});
parcelRegister("8ALXm", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0d76ba88b9164f9c$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iA7nF = parcelRequire("iA7nF");

var $i19HX = parcelRequire("i19HX");
const $0d76ba88b9164f9c$var$getData = ()=>({ setState: setState, getState: getState }, { cloudId: cloudId, isAdmin: isAdmin })=>{
        const { loading: loading } = getState();
        if (loading) // We are already fetching and receive results, no need to start another request
        return;
        setState({
            loading: true
        });
        return Promise.allSettled([
            (0, $i19HX.getNotificationPreferences)(cloudId),
            (0, $i19HX.getTransitioningStatus)(cloudId, isAdmin)
        ]).then((0, $iA7nF.multiplePromiseSettler)).then(([notificationPreferencesResult, transitioningStatusResult])=>{
            if (notificationPreferencesResult.status === 'rejected' || transitioningStatusResult.status === 'rejected') throw new Error('All promises should be fulfilled in then callback');
            return {
                ...notificationPreferencesResult.value,
                ...transitioningStatusResult.value
            };
        }).then(setState).catch((error)=>{
            // TODO: we might display toast
            setState({
                error: error
            });
            throw error;
        }).finally(()=>{
            setState({
                loading: false
            });
        });
    };
const $0d76ba88b9164f9c$var$initialize = $0d76ba88b9164f9c$var$getData;
const $0d76ba88b9164f9c$var$deactivateOgApps = ()=>async ({ setState: setState })=>{
        setState({
            areOgAppsDeactivated: true
        });
    };
const $0d76ba88b9164f9c$export$e324594224ef24da = {
    initialize: $0d76ba88b9164f9c$var$initialize,
    deactivateOgApps: $0d76ba88b9164f9c$var$deactivateOgApps
};

});
parcelRegister("i19HX", function(module, exports) {

$parcel$export(module.exports, "getTransitioningStatus", () => $af3bd5a83ad05315$export$6b245964f40af86a);
$parcel$export(module.exports, "getNotificationPreferences", () => $af3bd5a83ad05315$export$60e139c3026f21bc);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $af3bd5a83ad05315$export$6b245964f40af86a = (cloudId, isAdmin)=>(0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/transitioning?isAdmin=${isAdmin}`).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getTransitioningStatus',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
const $af3bd5a83ad05315$export$60e139c3026f21bc = (cloudId)=>(0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/notification-preferences`).then((res)=>// TODO: return name and role if it is necessary for the UI
        ({
            isRBNEnabled: !!res.roleBasedNotificationName
        })).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getNotificationPreferences',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });

});



parcelRegister("k9ufy", function(module, exports) {

$parcel$export(module.exports, "UsersAndRolesContainer", () => $f5ea6d8f67a25a35$export$8641f4275dfb350f);
$parcel$export(module.exports, "useUsersAndRolesStore", () => $f5ea6d8f67a25a35$export$4c1f48a2f8c5d25);
$parcel$export(module.exports, "useUserAndRolesActions", () => $f5ea6d8f67a25a35$export$3a5577e95dd8ebcf);
$parcel$export(module.exports, "useGetUsersWithoutAdminRole", () => $f5ea6d8f67a25a35$export$208cf6e453d9959);
$parcel$export(module.exports, "useGetUsersWithoutCustomRole", () => $f5ea6d8f67a25a35$export$f97f67eb73b757d4);
$parcel$export(module.exports, "useStakeholders", () => $f5ea6d8f67a25a35$export$57e32456ebc09be3);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $9OXo1 = parcelRequire("9OXo1");

var $fjrC9 = parcelRequire("fjrC9");

var $41HN4 = parcelRequire("41HN4");
const $f5ea6d8f67a25a35$var$initialState = {
    usersWithoutAdminRole: (0, $fjrC9.emptyResource),
    usersWithoutCustomRole: (0, $fjrC9.emptyResource),
    stakeholders: (0, $fjrC9.emptyResource)
};
const $f5ea6d8f67a25a35$var$Store = (0, $iXqE5.createStore)({
    initialState: $f5ea6d8f67a25a35$var$initialState,
    actions: $41HN4.actions,
    name: 'user-section'
});
const $f5ea6d8f67a25a35$export$8641f4275dfb350f = (0, $eW6Xc.createContainer)($f5ea6d8f67a25a35$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({
        useSyncContainerProps: ()=>{
            const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
            return {
                cloudId: cloudId
            };
        }
    })
});
const $f5ea6d8f67a25a35$export$4c1f48a2f8c5d25 = (0, $3sQ5x.createHook)($f5ea6d8f67a25a35$var$Store);
const $f5ea6d8f67a25a35$export$3a5577e95dd8ebcf = (0, $3sQ5x.createActionsHook)($f5ea6d8f67a25a35$var$Store);
const $f5ea6d8f67a25a35$export$208cf6e453d9959 = (0, $3sQ5x.createHook)($f5ea6d8f67a25a35$var$Store, {
    selector: (state)=>state.usersWithoutAdminRole
});
const $f5ea6d8f67a25a35$export$f97f67eb73b757d4 = (0, $3sQ5x.createHook)($f5ea6d8f67a25a35$var$Store, {
    selector: (state)=>state.usersWithoutCustomRole
});
const $f5ea6d8f67a25a35$export$57e32456ebc09be3 = (0, $3sQ5x.createHook)($f5ea6d8f67a25a35$var$Store, {
    selector: (state)=>state.stakeholders
});

});
parcelRegister("41HN4", function(module, exports) {

$parcel$export(module.exports, "actions", () => $83453406eb32a656$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1GqJn = parcelRequire("1GqJn");

var $iA7nF = parcelRequire("iA7nF");

var $2VwYU = parcelRequire("2VwYU");
const $83453406eb32a656$var$getUsersWithoutAdminRole = ()=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            usersWithoutAdminRole: {
                data: null,
                error: null,
                loading: true
            }
        });
        return $2VwYU.getUsersWithoutAdminRole(cloudId).then((res)=>{
            setState({
                usersWithoutAdminRole: (0, $1GqJn.createDataResponse)(res)
            });
        }).catch((err)=>{
            // TODO we might display toast
            setState({
                usersWithoutAdminRole: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $83453406eb32a656$var$getUsersWithoutCustomRole = ()=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            usersWithoutCustomRole: {
                data: null,
                error: null,
                loading: true
            }
        });
        return $2VwYU.getUsersWithoutCustomRole(cloudId).then((res)=>{
            setState({
                usersWithoutCustomRole: (0, $1GqJn.createDataResponse)(res)
            });
        }).catch((err)=>{
            // TODO we might display toast
            setState({
                usersWithoutCustomRole: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $83453406eb32a656$var$getStakeholders = ()=>({ setState: setState }, { cloudId: cloudId })=>{
        setState({
            stakeholders: {
                data: null,
                error: null,
                loading: true
            }
        });
        return $2VwYU.getStakeholders(cloudId).then((res)=>{
            setState({
                stakeholders: (0, $1GqJn.createDataResponse)(res)
            });
        }).catch((err)=>{
            // TODO we might display toast
            setState({
                stakeholders: (0, $1GqJn.createErrorResponse)(err)
            });
            throw err;
        });
    };
const $83453406eb32a656$var$initialize = (hasJsmAboveStandard)=>({ dispatch: dispatch })=>{
        if (hasJsmAboveStandard) return Promise.allSettled([
            dispatch($83453406eb32a656$var$getUsersWithoutCustomRole()),
            dispatch($83453406eb32a656$var$getUsersWithoutAdminRole()),
            dispatch($83453406eb32a656$var$getStakeholders())
        ]).then((0, $iA7nF.multiplePromiseSettler));
        return Promise.allSettled([
            dispatch($83453406eb32a656$var$getUsersWithoutCustomRole()),
            dispatch($83453406eb32a656$var$getUsersWithoutAdminRole())
        ]).then((0, $iA7nF.multiplePromiseSettler));
    };
const $83453406eb32a656$export$e324594224ef24da = {
    getUsersWithoutAdminRole: $83453406eb32a656$var$getUsersWithoutAdminRole,
    getUsersWithoutCustomRole: $83453406eb32a656$var$getUsersWithoutCustomRole,
    getStakeholders: $83453406eb32a656$var$getStakeholders,
    initialize: $83453406eb32a656$var$initialize
};

});
parcelRegister("2VwYU", function(module, exports) {

$parcel$export(module.exports, "getStakeholders", () => $867327124ecc2dfa$export$30370cfbc42a80a5);
$parcel$export(module.exports, "getUsersWithoutAdminRole", () => $867327124ecc2dfa$export$1ec19cfa7c383f0d);
$parcel$export(module.exports, "getUsersWithoutCustomRole", () => $867327124ecc2dfa$export$64f73bf174c9014a);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $867327124ecc2dfa$export$30370cfbc42a80a5 = (cloudId)=>(0, $eusud.performPostRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/roles/filter`, {
        body: JSON.stringify({
            limit: '10',
            offset: 0,
            roles: [
                'Stakeholder'
            ]
        })
    }).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getStakeholders',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
    // throw err;
    });
const $867327124ecc2dfa$export$1ec19cfa7c383f0d = (cloudId)=>(0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/permissionDifference/admin`).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getUsersWithoutAdminRole',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });
const $867327124ecc2dfa$export$64f73bf174c9014a = (cloudId)=>(0, $eusud.performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/permissionDifference/customRole`).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'getUsersWithoutCustomRole',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });

});



const $2829d585c82ec887$export$203403aefc029c66 = 'ref';
const $2829d585c82ec887$export$8638ff77a0e20f0f = 'opsgenie';

parcelRegister("kkwlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6abecfa22ab77d89$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6abecfa22ab77d89$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitleNonFinal: {
        "id": "eoc-changeboarding.controllers.store.global.error-title-non-final",
        "defaultMessage": "Couldn't open the guide"
    },
    errorDescriptionNonFinal: {
        "id": "eoc-changeboarding.controllers.store.global.error-description-non-final",
        "defaultMessage": "Something went wrong. Reload the page and try again."
    },
    errorActionNonFinal: {
        "id": "eoc-changeboarding.controllers.store.global.error-action-non-final",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("4kqRp", function(module, exports) {

$parcel$export(module.exports, "useProgressStore", () => $f68cf827bd94c6e7$export$312129c257c96af8);
$parcel$export(module.exports, "useProgressActions", () => $f68cf827bd94c6e7$export$2c96689aa9dcabf8);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $eSMWy = parcelRequire("eSMWy");
const $f68cf827bd94c6e7$var$initialState = {
    activeContent: (0, $eSMWy.ProgressContents).Home,
    activeTask: null,
    latestContent: (0, $eSMWy.ProgressContents).Home,
    isOpen: false
};
const $f68cf827bd94c6e7$var$Store = (0, $iXqE5.createStore)({
    initialState: $f68cf827bd94c6e7$var$initialState,
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true,
                    activeContent: (0, $eSMWy.ProgressContents).Home
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            },
        changeActiveContent: (content, task)=>({ setState: setState })=>{
                setState({
                    activeContent: content,
                    activeTask: task || null
                });
            },
        backToHome: (latestContent)=>({ setState: setState })=>{
                setState({
                    activeContent: (0, $eSMWy.ProgressContents).Home,
                    latestContent: latestContent
                });
            }
    },
    name: 'progress'
});
const $f68cf827bd94c6e7$export$312129c257c96af8 = (0, $3sQ5x.createHook)($f68cf827bd94c6e7$var$Store);
const $f68cf827bd94c6e7$export$2c96689aa9dcabf8 = (0, $3sQ5x.createActionsHook)($f68cf827bd94c6e7$var$Store);
const $f68cf827bd94c6e7$export$98485f76d889f48a = (0, $eW6Xc.createContainer)($f68cf827bd94c6e7$var$Store, {
    Wrapper: (0, $eW6Xc.createDefaultEocWrapper)({})
});

});
parcelRegister("eSMWy", function(module, exports) {

$parcel$export(module.exports, "ProgressContents", () => $30a0586874813b0a$export$470df1a589ec66d4);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $30a0586874813b0a$export$470df1a589ec66d4 = /*#__PURE__*/ function(ProgressContents) {
    ProgressContents[ProgressContents["Home"] = 0] = "Home";
    ProgressContents[ProgressContents["UsersAndRoles"] = 1] = "UsersAndRoles";
    ProgressContents[ProgressContents["Alerts"] = 2] = "Alerts";
    ProgressContents[ProgressContents["Notifications"] = 3] = "Notifications";
    ProgressContents[ProgressContents["Teams"] = 4] = "Teams";
    ProgressContents[ProgressContents["ChatTools"] = 5] = "ChatTools";
    ProgressContents[ProgressContents["Integrations"] = 6] = "Integrations";
    ProgressContents[ProgressContents["AutomateAlertAndIncidentResponse"] = 7] = "AutomateAlertAndIncidentResponse";
    ProgressContents[ProgressContents["Incidents"] = 8] = "Incidents";
    ProgressContents[ProgressContents["Heartbeats"] = 9] = "Heartbeats";
    ProgressContents[ProgressContents["Find"] = 10] = "Find";
    ProgressContents[ProgressContents["DeprecatedOnes"] = 11] = "DeprecatedOnes";
    return ProgressContents;
}({});

});


parcelRegister("5p9RM", function(module, exports) {

$parcel$export(module.exports, "useTransitionHomeQueryParams", () => $0889d0a4f7517bd8$export$d067561a2d981345);

var $ieDtd = parcelRequire("ieDtd");

var $eSMWy = parcelRequire("eSMWy");
function $0889d0a4f7517bd8$var$isProgressContentsKey(key) {
    return key in (0, $eSMWy.ProgressContents);
}
function $0889d0a4f7517bd8$var$getActiveContent(queryParamValue) {
    const activeContentValue = Number(queryParamValue);
    if (Number.isNaN(activeContentValue) && $0889d0a4f7517bd8$var$isProgressContentsKey(queryParamValue)) return (0, $eSMWy.ProgressContents)[queryParamValue];
    return activeContentValue;
}
const $0889d0a4f7517bd8$export$d067561a2d981345 = ()=>{
    const [transitionHomeContent, setTransitionHomeContent] = (0, $ieDtd.useQueryParam)('transitionHomeContent');
    const [transitionHomeActiveTask, setTransitionHomeActiveTask] = (0, $ieDtd.useQueryParam)('transitionHomeActiveTask');
    const clearQueryParams = ()=>{
        setTransitionHomeContent(undefined);
        // Workaround: A setTimeout is used to clear the transitionHomeActiveTask query parameter.
        // Without this delay, only the first query parameter gets cleared,
        // even though both setters are called within the same function.
        setTimeout(()=>{
            setTransitionHomeActiveTask(undefined);
        });
    };
    const activeTaskIndex = Number(transitionHomeActiveTask);
    const isTaskIndexValid = !Number.isNaN(activeTaskIndex) && activeTaskIndex >= 0;
    const isTransitionHomeContentValid = transitionHomeContent && $0889d0a4f7517bd8$var$isProgressContentsKey(transitionHomeContent);
    const activeContent = isTransitionHomeContentValid ? $0889d0a4f7517bd8$var$getActiveContent(transitionHomeContent) : undefined;
    const queryParamsValid = isTransitionHomeContentValid && isTaskIndexValid;
    return {
        clearQueryParams: clearQueryParams,
        activeTaskIndex: activeTaskIndex,
        activeContent: activeContent,
        queryParamsValid: queryParamsValid
    };
};

});

parcelRegister("aTWms", function(module, exports) {

$parcel$export(module.exports, "ChangeboardingProviders", () => $a85523c42764cbee$export$935fa8923574c4cf);

var $5uXOq = parcelRequire("5uXOq");

var $4iQaI = parcelRequire("4iQaI");

var $lLiTq = parcelRequire("lLiTq");

var $luBum = parcelRequire("luBum");

var $5fIfP = parcelRequire("5fIfP");

var $gPfYl = parcelRequire("gPfYl");

var $jbwqm = parcelRequire("jbwqm");

var $4UyCK = parcelRequire("4UyCK");

var $91lou = parcelRequire("91lou");

var $k9ufy = parcelRequire("k9ufy");
const $a85523c42764cbee$var$MinimalToolingProviders = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9ufy.UsersAndRolesContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4iQaI.ChatToolsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPfYl.JNAAppStatusContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $91lou.TransitioningStatusContainer), {
        isGlobal: true
    }, children))));
const $a85523c42764cbee$export$935fa8923574c4cf = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4UyCK.TeamsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbwqm.TeamAdminStatusContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5fIfP.IntegrationsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLiTq.DeprecatedCountsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBum.IncidentsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a85523c42764cbee$var$MinimalToolingProviders, null, children))))));
};

});

parcelRegister("8PpFm", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeModal", () => $368fdb9af0e95225$export$164cefb24823017f);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $d2gYe = parcelRequire("d2gYe");

var $aEHvW = parcelRequire("aEHvW");

var $8jRW9 = parcelRequire("8jRW9");

var $i8Qvm = parcelRequire("i8Qvm");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $1Ucx1 = parcelRequire("1Ucx1");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $7NYq5 = parcelRequire("7NYq5");

var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $e7p8X = parcelRequire("e7p8X");

var $4kqRp = parcelRequire("4kqRp");

var $eSMWy = parcelRequire("eSMWy");

var $gB05R = parcelRequire("gB05R");

var $9BvDp = parcelRequire("9BvDp");

var $i9P4n = parcelRequire("i9P4n");

var $iAXXw = parcelRequire("iAXXw");

var $9hz6f = parcelRequire("9hz6f");

var $6t2QC = parcelRequire("6t2QC");

var $kFgpe = parcelRequire("kFgpe");

var $lurvh = parcelRequire("lurvh");

var $fKCt1 = parcelRequire("fKCt1");

var $l2kza = parcelRequire("l2kza");

var $gsf0a = parcelRequire("gsf0a");

var $dA5lS = parcelRequire("dA5lS");

var $avRjR = parcelRequire("avRjR");

var $8rMbg = parcelRequire("8rMbg");
const $368fdb9af0e95225$var$GiveFeedbackButton = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openEocFeedbackCollector: openEocFeedbackCollector } = (0, $1Ucx1.useEocFeedbackCollector)();
    const onFeedbackButtonClick = (_, analyticEvent)=>{
        onClose();
        (0, $8zOmE.fireUIAnalytics)(analyticEvent, 'eocGiveFeedbackButton');
        openEocFeedbackCollector({
            showTypeField: true,
            renderCustomContent: (0, $e7p8X.FeedbackCollectorDescription),
            feedbackTitle: formatMessage((0, $l2kza.default).giveFeedbackButtonNonFinal)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $368fdb9af0e95225$var$giveFeedbackBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aEHvW))), {
            spacing: "spacious",
            label: formatMessage((0, $l2kza.default).giveFeedbackButtonNonFinal),
            color: "var(--ds-icon-subtle, #626F86)"
        }),
        "aria-label": formatMessage((0, $l2kza.default).giveFeedbackButtonNonFinal),
        onClick: onFeedbackButtonClick
    }));
};
const $368fdb9af0e95225$var$MinimizeButton = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $368fdb9af0e95225$var$closeFullScreenBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jRW9))), {
            spacing: "spacious",
            label: formatMessage((0, $l2kza.default).minimizeNonFinal),
            color: "var(--ds-icon-subtle, #626F86)"
        }),
        "aria-label": formatMessage((0, $l2kza.default).closeButtonNonFinal),
        onClick: (_, analyticEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticEvent, 'closetransitionHome');
            onClose();
        }
    }));
};
const $368fdb9af0e95225$export$164cefb24823017f = ({ isOpen: isOpen, onClose: onClose })=>{
    const [{ activeContent: activeContent, activeTask: activeTask }] = (0, $4kqRp.useProgressStore)();
    const { backToHome: backToHome } = (0, $4kqRp.useProgressActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (activeTask || activeTask === 0) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const nodes = document.querySelectorAll('.transition-home-content-box');
            const node = nodes[activeTask];
            if (node) node.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }, [
        activeContent,
        activeTask
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        onClose: (e, analyticEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticEvent, 'transitionHome');
            onClose();
        },
        width: 1100,
        height: 700,
        messageId: "eoc-changeboarding.ui.transition-home.modal",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        grow: "fill",
        xcss: $368fdb9af0e95225$var$inlineStyles
    }, activeContent === (0, $eSMWy.ProgressContents).Home ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fKCt1.TransitionHomeLeft), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dA5lS.TransitionHomeRight), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($368fdb9af0e95225$var$GiveFeedbackButton, {
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($368fdb9af0e95225$var$MinimizeButton, {
        onClose: onClose
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $368fdb9af0e95225$var$stepLeftBoxStyles,
        padding: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2gYe))), {
            label: ""
        }),
        onClick: ()=>backToHome(activeContent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $l2kza.default).backButtonNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.300",
        xcss: $368fdb9af0e95225$var$stepsWrapperBoxStyles
    }, activeContent === (0, $eSMWy.ProgressContents).UsersAndRoles && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8rMbg.UsersAndRolesStep), null), activeContent === (0, $eSMWy.ProgressContents).Alerts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gB05R.AlertsStep), null), activeContent === (0, $eSMWy.ProgressContents).Notifications && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gsf0a.NotificationsStep), null), activeContent === (0, $eSMWy.ProgressContents).ChatTools && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9P4n.ChatToolsStep), null), activeContent === (0, $eSMWy.ProgressContents).Teams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $avRjR.TeamsConceptStep), null), activeContent === (0, $eSMWy.ProgressContents).Integrations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lurvh.IntegrationsStep), null), activeContent === (0, $eSMWy.ProgressContents).AutomateAlertAndIncidentResponse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9BvDp.AutomateAlertAndIncidentResponseStep), null), activeContent === (0, $eSMWy.ProgressContents).Incidents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kFgpe.IncidentsStep), null), activeContent === (0, $eSMWy.ProgressContents).Heartbeats && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6t2QC.HeartbeatsStep), null), activeContent === (0, $eSMWy.ProgressContents).Find && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9hz6f.FindStep), null), activeContent === (0, $eSMWy.ProgressContents).DeprecatedOnes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iAXXw.DeprecatedOnesStep), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($368fdb9af0e95225$var$GiveFeedbackButton, {
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($368fdb9af0e95225$var$MinimizeButton, {
        onClose: onClose
    }))))));
};
const $368fdb9af0e95225$var$stepLeftBoxStyles = (0, $8CUq3.xcss)({
    width: '172px',
    flexShrink: 0
});
const $368fdb9af0e95225$var$inlineStyles = (0, $8CUq3.xcss)({
    height: '100%',
    position: 'relative'
});
const $368fdb9af0e95225$var$closeFullScreenBoxStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.100',
    right: 'space.100'
});
const $368fdb9af0e95225$var$giveFeedbackBoxStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.100',
    right: 'space.500'
});
const $368fdb9af0e95225$var$stepsWrapperBoxStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    height: '100%',
    width: '100%',
    overflow: 'auto'
});

});
parcelRegister("aEHvW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c129a0bf5d2aeea221ba2044e3fd85fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));

var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
    }, props));
$7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;

});
parcelRegister("5dqGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cc2df171aca9493$var$_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3cc2df171aca9493$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cc2df171aca9493$var$FeedbackIcon = (props)=>/*#__PURE__*/ $3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;

});

parcelRegister("3g1Fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>/*#__PURE__*/ $25f4287f17f73dc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $25f4287f17f73dc4$var$_feedback.default
    }));
$25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;

});


parcelRegister("8jRW9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aad52e9dcb072191e5185d04bd1632ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60e9efd17ad3db60$var$_react = $60e9efd17ad3db60$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $60e9efd17ad3db60$var$_shrinkDiagonal = $60e9efd17ad3db60$var$_interopRequireDefault((parcelRequire("8KRBa")));

var $60e9efd17ad3db60$var$_vidFullScreenOff = $60e9efd17ad3db60$var$_interopRequireDefault((parcelRequire("4rRW5")));
function $60e9efd17ad3db60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShrinkDiagonalIcon.
 * This component is ShrinkDiagonalIcon, with `UNSAFE_fallbackIcon` set to "VidFullScreenOffIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60e9efd17ad3db60$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $60e9efd17ad3db60$var$_react.default.createElement($60e9efd17ad3db60$var$_shrinkDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $60e9efd17ad3db60$var$_vidFullScreenOff.default
    }, props));
$60e9efd17ad3db60$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
var $60e9efd17ad3db60$var$_default = module.exports.default = $60e9efd17ad3db60$var$ShrinkDiagonalIcon;

});
parcelRegister("8KRBa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5830a86fa64b71ea84cc4eb2a6e1075>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65fc322a3db160cb$var$_react = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $65fc322a3db160cb$var$_baseNew = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $65fc322a3db160cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65fc322a3db160cb$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $65fc322a3db160cb$var$_react.default.createElement($65fc322a3db160cb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.72 6.22 13.97.97l1.06 1.06-5.25 5.25zM7.28 9.78l-5.25 5.25-1.06-1.06 5.25-5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M10 6V2H8.5v4.75c0 .414.336.75.75.75H14V6zM2 8.5h4.75a.75.75 0 0 1 .75.75V14H6v-4H2z" clip-rule="evenodd"/>`
    }, props));
$65fc322a3db160cb$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $65fc322a3db160cb$var$_default = module.exports.default = $65fc322a3db160cb$var$ShrinkDiagonalIcon;

});

parcelRegister("4rRW5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33d3859773cf17e9$var$_react = $33d3859773cf17e9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $33d3859773cf17e9$var$_shrinkDiagonal = $33d3859773cf17e9$var$_interopRequireDefault((parcelRequire("8KRBa")));
function $33d3859773cf17e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $33d3859773cf17e9$var$VidFullScreenOffIcon = (props)=>/*#__PURE__*/ $33d3859773cf17e9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M9 15.003v2.995a1 1 0 1 0 2 0v-3.896C11 13.494 10.507 13 9.9 13H6a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M3.74 20.294a.997.997 0 0 0 1.407.005l5.152-5.152a1 1 0 0 0-.005-1.407l-.034-.034a.997.997 0 0 0-1.407-.005l-5.152 5.152a1 1 0 0 0 .005 1.407z"/><path d="M19.067 3.321 13.32 9.066a1.115 1.115 0 0 0 .005 1.57l.036.037a1.11 1.11 0 0 0 1.571.005l5.747-5.744a1.116 1.116 0 0 0-.006-1.57l-.037-.037a1.117 1.117 0 0 0-1.57-.006"/><path d="M13 6.002v3.896c0 .608.493 1.102 1.1 1.102H18a1 1 0 0 0 0-2.003h-3V6.002a1 1 0 1 0-2 0"/></g></svg>`
    }, props, {
        newIcon: $33d3859773cf17e9$var$_shrinkDiagonal.default
    }));
$33d3859773cf17e9$var$VidFullScreenOffIcon.displayName = 'VidFullScreenOffIcon';
var $33d3859773cf17e9$var$_default = module.exports.default = $33d3859773cf17e9$var$VidFullScreenOffIcon;

});


parcelRegister("1Ucx1", function(module, exports) {

$parcel$export(module.exports, "useEocFeedbackCollector", () => $59465509708ed36e$export$6c2ca7ac39b8ab80);

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $doZTA = parcelRequire("doZTA");


var $hHSGg = parcelRequire("hHSGg");
const $59465509708ed36e$export$6c2ca7ac39b8ab80 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin, appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const [{ route: { name: name, path: path } }] = (0, $doZTA.useRouter)();
    return {
        openEocFeedbackCollector: (options)=>{
            openFeedbackCollector({
                showTypeField: false,
                feedbackTitle: formatMessage((0, $hHSGg.messages).modalTitle),
                summaryPlaceholder: formatMessage((0, $hHSGg.messages).feedbackInputPlaceholder),
                // @ts-expect-error: Object literal may only specify known properties, and 'customTextAreaLabel' does not exist in type 'FeedbackCollectorProps'.ts(2345)
                customTextAreaLabel: formatMessage((0, $hHSGg.messages).feedbackInputLabel),
                ...options,
                entrypointId: (0, $a4bb41a5178f4e2e$export$8c3fe078bd6c888e),
                onSubmit: ()=>{
                    // https://data-portal.internal.atlassian.com/analytics/registry/62661
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                        actionSubject: 'eocFeedbackCollectorModal',
                        action: 'submitted'
                    }));
                },
                feedbackContext: [
                    {
                        id: (0, $7iULw.EntryKeys).IS_ADMIN,
                        value: isAdmin
                    },
                    {
                        id: (0, $7iULw.EntryKeys).IS_SITE_ADMIN,
                        value: isSiteAdmin
                    },
                    {
                        id: (0, $7iULw.EntryKeys).EDITION,
                        value: appEditions.serviceDesk
                    },
                    {
                        id: (0, $7iULw.EntryKeys).ROUTE_NAME,
                        value: name
                    },
                    {
                        id: (0, $7iULw.EntryKeys).LOCATION,
                        value: path
                    }
                ]
            });
        }
    };
};

});
const $a4bb41a5178f4e2e$export$8c3fe078bd6c888e = '07551bfc-5486-4265-b9fa-7e540430b3fd';

parcelRegister("hHSGg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8fcc7b64d7376990$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8fcc7b64d7376990$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    modalTitle: {
        "id": "eoc-feedback-collector.modal-title",
        "defaultMessage": "Share your feedback with us"
    },
    feedbackInputPlaceholder: {
        "id": "eoc-feedback-collector.feedback-input-placeholder",
        "defaultMessage": "We'd love to know what you like, what you dislike, and what you want to change."
    },
    feedbackInputLabel: {
        "id": "eoc-feedback-collector.feedback-input-label",
        "defaultMessage": "Tell us what's on your mind"
    }
});

});


parcelRegister("e7p8X", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorDescription", () => $2023f49972a59fe1$export$5881447fa4ef232a);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $fAcYG = parcelRequire("fAcYG");
const $2023f49972a59fe1$export$5881447fa4ef232a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $2023f49972a59fe1$var$feedbackCollectorDescriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $fAcYG.messages).descriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $fAcYG.messages).learnMoreNonFinal, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: "/"
            }, chunks)
    })));
};
const $2023f49972a59fe1$var$feedbackCollectorDescriptionStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.300',
    gap: 'space.150'
});

});
parcelRegister("fAcYG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1a89939afe3b3038$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $1a89939afe3b3038$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    descriptionNonFinal: {
        "id": "eoc-changeboarding.common.feedback-collector-description.description-non-final",
        "defaultMessage": "Your thoughts are valuable in helping improve our products."
    },
    learnMoreNonFinal: {
        "id": "eoc-changeboarding.common.feedback-collector-description.learn-more-non-final",
        "defaultMessage": "If you're looking to get help or want to report a bug, visit our <link>support site</link>."
    }
});

});


parcelRegister("gB05R", function(module, exports) {

$parcel$export(module.exports, "AlertsStep", () => $c2baf46b0e9027aa$export$d4500eed718a362b);

var $5uXOq = parcelRequire("5uXOq");

var $flpap = parcelRequire("flpap");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $bJeNF = parcelRequire("bJeNF");

var $5qRwM = parcelRequire("5qRwM");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $lha8j = parcelRequire("lha8j");

var $3V4J8 = parcelRequire("3V4J8");

var $5JunY = parcelRequire("5JunY");

var $1fGbK = parcelRequire("1fGbK");

var $kgVQv = parcelRequire("kgVQv");

var $fqVln = parcelRequire("fqVln");

var $3tlnn = parcelRequire("3tlnn");

var $glWMa = parcelRequire("glWMa");
const $c2baf46b0e9027aa$var$Bold = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "strong"
    }, children, " ", children?.[0] === 'More actions' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
        LEGACY_size: "small",
        label: ""
    }));
const $c2baf46b0e9027aa$export$d4500eed718a362b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3V4J8.TransitionHomeHeader), {
        title: formatMessage((0, $5JunY.messages).alertsAndOnCallTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).alertsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).alertsTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $glWMa.messages).taskOneDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "/jira/ops/alerts",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $glWMa.messages).taskOneButtonNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3tlnn))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($fqVln))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).alertsTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                strong: {
                    component: $c2baf46b0e9027aa$var$Bold
                }
            }
        }
    }, formatMessage((0, $glWMa.messages).taskTwoDescriptionNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).alertsTaskThreeNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $glWMa.messages).taskThreeDescriptionNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            // todo: change the illustration when dark mode is ready
            src: (0, (/*@__PURE__*/$parcel$interopDefault($kgVQv))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($kgVQv))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $1fGbK.default).alertsTaskFourNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $glWMa.messages).taskFourDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "/jira/ops/who-is-on-call",
        target: "_blank"
    }, formatMessage((0, $glWMa.messages).taskFourButtonNonFinal))))));
};

});
parcelRegister("flpap", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2bc56c6c0b4e02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $b2bc56c6c0b4e02e$var$t() {
    return $b2bc56c6c0b4e02e$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $b2bc56c6c0b4e02e$var$t.apply(this, arguments);
}
const $b2bc56c6c0b4e02e$var$n = [
    "children",
    "options"
], $b2bc56c6c0b4e02e$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $b2bc56c6c0b4e02e$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($b2bc56c6c0b4e02e$var$i || ($b2bc56c6c0b4e02e$var$i = {}));
const $b2bc56c6c0b4e02e$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $b2bc56c6c0b4e02e$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $b2bc56c6c0b4e02e$var$o = [
    "style",
    "script"
], $b2bc56c6c0b4e02e$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $b2bc56c6c0b4e02e$var$s = /mailto:/i, $b2bc56c6c0b4e02e$var$d = /\n{2,}$/, $b2bc56c6c0b4e02e$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $b2bc56c6c0b4e02e$var$u = /^ *> ?/gm, $b2bc56c6c0b4e02e$var$f = /^ {2,}\n/, $b2bc56c6c0b4e02e$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $b2bc56c6c0b4e02e$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $b2bc56c6c0b4e02e$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $b2bc56c6c0b4e02e$var$k = /^(?:\n *)*\n/, $b2bc56c6c0b4e02e$var$x = /\r\n?/g, $b2bc56c6c0b4e02e$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $b2bc56c6c0b4e02e$var$v = /^\[\^([^\]]+)]/, $b2bc56c6c0b4e02e$var$S = /\f/g, $b2bc56c6c0b4e02e$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $b2bc56c6c0b4e02e$var$C = /^\s*?\[(x|\s)\]/, $b2bc56c6c0b4e02e$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $b2bc56c6c0b4e02e$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $b2bc56c6c0b4e02e$var$T = /^<!--[\s\S]*?(?:-->)/, $b2bc56c6c0b4e02e$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $b2bc56c6c0b4e02e$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $b2bc56c6c0b4e02e$var$M = /^\{.*\}$/, $b2bc56c6c0b4e02e$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $b2bc56c6c0b4e02e$var$I = /^<([^ >]+@[^ >]+)>/, $b2bc56c6c0b4e02e$var$U = /^<([^ >]+:\/[^ >]+)>/, $b2bc56c6c0b4e02e$var$D = /-([a-z])?/gi, $b2bc56c6c0b4e02e$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $b2bc56c6c0b4e02e$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $b2bc56c6c0b4e02e$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $b2bc56c6c0b4e02e$var$_ = /\t/g, $b2bc56c6c0b4e02e$var$G = /(^ *\||\| *$)/g, $b2bc56c6c0b4e02e$var$W = /^ *:-+: *$/, $b2bc56c6c0b4e02e$var$Z = /^ *:-+ *$/, $b2bc56c6c0b4e02e$var$q = /^ *-+: *$/, $b2bc56c6c0b4e02e$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $b2bc56c6c0b4e02e$var$V = new RegExp(`^([*_])\\1${$b2bc56c6c0b4e02e$var$Q}\\1\\1(?!\\1)`), $b2bc56c6c0b4e02e$var$X = new RegExp(`^([*_])${$b2bc56c6c0b4e02e$var$Q}\\1(?!\\1|\\w)`), $b2bc56c6c0b4e02e$var$J = new RegExp(`^==${$b2bc56c6c0b4e02e$var$Q}==`), $b2bc56c6c0b4e02e$var$K = new RegExp(`^~~${$b2bc56c6c0b4e02e$var$Q}~~`), $b2bc56c6c0b4e02e$var$Y = /^\\([^0-9A-Za-z\s])/, $b2bc56c6c0b4e02e$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $b2bc56c6c0b4e02e$var$te = /^\n+/, $b2bc56c6c0b4e02e$var$ne = /^([ \t]*)/, $b2bc56c6c0b4e02e$var$re = /\\([^\\])/g, $b2bc56c6c0b4e02e$var$ie = / *\n+$/, $b2bc56c6c0b4e02e$var$le = /(?:^|\n)( *)$/, $b2bc56c6c0b4e02e$var$ae = "(?:\\d+\\.)", $b2bc56c6c0b4e02e$var$oe = "(?:[*+-])";
function $b2bc56c6c0b4e02e$var$ce(e) {
    return "( *)(" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + ") +";
}
const $b2bc56c6c0b4e02e$var$se = $b2bc56c6c0b4e02e$var$ce(1), $b2bc56c6c0b4e02e$var$de = $b2bc56c6c0b4e02e$var$ce(2);
function $b2bc56c6c0b4e02e$var$pe(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de));
}
const $b2bc56c6c0b4e02e$var$ue = $b2bc56c6c0b4e02e$var$pe(1), $b2bc56c6c0b4e02e$var$fe = $b2bc56c6c0b4e02e$var$pe(2);
function $b2bc56c6c0b4e02e$var$he(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $b2bc56c6c0b4e02e$var$me = $b2bc56c6c0b4e02e$var$he(1), $b2bc56c6c0b4e02e$var$ge = $b2bc56c6c0b4e02e$var$he(2);
function $b2bc56c6c0b4e02e$var$ye(e) {
    const t = 1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $b2bc56c6c0b4e02e$var$ke = $b2bc56c6c0b4e02e$var$ye(1), $b2bc56c6c0b4e02e$var$xe = $b2bc56c6c0b4e02e$var$ye(2);
function $b2bc56c6c0b4e02e$var$be(e, t) {
    const n = 1 === t, i = n ? $b2bc56c6c0b4e02e$var$ke : $b2bc56c6c0b4e02e$var$xe, l = n ? $b2bc56c6c0b4e02e$var$me : $b2bc56c6c0b4e02e$var$ge, a = n ? $b2bc56c6c0b4e02e$var$ue : $b2bc56c6c0b4e02e$var$fe;
    return {
        match (e, t) {
            const n = $b2bc56c6c0b4e02e$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($b2bc56c6c0b4e02e$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($b2bc56c6c0b4e02e$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($b2bc56c6c0b4e02e$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $b2bc56c6c0b4e02e$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $b2bc56c6c0b4e02e$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $b2bc56c6c0b4e02e$var$Ee = [
    $b2bc56c6c0b4e02e$var$p,
    $b2bc56c6c0b4e02e$var$m,
    $b2bc56c6c0b4e02e$var$g,
    $b2bc56c6c0b4e02e$var$$,
    $b2bc56c6c0b4e02e$var$z,
    $b2bc56c6c0b4e02e$var$w,
    $b2bc56c6c0b4e02e$var$T,
    $b2bc56c6c0b4e02e$var$j,
    $b2bc56c6c0b4e02e$var$me,
    $b2bc56c6c0b4e02e$var$ke,
    $b2bc56c6c0b4e02e$var$ge,
    $b2bc56c6c0b4e02e$var$xe
], $b2bc56c6c0b4e02e$var$Ce = [
    ...$b2bc56c6c0b4e02e$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $b2bc56c6c0b4e02e$var$L,
    $b2bc56c6c0b4e02e$var$B
];
function $b2bc56c6c0b4e02e$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $b2bc56c6c0b4e02e$var$we(e) {
    return $b2bc56c6c0b4e02e$var$q.test(e) ? "right" : $b2bc56c6c0b4e02e$var$W.test(e) ? "center" : $b2bc56c6c0b4e02e$var$Z.test(e) ? "left" : null;
}
function $b2bc56c6c0b4e02e$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $b2bc56c6c0b4e02e$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($b2bc56c6c0b4e02e$var$G, "").split("|").map($b2bc56c6c0b4e02e$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $b2bc56c6c0b4e02e$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $b2bc56c6c0b4e02e$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph
    };
}
function $b2bc56c6c0b4e02e$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $b2bc56c6c0b4e02e$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$b2bc56c6c0b4e02e$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $b2bc56c6c0b4e02e$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $b2bc56c6c0b4e02e$var$Ue(e) {
    return e.replace($b2bc56c6c0b4e02e$var$re, "$1");
}
function $b2bc56c6c0b4e02e$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $b2bc56c6c0b4e02e$var$He = (e, t, n)=>({
        children: $b2bc56c6c0b4e02e$var$De(t, e[1], n)
    });
function $b2bc56c6c0b4e02e$var$Fe() {
    return {};
}
function $b2bc56c6c0b4e02e$var$Pe() {
    return null;
}
function $b2bc56c6c0b4e02e$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $b2bc56c6c0b4e02e$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $b2bc56c6c0b4e02e$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $b2bc56c6c0b4e02e$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $b2bc56c6c0b4e02e$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $b2bc56c6c0b4e02e$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $b2bc56c6c0b4e02e$var$t({}, n, l, {
            className: $b2bc56c6c0b4e02e$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($b2bc56c6c0b4e02e$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $b2bc56c6c0b4e02e$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($b2bc56c6c0b4e02e$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $5uXOq.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($b2bc56c6c0b4e02e$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($b2bc56c6c0b4e02e$var$O) && (e = e.replace($b2bc56c6c0b4e02e$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $b2bc56c6c0b4e02e$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($b2bc56c6c0b4e02e$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($b2bc56c6c0b4e02e$var$L.test(p) || $b2bc56c6c0b4e02e$var$B.test(p)) && (n[d] = $5uXOq.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$b2bc56c6c0b4e02e$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $b2bc56c6c0b4e02e$export$3e2338ea76b578c9, i.slugify = i.slugify || $b2bc56c6c0b4e02e$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $b2bc56c6c0b4e02e$var$t({}, $b2bc56c6c0b4e02e$var$a, i.namedCodesToUnicode) : $b2bc56c6c0b4e02e$var$a, i.createElement = i.createElement || $5uXOq.createElement;
    const Z = [], q = {}, Q = {
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.blockQuote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($b2bc56c6c0b4e02e$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakLine]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$f),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakThematic]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$h),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeFenced]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeInline]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnoteReference]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $b2bc56c6c0b4e02e$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.gfmTask]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading]: {
            match: $b2bc56c6c0b4e02e$var$Be(i.enforceAtxHeadings ? $b2bc56c6c0b4e02e$var$w : $b2bc56c6c0b4e02e$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[2], n),
                    id: i.slugify(e[2], $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.headingSetext]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($b2bc56c6c0b4e02e$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $b2bc56c6c0b4e02e$var$Ce.some((e)=>e.test(c)) ? $b2bc56c6c0b4e02e$var$Ne : $b2bc56c6c0b4e02e$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $b2bc56c6c0b4e02e$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlComment]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$T),
            order: 1,
            parse: ()=>({}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.image]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$je(t, e[1], n),
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $b2bc56c6c0b4e02e$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                };
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList]: $b2bc56c6c0b4e02e$var$be(d, 1),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.unorderedList]: $b2bc56c6c0b4e02e$var$be(d, 2),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$k),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: ()=>"\n"
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph]: {
            match: $b2bc56c6c0b4e02e$var$Re,
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.ref]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refImage]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refLink]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$j),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($b2bc56c6c0b4e02e$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textBolded]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEmphasized]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEscaped]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textMarked]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$J),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$K),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock], delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($b2bc56c6c0b4e02e$var$x, "\n").replace($b2bc56c6c0b4e02e$var$S, "").replace($b2bc56c6c0b4e02e$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $b2bc56c6c0b4e02e$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $b2bc56c6c0b4e02e$var$n);
    return $5uXOq.cloneElement($b2bc56c6c0b4e02e$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("lha8j", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeContentBox", () => $6756a4fad22145cd$export$481db495d3b96c87);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");
const $6756a4fad22145cd$export$481db495d3b96c87 = ({ children: children, footer: footer, illustration: illustration })=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: "transition-home-content-box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $6756a4fad22145cd$var$wrapperInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        grow: "fill",
        alignInline: "center",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6756a4fad22145cd$var$leftBoxStyles,
        padding: "space.300"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.300",
        xcss: $6756a4fad22145cd$var$illustrationWrapperBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center"
    }, illustration))), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.300",
        paddingBlockStart: "space.0"
    }, footer))));
};
const $6756a4fad22145cd$var$leftBoxStyles = (0, $8CUq3.xcss)({
    width: '100%'
});
const $6756a4fad22145cd$var$illustrationWrapperBoxStyles = (0, $8CUq3.xcss)({
    width: '320px',
    flexShrink: 0
});
const $6756a4fad22145cd$var$wrapperInlineStyles = (0, $8CUq3.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderRadius: 'border.radius.200'
});

});

parcelRegister("3V4J8", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeHeader", () => $4f3218852f667a7b$export$60dbab4e777fdf3e);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $luBm6 = parcelRequire("luBm6");
const $4f3218852f667a7b$export$60dbab4e777fdf3e = ({ title: title, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h1",
        size: "large"
    }, title), description);

});

parcelRegister("5JunY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40f259f6898d233f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $40f259f6898d233f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    notCompletedTaskCountNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.not-completed-task-count-non-final",
        "defaultMessage": "{count, plural, one {{count} task} other {{count} tasks}} left"
    },
    taskTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.task-title-non-final",
        "defaultMessage": "Things to do"
    },
    usersAndRolesTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.users-and-roles-title-non-final",
        "defaultMessage": "Users and roles"
    },
    usersAndRolesDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.users-and-roles-description-non-final",
        "defaultMessage": "Learn how to manage users and roles, and resolve any detected errors to ensure your team members have access to Jira Service Management."
    },
    alertsTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.alerts-title-non-final",
        "defaultMessage": "Alerts"
    },
    alertsAndOnCallTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.alerts-and-on-call-title-non-final",
        "defaultMessage": "Alerts and on-call"
    },
    alertsDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.alerts-description-non-final",
        "defaultMessage": "Check out what's new in the redesigned alerting experience in Jira Service Management."
    },
    notificationsTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.notifications-title-non-final",
        "defaultMessage": "Notifications"
    },
    notificationsDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.notifications-description-non-final",
        "defaultMessage": "Learn about the changes to your notifications, and set up Jira Cloud as your primary contact method for push notifications."
    },
    teamsTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.teams-title-non-final",
        "defaultMessage": "Launch operations for your team"
    },
    teamsDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.teams-description-non-final",
        "defaultMessage": "Discover how to launch and manage operations for your teams in Jira Service Management."
    },
    chatToolsTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.chat-tools-title-non-final",
        "defaultMessage": "Chat tools"
    },
    chatToolsDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.chat-tools-description-non-final",
        "defaultMessage": "Learn how chat tools help with alerting, and set up your Opsgenie chat integrations in Jira Service Management."
    },
    automateAlertAndIncidentResponseTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.automate-alert-and-incident-response-title-non-final",
        "defaultMessage": "Automate your alert and incident response"
    },
    automateAlertAndIncidentResponseDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.automate-alert-and-incident-response-description-non-final",
        "defaultMessage": "Learn how to set up automation for your alerts and incidents in Jira Service Management."
    },
    integrationsTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.integrations-title-non-final",
        "defaultMessage": "Integrations"
    },
    integrationsDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.integrations-description-non-final",
        "defaultMessage": "Learn where to find your alerting integrations and how to manage them in Jira Service Management."
    },
    deprecatedOnesTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.deprecated-ones-title-non-final",
        "defaultMessage": "What's left behind in Opsgenie"
    },
    deprecatedOnesDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.deprecated-ones-description-non-final",
        "defaultMessage": "Review which parts of Opsgenie aren't moving to Jira Service Management."
    },
    heartbeatsTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.heartbeats-title-non-final",
        "defaultMessage": "Heartbeats"
    },
    heartbeatsDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.heartbeats-description-non-final",
        "defaultMessage": "Learn how to manage your heartbeats in Jira Service Management."
    },
    findWhatYouAreLookingForTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.find-what-you-are-looking-for-title-non-final",
        "defaultMessage": "Find what you're looking for"
    },
    findWhatYouAreLookingForDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.find-what-you-are-looking-for-description-non-final",
        "defaultMessage": "View a list of shortcuts for you to quickly navigation between your operations work in Jira Service Management."
    },
    incidentsTitleNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.incidents-title-non-final",
        "defaultMessage": "Incidents"
    },
    incidentsDescriptionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.step.incidents-description-non-final",
        "defaultMessage": "Check out how the incident management experience looks like in Jira Service Management."
    }
});

});

parcelRegister("1fGbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc3579b46894835a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fc3579b46894835a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    preventPushTitleNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.prevent-push-title-non-final",
        "defaultMessage": "Prevent push notifications from Opsgenie mobile app"
    },
    deleteOgContactMethodsTitleNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.delete-og-contact-methods-title-non-final",
        "defaultMessage": "Delete your Opsgenie contact methods"
    },
    contactMethodTitleNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.contact-method-title-non-final",
        "defaultMessage": "Keep your contact methods up to date"
    },
    usersAndRolesTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.users-and-roles-task-one-non-final",
        "defaultMessage": "How to manage users and roles"
    },
    usersAndRolesTaskTwoV2NonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.users-and-roles-task-two-v2-non-final",
        "defaultMessage": "{count, plural, =0 {All Opsgenie admins are now \u201COperations global admins\u201D} one {{count} Opsgenie admin has been assigned the Operations global admin role} other {{count} Opsgenie admins have been assigned the Operations global admin role}}"
    },
    usersAndRolesTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.users-and-roles-task-two-non-final",
        "defaultMessage": "{count, plural, =0 {All Opsgenie admins now have the product admin role} one {{count} Opsgenie admin doesn't have the product admin role} other {{count} Opsgenie admins don't have the product admin role}}"
    },
    usersAndRolesTaskThreeNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.users-and-roles-task-three-non-final",
        "defaultMessage": "{count, plural, =0 {All Opsgenie users now have a product role} one {{count} Opsgenie user no longer have custom roles} other {{count} Opsgenie users no longer have custom roles}}"
    },
    usersAndRolesTaskFourNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.users-and-roles-task-four-non-final",
        "defaultMessage": "Stakeholders are now in Jira Service Management"
    },
    alertsTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.alerts-task-one-non-final",
        "defaultMessage": "Meet the redesigned alerts on Jira"
    },
    alertsTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.alerts-task-two-non-final",
        "defaultMessage": "Where to find your alerts"
    },
    alertsTaskThreeNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.alerts-task-three-non-final",
        "defaultMessage": "What happens to Opsgenie alerts"
    },
    alertsTaskFourNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.alerts-task-four-non-final",
        "defaultMessage": "How to check and manage your on-call schedules"
    },
    notificationsTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.notifications-task-one-non-final",
        "defaultMessage": "How to manage your alert notifications"
    },
    notificationsTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.notifications-task-two-non-final",
        "defaultMessage": "Add Jira Cloud mobile app as your notification method"
    },
    notificationsTaskThreeNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.notifications-task-three-non-final",
        "defaultMessage": "Prevent duplicate notifications from Opsgenie mobile app"
    },
    teamsTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.teams-task-one-non-final",
        "defaultMessage": "Why launch operations for your team"
    },
    teamsTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.teams-task-two-non-final",
        "defaultMessage": "Opsgenie teams are now in Jira Service Management"
    },
    chatToolsTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.chat-tools-task-one-non-final",
        "defaultMessage": "How chat tools help with alerting"
    },
    chatToolsTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.chat-tools-task-two-non-final",
        "defaultMessage": "Connect your chat tools with Jira Service Management"
    },
    chatToolsTaskThreeNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.chat-tools-task-three-non-final",
        "defaultMessage": "Copy your Opsgenie chat integrations to Jira Service Management"
    },
    chatToolsTaskFourNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.chat-tools-task-four-non-final",
        "defaultMessage": "Prevent duplicate notifications from Opsgenie chat integrations"
    },
    automateAlertsAndIncidentResponseTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.automate-alerts-and-incident-response-task-one-non-final",
        "defaultMessage": "Recreate Opsgenie alert actions and incident rules in Jira"
    },
    automateAlertsAndIncidentResponseTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.automate-alerts-and-incident-response-task-two-non-final",
        "defaultMessage": "Delete your Opsgenie actions and incident rules"
    },
    integrationsTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.integrations-task-one-non-final",
        "defaultMessage": "Where to find your integrations"
    },
    integrationsTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.integrations-task-two-non-final",
        "defaultMessage": "Syncing your alerts with software and service projects"
    },
    integrationsTaskThreeNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.integrations-task-three-non-final",
        "defaultMessage": "Integrations unavailable for addition in Jira Service Management"
    },
    integrationsTaskFourNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.integrations-task-four-non-final",
        "defaultMessage": "Integrations left behind in Opsgenie"
    },
    integrationsTaskFiveNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.integrations-task-five-non-final",
        "defaultMessage": "Incoming call routing"
    },
    deprecatedOnesTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.deprecated-ones-task-one-non-final",
        "defaultMessage": "{deprecatedFeaturesCount, plural, one {{deprecatedFeaturesCount} feature is} other {{deprecatedFeaturesCount} features are}} left behind in Opsgenie"
    },
    heartbeatsTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.heartbeats-task-one-non-final",
        "defaultMessage": "Use the updated heartbeats' address in your systems"
    },
    heartbeatsTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.heartbeats-task-two-non-final",
        "defaultMessage": "Outdated heartbeats won't sync to Jira Service Management"
    },
    heartbeatsTaskThreeNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.heartbeats-task-three-non-final",
        "defaultMessage": "Remove excess heartbeats"
    },
    incidentsTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.incidents-task-one-non-final",
        "defaultMessage": "Find your Opsgenie incidents in Jira Service Management"
    },
    incidentsTaskTwoNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.incidents-task-two-non-final",
        "defaultMessage": "Incident status and priority in Jira Service Management"
    },
    incidentsTaskThreeNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.incidents-task-three-non-final",
        "defaultMessage": "4 incident features are left behind in Opsgenie"
    },
    incidentsTaskFourNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.incidents-task-four-non-final",
        "defaultMessage": "Copy new Opsgenie incidents to Jira Service Management"
    },
    incidentsTaskFourSuccessNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.incidents-task-four-success-non-final",
        "defaultMessage": "You've successfully copied your incidents to Jira"
    },
    findWhatYouAreLookingForTaskOneNonFinal: {
        "id": "eoc-changeboarding.common.utils.tasks.find-what-you-are-looking-for-task-one-non-final",
        "defaultMessage": "Navigate to your work quickly"
    }
});

});

parcelRegister("kgVQv", function(module, exports) {
module.exports = new URL("alerts-task-four-illustration.dd0ac676.png", import.meta.url).toString();

});

parcelRegister("fqVln", function(module, exports) {
module.exports = new URL("alerts-task-two-illustration-dark.37c696ca.png", import.meta.url).toString();

});

parcelRegister("3tlnn", function(module, exports) {
module.exports = new URL("alerts-task-two-illustration.b55d1dc4.png", import.meta.url).toString();

});

parcelRegister("glWMa", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2e0ef16f157e54f9$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2e0ef16f157e54f9$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    taskOneDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.alerts-step.task-one-description-non-final",
        "defaultMessage": "\nWe've completely redesigned alerts to look and work like the way you'd like, so they're just as familiar as everything else on Jira.\n\nNow, Jira's robust design language powers the alert's layout, structure, actions, and details, making it more intuitive for you to work with alerts.\n\nTake a look at it yourself by viewing your alerts.\n        "
    },
    taskOneButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.alerts-step.task-one-button-non-final",
        "defaultMessage": "View your alerts"
    },
    taskTwoDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.alerts-step.task-two-description-non-final",
        "defaultMessage": "\nTo view your alerts, select **Your work** from Jira navigation and select **Alerts.**\nYou can also access your alerts from the **Alerts widget** on the **Your work** page.\n\nWant to create alerts yourself? Select **Create alert** from **More actions** on the **Alerts** page.\n        "
    },
    taskThreeDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.alerts-step.task-three-description-non-final",
        "defaultMessage": "While it's possible for you to work on your alerts on Opsgenie, it will support only critical actions. All of your alert, on-call, and incident response data from Opsgenie are now natively available on Jira Service Management, so you won't have to log in to Opsgenie."
    },
    taskFourDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.alerts-step.task-four-description-non-final",
        "defaultMessage": "\nYou can check your current on-call status and schedule times from the **On-call schedules** widget on the **Your work page**. Select **View all** to get a view of your on-call times and browse all the schedules.\n        "
    },
    taskFourButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.alerts-step.task-four-button-non-final",
        "defaultMessage": "View your on-call schedules"
    }
});

});


parcelRegister("9BvDp", function(module, exports) {

$parcel$export(module.exports, "AutomateAlertAndIncidentResponseStep", () => $b23b5138b6b54c34$export$790d637e6bc9f322);

var $5uXOq = parcelRequire("5uXOq");

var $flpap = parcelRequire("flpap");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $5qRwM = parcelRequire("5qRwM");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");

var $7q5TP = parcelRequire("7q5TP");
parcelRequire("9oHid");
var $dzr3b = parcelRequire("dzr3b");

var $koVbs = parcelRequire("koVbs");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $aTClY = parcelRequire("aTClY");

var $lha8j = parcelRequire("lha8j");

var $3V4J8 = parcelRequire("3V4J8");

var $5JunY = parcelRequire("5JunY");

var $1fGbK = parcelRequire("1fGbK");

var $6BT89 = parcelRequire("6BT89");

var $kSGv4 = parcelRequire("kSGv4");
const $b23b5138b6b54c34$export$790d637e6bc9f322 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isPrimaryAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { opsgenieBaseUrl: opsgenieBaseUrl } = (0, $6BT89.useGlobalChangeboarding)();
    const ogTeamsUrl = opsgenieBaseUrl ? `${opsgenieBaseUrl}/teams/list` : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3V4J8.TransitionHomeHeader), {
        title: formatMessage((0, $5JunY.messages).automateAlertAndIncidentResponseTitleNonFinal),
        description: formatMessage((0, $5JunY.messages).automateAlertAndIncidentResponseDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            width: "200px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dzr3b))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dzr3b))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $1fGbK.default).automateAlertsAndIncidentResponseTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $aTClY.Anchor)
                }
            }
        }
    }, formatMessage((0, $kSGv4.messages).taskOneDescriptionNonFinal))), (isPrimaryAdmin || isSiteAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "/jira/settings/automation",
        target: "_blank"
    }, formatMessage((0, $kSGv4.messages).taskOneButtonNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            width: "163px",
            src: (0, $7q5TP.srcLight),
            srcDark: (0, $7q5TP.srcDark),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $1fGbK.default).automateAlertsAndIncidentResponseTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $aTClY.Anchor)
                }
            }
        }
    }, formatMessage((0, $kSGv4.messages).taskTwoDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: ogTeamsUrl,
        target: "_blank"
    }, formatMessage((0, $kSGv4.messages).taskTwoButtonNonFinal))))));
};

});
parcelRegister("9oHid", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9f86978dd20d054$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("dzr3b")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("dzr3b")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 3p3pcq5wm596jjft2hqxn3jk
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/3p3pcq5wm596jjft2hqxn3jk

var $dCLgq = parcelRequire("dCLgq");

var $dzr3b = parcelRequire("dzr3b");
const $f9f86978dd20d054$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($dzr3b)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($dzr3b))
});
var $f9f86978dd20d054$export$2e2bcd8739ae039 = $f9f86978dd20d054$var$Illustration;
// for advanced use only
const $f9f86978dd20d054$export$a179c88182cb9d56 = [
    0,
    0,
    264,
    212
];

});
parcelRegister("dzr3b", function(module, exports) {
module.exports = new URL("complex-window.3a2a7b13.svg", import.meta.url).toString();

});


parcelRegister("aTClY", function(module, exports) {

$parcel$export(module.exports, "Anchor", () => $40857484b55e4b26$export$b688253958b8dfe7);

var $5uXOq = parcelRequire("5uXOq");

var $jhmo0 = parcelRequire("jhmo0");
const $40857484b55e4b26$export$b688253958b8dfe7 = ({ children: children, href: href })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: href,
        target: "_blank"
    }, children);

});

parcelRegister("kSGv4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4f81359fa6d762cc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4f81359fa6d762cc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    taskOneDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.automate-alert-and-incident-response-step.task-one-description-non-final",
        "defaultMessage": "Your Opsgenie actions and incident rules aren't automatically moved to Jira Service Management.\n\nYou can easily recreate them using Jira Automation's vast library of rule templates and components. [Read how to recreate Opsgenie actions and rules with Jira automation](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Automation)\n"
    },
    taskOneButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.automate-alert-and-incident-response-step.task-one-button-non-final",
        "defaultMessage": "Go to Jira automation"
    },
    taskTwoDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.automate-alert-and-incident-response-step.task-two-description-non-final",
        "defaultMessage": "To avoid conflict between Opsgenie and Jira, delete your teams' Opsgenie actions and incident rules in Opsgenie. It's recommended to do this after setting up your automation in Jira.\n\nIn your Opsgenie team, select **Actions** and **Incident rules** and delete all the action channels, actions, and incident rules permanently. [Read how to delete Opsgenie actions and incidents rules](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Automation)\n"
    },
    taskTwoButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.automate-alert-and-incident-response-step.task-two-button-non-final",
        "defaultMessage": "Go to teams in Opsgenie"
    }
});

});


parcelRegister("i9P4n", function(module, exports) {

$parcel$export(module.exports, "ChatToolsStep", () => $2b3182241315c9f2$export$39c402b7954418b);

var $5uXOq = parcelRequire("5uXOq");

var $flpap = parcelRequire("flpap");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");

var $2JXc1 = parcelRequire("2JXc1");

var $fPTxR = parcelRequire("fPTxR");

var $c0pCS = parcelRequire("c0pCS");

var $ePSTF = parcelRequire("ePSTF");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $itmJb = parcelRequire("itmJb");

var $aTClY = parcelRequire("aTClY");

var $lha8j = parcelRequire("lha8j");

var $3V4J8 = parcelRequire("3V4J8");

var $5JunY = parcelRequire("5JunY");

var $1fGbK = parcelRequire("1fGbK");

var $6BT89 = parcelRequire("6BT89");

var $4iQaI = parcelRequire("4iQaI");

var $jbwqm = parcelRequire("jbwqm");

var $gW8Uf = parcelRequire("gW8Uf");

var $U6d3c = parcelRequire("U6d3c");

var $QWB3s = parcelRequire("QWB3s");
const $2b3182241315c9f2$export$39c402b7954418b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isPrimaryAdmin = (0, $itmJb.useIsAdmin)();
    const [{ isTeamAdmin: isTeamAdmin }] = (0, $jbwqm.useIsTeamAdmin)();
    const [connections] = (0, $4iQaI.useChatToolsConnections)();
    const [integrations] = (0, $4iQaI.useChatToolsIntegrations)();
    if (!connections.data && !isTeamAdmin) throw new Error('ChatToolsStep should be rendered when chat tools connections are loaded');
    const { opsgenieBaseUrl: opsgenieBaseUrl } = (0, $6BT89.useGlobalChangeboarding)();
    const ogTeamsUrl = opsgenieBaseUrl ? `${opsgenieBaseUrl}/teams/list` : '';
    const ogIntegrationsUrl = opsgenieBaseUrl ? `${opsgenieBaseUrl}/settings/integrations/` : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3V4J8.TransitionHomeHeader), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).chatToolsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).chatToolsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fPTxR.default), {
            alt: "",
            width: 100
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).chatToolsTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $aTClY.Anchor)
                }
            }
        }
    }, formatMessage((0, $QWB3s.messages).taskOneDescriptionNonFinal))))), isPrimaryAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JXc1.default), {
            width: 100,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).chatToolsTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $QWB3s.messages).taskTwoDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "/jira/settings/products/ops/jira-service-management-chatops-and-video-tools",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $QWB3s.messages).taskTwoActionButtonNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockStart: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gW8Uf.ConnectChatToolsTable), {
        connections: connections
    })))), (integrations.data?.count || 0) > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0pCS.default), {
            alt: "",
            width: 100
        }),
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingBlockStart: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $U6d3c.CopyIntegrationsTable), {
            integrations: integrations
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).chatToolsTaskThreeNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $QWB3s.messages).taskThreeDescriptionNonFinal))), isPrimaryAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "/jira/settings/products/ops/integrations",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $QWB3s.messages).taskThreeActionButtonNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePSTF.default), {
            width: 100,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).chatToolsTaskFourNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage(isTeamAdmin ? (0, $QWB3s.messages).taskFourTeamAdminDescriptionNonFinal : (0, $QWB3s.messages).taskFourDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: isTeamAdmin ? ogTeamsUrl : ogIntegrationsUrl,
        target: "_blank"
    }, formatMessage(isTeamAdmin ? (0, $QWB3s.messages).taskFourTeamAdminActionButtonNonFinal : (0, $QWB3s.messages).taskFourActionButtonNonFinal))))));
};

});
parcelRegister("2JXc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5d3fe7c3133ec07$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = mmwr66tqxzps49fhmn4694w
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/mmwr66tqxzps49fhmn4694w

var $dCLgq = parcelRequire("dCLgq");

var $2HwhE = parcelRequire("2HwhE");

var $6tR6E = parcelRequire("6tR6E");
const $c5d3fe7c3133ec07$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6tR6E)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2HwhE))
});
var $c5d3fe7c3133ec07$export$2e2bcd8739ae039 = $c5d3fe7c3133ec07$var$Illustration;
// for advanced use only
const $c5d3fe7c3133ec07$export$a179c88182cb9d56 = [
    0,
    0,
    191,
    222
];

});
parcelRegister("2HwhE", function(module, exports) {
module.exports = new URL("lock-closed-darkmode.26d51607.svg", import.meta.url).toString();

});

parcelRegister("6tR6E", function(module, exports) {
module.exports = new URL("lock-closed.22dbfd6e.svg", import.meta.url).toString();

});


parcelRegister("fPTxR", function(module, exports) {

$parcel$export(module.exports, "default", () => $de9c146d819a9967$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 5brnpzkmsmk379qcw4nzxktj
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/5brnpzkmsmk379qcw4nzxktj

var $dCLgq = parcelRequire("dCLgq");

var $gVD9S = parcelRequire("gVD9S");

var $2YVUK = parcelRequire("2YVUK");
const $de9c146d819a9967$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($2YVUK)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gVD9S))
});
var $de9c146d819a9967$export$2e2bcd8739ae039 = $de9c146d819a9967$var$Illustration;
// for advanced use only
const $de9c146d819a9967$export$a179c88182cb9d56 = [
    0,
    0,
    231,
    191
];

});
parcelRegister("gVD9S", function(module, exports) {
module.exports = new URL("chat-darkmode.d567d134.svg", import.meta.url).toString();

});

parcelRegister("2YVUK", function(module, exports) {
module.exports = new URL("chat.06e18536.svg", import.meta.url).toString();

});


parcelRegister("c0pCS", function(module, exports) {

$parcel$export(module.exports, "default", () => $13c06f385dee05ab$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = q4j47tscp9jf77b93smc2h6r
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/q4j47tscp9jf77b93smc2h6r

var $dCLgq = parcelRequire("dCLgq");

var $7jf3m = parcelRequire("7jf3m");
const $13c06f385dee05ab$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($7jf3m)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($7jf3m))
});
var $13c06f385dee05ab$export$2e2bcd8739ae039 = $13c06f385dee05ab$var$Illustration;
// for advanced use only
const $13c06f385dee05ab$export$a179c88182cb9d56 = [
    0,
    0,
    207,
    227
];

});
parcelRegister("7jf3m", function(module, exports) {
module.exports = new URL("download.61c2405e.svg", import.meta.url).toString();

});


parcelRegister("ePSTF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9557dc0b9b6a7341$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 4gngnxb7cxjb44cjfmnzf923
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/4gngnxb7cxjb44cjfmnzf923

var $dCLgq = parcelRequire("dCLgq");

var $7XcLV = parcelRequire("7XcLV");
const $9557dc0b9b6a7341$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($7XcLV)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($7XcLV))
});
var $9557dc0b9b6a7341$export$2e2bcd8739ae039 = $9557dc0b9b6a7341$var$Illustration;
// for advanced use only
const $9557dc0b9b6a7341$export$a179c88182cb9d56 = [
    0,
    0,
    220,
    192
];

});
parcelRegister("7XcLV", function(module, exports) {
module.exports = new URL("settings.9bfa4562.svg", import.meta.url).toString();

});


parcelRegister("gW8Uf", function(module, exports) {

$parcel$export(module.exports, "ConnectChatToolsTable", () => $f3b0d3606a5cebce$export$67c29319faef998a);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $k3qRI = parcelRequire("k3qRI");

var $6tRzQ = parcelRequire("6tRzQ");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $ousew = parcelRequire("ousew");

var $fjrC9 = parcelRequire("fjrC9");

var $8RZaz = parcelRequire("8RZaz");

var $bqRub = parcelRequire("bqRub");
const $f3b0d3606a5cebce$export$67c29319faef998a = ({ connections: connections })=>{
    if (!connections.data) throw new Error('ConnectChatToolsTable should be rendered when chat tools connections are loaded');
    const rows = connections.data.values.map((item, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-workspace`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        paddingInlineStart: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p",
                        maxLines: 1
                    }, item.chatSpaceName))
                },
                {
                    key: `cell-${index}-product`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                        space: "space.100",
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                        size: "xsmall",
                        src: item.chatSpaceType === 'slack' ? (0, $fjrC9.SLACK_IMAGE_URL) : (0, $fjrC9.MST_IMAGE_URL)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p",
                        maxLines: 1
                    }, item.chatSpaceType === 'slack' ? (0, $fjrC9.SLACK_TEXT) : (0, $fjrC9.MST_TEXT)))
                },
                {
                    key: `cell-${index}-status`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                        space: "space.050",
                        alignBlock: "center",
                        alignInline: "center",
                        xcss: $f3b0d3606a5cebce$var$inlineStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8RZaz.Action), {
                        item: item
                    }))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'workspace-or-tenant',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bqRub.messages).chatToolsConnectTableWorkspaceHeadNonFinal)),
                isSortable: true
            },
            {
                key: 'product',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bqRub.messages).chatToolsConnectTableProductHeadNonFinal)
            },
            {
                key: 'status',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                    space: "space.050",
                    alignInline: "center",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bqRub.messages).chatToolsConnectTableStatusHeadNonFinal), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    position: "top",
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $bqRub.messages).chatToolsConnectTableStatusHeadTooltipNonFinal)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $f3b0d3606a5cebce$var$infoIconBoxStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
                    LEGACY_size: "small",
                    label: ""
                }))))
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3qRI.default), {
        isLoading: connections.loading,
        isFixedSize: true,
        head: head,
        rows: rows,
        rowsPerPage: 5,
        defaultPage: 1
    });
};
const $f3b0d3606a5cebce$var$infoIconBoxStyles = (0, $8CUq3.xcss)({
    height: 'size.100'
});
const $f3b0d3606a5cebce$var$inlineStyles = (0, $8CUq3.xcss)({
    height: 'size.400',
    cursor: 'default'
});

});
parcelRegister("k3qRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e4f0159aa1c87c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $gS5Cm = parcelRequire("gS5Cm");

var $dHbUn = parcelRequire("dHbUn");
class $60e4f0159aa1c87c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $eGmKJ.default),
            onSort: (0, $eGmKJ.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dHbUn.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args), this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        }, this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        }, this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        }, this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        }, this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $gS5Cm.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("gS5Cm", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $7f55105045703159$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $7f55105045703159$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $7f55105045703159$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $7f55105045703159$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $7f55105045703159$export$c476bbe5da59992d);
const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("dHbUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb6422faa785b221$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $VSDnB = parcelRequire("VSDnB");


var $gS5Cm = parcelRequire("gS5Cm");

var $hiWL0 = parcelRequire("hiWL0");

var $kF3yx = parcelRequire("kF3yx");

var $fkvnY = parcelRequire("fkvnY");

var $hK8cd = parcelRequire("hK8cd");

var $dDBI6 = parcelRequire("dDBI6");

var $dk72m = parcelRequire("dk72m");

var $50Tma = parcelRequire("50Tma");

var $jlnvO = parcelRequire("jlnvO");
function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
            return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
        case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
            return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $eGmKJ.default), onSort: providedOnSort = (0, $eGmKJ.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $eGmKJ.default), onRankEnd: providedOnRankEnd = (0, $eGmKJ.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: (0, $VSDnB.fg)('eax-1131_fix_a11y_issues_global_issues_settings') ? 'Previous Page' : 'Previous',
    next: (0, $VSDnB.fg)('eax-1131_fix_a11y_issues_global_issues_settings') ? 'Next Page' : 'Next',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
    const tableBodyRef = (0, $5uXOq.useRef)(null);
    const onSort = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $5uXOq.useEffect)(()=>{
        (0, $gS5Cm.validateSortKey)(sortKey, head);
        (0, $gS5Cm.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $gS5Cm.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kF3yx.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kF3yx.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dk72m.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hiWL0.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hiWL0.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jlnvO.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $2OMIu.jsx)($cb6422faa785b221$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hiWL0.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $50Tma.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dDBI6.default), {
                isLoading: isLoading,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $cb6422faa785b221$var$RankableTableBody = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("hcItm")));
const $cb6422faa785b221$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fkvnY.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hK8cd.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($cb6422faa785b221$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;

});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;

parcelRegister("hiWL0", function(module, exports) {

$parcel$export(module.exports, "Table", () => $3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = null;
const $3b29b0d00cd7b5c6$var$tableStyles = null;
const $3b29b0d00cd7b5c6$var$bodyBorder = null;
const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1on0"
        ]),
        children: children
    });
});
const $3b29b0d00cd7b5c6$var$captionStyles = null;
const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("caption", {
        className: (0, $bwpsq.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = null;
const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("kF3yx", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $0852c529eaab7231$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $0852c529eaab7231$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0852c529eaab7231$var$fixedHeightStyles = null;
const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $bwpsq.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $0852c529eaab7231$var$emptyViewContainerStyles = null;
const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $bwpsq.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("fkvnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $32bba7afdbc8736a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7bJDt = parcelRequire("7bJDt");

var $ggqAE = parcelRequire("ggqAE");
class $32bba7afdbc8736a$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ggqAE.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $32bba7afdbc8736a$var$Body = (0, $7bJDt.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($32bba7afdbc8736a$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;

});
parcelRegister("7bJDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc6eeecb3dc05edd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $gS5Cm = parcelRequire("gS5Cm");
const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $gS5Cm.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $gS5Cm.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("ggqAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $136b57fea50cecd2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1g0dL = parcelRequire("1g0dL");

var $d9WgS = parcelRequire("d9WgS");
const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d9WgS.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $1g0dL.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;

});
parcelRegister("1g0dL", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $11c3ea74eda01ab8$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9GQPi = parcelRequire("9GQPi");
const $11c3ea74eda01ab8$var$fixedSizeTruncateStyles = null;
const $11c3ea74eda01ab8$var$overflowTruncateStyles = null;
const $11c3ea74eda01ab8$var$truncationWidthStyles = null;
const $11c3ea74eda01ab8$var$cellStyles = null;
const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("9GQPi", function(module, exports) {

$parcel$export(module.exports, "getTruncationStyleVars", () => $99c9652c1fab2b08$export$5e6497a652ae30b5);
const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("d9WgS", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $ba9cb59faf06ce7f$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ba9cb59faf06ce7f$var$rowStyles = null;
const $ba9cb59faf06ce7f$var$rowBackgroundStyles = null;
const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = null;
const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_bfhk1w7a _1ygbi9un _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("hK8cd", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $883137116243a6a0$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $883137116243a6a0$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("dDBI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4b90b361173610$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $lLAKY = parcelRequire("lLAKY");
class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lLAKY.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLAKY.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lLAKY.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("lLAKY", function(module, exports) {

$parcel$export(module.exports, "Container", () => $d0e2766ad96d94ad$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $d0e2766ad96d94ad$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $d0e2766ad96d94ad$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
const $d0e2766ad96d94ad$var$containerStyles = null;
const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $d0e2766ad96d94ad$var$contentsContainerStyles = null;
const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $bwpsq.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $d0e2766ad96d94ad$var$spinnerContainerStyles = null;
const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("dk72m", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba39c903b39a83b1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $4xXH4 = parcelRequire("4xXH4");
class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4xXH4.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4xXH4.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4xXH4.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("4xXH4", function(module, exports) {

$parcel$export(module.exports, "Container", () => $48301faf1109874f$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $48301faf1109874f$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $48301faf1109874f$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $48301faf1109874f$var$containerStyles = null;
const $48301faf1109874f$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $48301faf1109874f$var$spinnerBackdropStyles = null;
const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $bwpsq.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $48301faf1109874f$var$spinnerContainerStyles = null;
const $48301faf1109874f$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("50Tma", function(module, exports) {

$parcel$export(module.exports, "default", () => $21d5ee5c6331aeb9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $xBgAj = parcelRequire("xBgAj");
class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $xBgAj.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("xBgAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aaadfaafd170b3c$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $33etG = parcelRequire("33etG");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $5HBW9 = parcelRequire("5HBW9");

var $15F6T = parcelRequire("15F6T");

var $lmPue = parcelRequire("lmPue");

var $fc5SA = parcelRequire("fc5SA");

var $gRWrA = parcelRequire("gRWrA");
const $8aaadfaafd170b3c$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $8aaadfaafd170b3c$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))) : (0, (/*@__PURE__*/$parcel$interopDefault($6s76W)));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: $8aaadfaafd170b3c$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        })
    });
}
function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, $fc5SA.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $fc5SA.emptyObject), max: max = 7, onChange: onChange = (0, $eGmKJ.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $lmPue.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $33etG.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$8aaadfaafd170b3c$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
            as: "li",
            xcss: $8aaadfaafd170b3c$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $15F6T.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $8aaadfaafd170b3c$var$styles.paginationMenu,
                    children: (0, $gRWrA.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5HBW9.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($8aaadfaafd170b3c$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $8aaadfaafd170b3c$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;

});
parcelRegister("fmJTX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8f114aeec843a8c754b38083d324c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));

var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
function $b2fc843461eabf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
    }, props));
$b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;

});
parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default,
        iconType: "utility"
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9d13c7d9aac3b58cfed9b747dada0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default,
        iconType: "utility"
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("5HBW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63acbbc2953d9b5a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("15F6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $097dd42f19f41562$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("lmPue", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d144cd0d91a90ab$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $jldZL = parcelRequire("jldZL");
const $3d144cd0d91a90ab$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "li",
        testId: testId,
        xcss: $3d144cd0d91a90ab$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dS3PR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jldZL.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("fc5SA", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $cbef1c2cfb373aca$export$3f860eba1218f8d3);
const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};

});

parcelRegister("gRWrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $48fbac64848b775a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;

});



parcelRegister("jlnvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $097ee65829e33b82$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $gS5Cm = parcelRequire("gS5Cm");

var $9Ooyy = parcelRequire("9Ooyy");

var $a41RA = parcelRequire("a41RA");

var $7gEwE = parcelRequire("7gEwE");

var $dpXLF = parcelRequire("dpXLF");

var $BQUUh = parcelRequire("BQUUh");
class $097ee65829e33b82$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $gS5Cm.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $gS5Cm.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponentOld = isRankable ? (0, $7gEwE.default) : (0, $BQUUh.default);
        const HeadCellComponent = isRankable ? (0, $a41RA.default) : (0, $dpXLF.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return (0, $VSDnB.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index) : /*#__PURE__*/ (0, $2OMIu.jsx)(HeadCellComponentOld, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        onClick: isSortable ? onSort(cell) : undefined,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;

});
parcelRegister("9Ooyy", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e002e0403dc403bb$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e002e0403dc403bb$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");



var $9GQPi = parcelRequire("9GQPi");
const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e002e0403dc403bb$var$rankingStyles = null;
const $e002e0403dc403bb$var$headStyles = null;
const $e002e0403dc403bb$var$overflowTruncateStyles = null;
const $e002e0403dc403bb$var$truncationWidthStyles = null;
const $e002e0403dc403bb$var$fixedSizeTruncateStyles = null;
const $e002e0403dc403bb$var$cellStyles = null;
const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $bwpsq.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $e002e0403dc403bb$var$headCellBaseStyles = null;
const $e002e0403dc403bb$var$headCellBaseStylesOld = null;
const $e002e0403dc403bb$var$onClickStyles = null;
const $e002e0403dc403bb$var$baseStyles = null;
const $e002e0403dc403bb$var$ascendingStyles = null;
const $e002e0403dc403bb$var$descendingStyles = null;
const $e002e0403dc403bb$export$4e8024263ace498b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
    };
    const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    const isVisuallyRefreshed = (0, $VSDnB.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $bwpsq.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            isVisuallyRefreshed ? "_11c8dcr7 _179r1on0 _mqm2glyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbvd8c" : "_11c8dcr7 _179r1on0 _mqm2glyw _t51zglyw _191wglyw _vchhusvi _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4jp4b _1ygbvd8c",
            !isVisuallyRefreshed && onClick && "_irr3yw9d _d0altlke",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            !isVisuallyRefreshed && isSortable && "_173zglyw _pw6dglyw _1xgk3acm _1wfn3acm _y9yonqa1 _997wnqa1 _sklb1l7b _1j091l7b _19w61ule _1w611ule _1hvvidpf _n56nidpf _wyc4idpf _1d4oidpf _no7mstnw _qh32stnw _4b5mb3bt _hn3bb3bt _14gsx0bf _cigmx0bf _c77kvia6 _qzvtu2gc _f473via6 _1fpyidpf _a04fh2mm _xv14glyw _58ej1kw7 _1ay31kw7 _mdbq1kw7 _10pp1kw7 _1yw3ze3t _n2fdze3t _8607ze3t _szhwze3t _1g2wwc43 _ze9fwc43 _1lcgnqa1 _at5qnqa1 _o4d71l7b _npl51l7b _1rp11onz _1iornqa1 _oi051l7b _1ehx1onz _19t8nqa1 _1bog1l7b",
            !isVisuallyRefreshed && isASC && "_c77k1thn _142s94yt",
            !isVisuallyRefreshed && isDESC && "_f4731thn _17x894yt"
        ]),
        children: children
    });
});

});

parcelRegister("a41RA", function(module, exports) {

$parcel$export(module.exports, "default", () => $669a06e89a9827f7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $dpXLF = parcelRequire("dpXLF");
class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dpXLF.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $669a06e89a9827f7$var$RankableTableHeadCell = (0, $cVljL.default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;

});
parcelRegister("cVljL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e49a9b167764eb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dpXLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c80f4a483cfd6a$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cC5ib = parcelRequire("cC5ib");

var $kcHZS = parcelRequire("kcHZS");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $3Lty3 = parcelRequire("3Lty3");
var $dS3PR = parcelRequire("dS3PR");

var $3bDjY = parcelRequire("3bDjY");


var $9Ooyy = parcelRequire("9Ooyy");
const $d9c80f4a483cfd6a$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $d9c80f4a483cfd6a$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o"
};
const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $d9c80f4a483cfd6a$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Lty3.default), {
                onClick: onClick,
                xcss: $d9c80f4a483cfd6a$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                        xcss: isVisibleIconOnlyHeader ? $d9c80f4a483cfd6a$var$styles.hideIconHeaderWrapper : $d9c80f4a483cfd6a$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            size: "small",
                            color: "color.text.subtle",
                            weight: "bold",
                            maxLines: 1,
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                        xcss: isSortIconVisible ? $d9c80f4a483cfd6a$var$styles.sortIconVisibleWrapper : $d9c80f4a483cfd6a$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kcHZS))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cC5ib))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});

parcelRegister("kcHZS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb570e807ab2e210$var$_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb570e807ab2e210$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;

});



parcelRegister("7gEwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $BQUUh = parcelRequire("BQUUh");
class $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BQUUh.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld = (0, $cVljL.default)($5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039 = $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld;

});
parcelRegister("BQUUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bd2f57a58531c0d$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9Ooyy = parcelRequire("9Ooyy");
const $4bd2f57a58531c0d$var$TableHeadCellOld = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable,
        children: isSortable ? /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            type: "button",
            "aria-roledescription": "Sort button",
            children: content
        }) : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4bd2f57a58531c0d$export$2e2bcd8739ae039 = $4bd2f57a58531c0d$var$TableHeadCellOld;

});



parcelRegister("hcItm", function(module, exports) {

let $c8660dfa442bff40$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c8660dfa442bff40$var$load("76n7a"),
    $c8660dfa442bff40$var$load("l253H"),
    $c8660dfa442bff40$var$load("etJKP")
]).then(()=>parcelRequire('4THp8'));

});



parcelRegister("8RZaz", function(module, exports) {

$parcel$export(module.exports, "Action", () => $fd6a8e99ca6e1d49$export$e19cd5f9376f8cee);

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $c2i4s = parcelRequire("c2i4s");

var $c8Oei = parcelRequire("c8Oei");

var $dD7Zc = parcelRequire("dD7Zc");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $ousew = parcelRequire("ousew");

var $4iQaI = parcelRequire("4iQaI");

var $gQQEZ = parcelRequire("gQQEZ");
const $fd6a8e99ca6e1d49$export$e19cd5f9376f8cee = ({ item: item })=>{
    const { authorizeSlackConnection: authorizeSlackConnection, delegateMSTConnection: delegateMSTConnection, authorizeMSTConnection: authorizeMSTConnection, copyMSTAuthorizationLink: copyMSTAuthorizationLink } = (0, $4iQaI.useChatToolsActions)();
    const [{ loadingConnectionId: loadingConnectionId }] = (0, $4iQaI.useChatToolsStore)();
    const isLoading = loadingConnectionId === item.chatSpaceId;
    if (item.status === 'SITE_SETTING_CONFIGURED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        LEGACY_size: "small",
        label: "",
        color: "var(--ds-icon-success, #22A06B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $gQQEZ.messages).chatToolsConnectTableConnectedTextNonFinal));
    if (item.status === 'SITE_SETTING_NOT_PRESENT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        onClick: ()=>{
            if (item.chatSpaceType === 'msteams') delegateMSTConnection(item.chatSpaceId);
            else if (item.chatSpaceType === 'slack') authorizeSlackConnection(item.chatSpaceId);
        },
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $gQQEZ.messages).chatToolsConnectTableConnectButtonTextNonFinal));
    // msteams chat spaces
    if (item.status === 'REDUNDANT_TENANT' && item.chatSpaceType === 'msteams') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $gQQEZ.messages).redundantTenantTooltipNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "center",
        xcss: $fd6a8e99ca6e1d49$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $gQQEZ.messages).redundantTenantTextNonFinal)));
    if (item.status === 'ADMIN_CONSENT_NOT_GRANTED' && item.chatSpaceType === 'msteams') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
                ...props,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                    label: "Error",
                    LEGACY_size: "small"
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                    label: "chevron-down",
                    LEGACY_size: "small",
                    spacing: "compact"
                }),
                isLoading: isLoading,
                ref: triggerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $gQQEZ.messages).givePermissionTextNonFinal))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $gQQEZ.messages).givePermissionTooltipNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>authorizeMSTConnection(item.chatSpaceId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $gQQEZ.messages).givePermissionTextNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $gQQEZ.messages).copyLinkTooltipNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>copyMSTAuthorizationLink(item.chatSpaceId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $gQQEZ.messages).copyLinkTextNonFinal)))));
    // It won't happen, there is a mistake on the BE side chatSpaceType is slack but status is not SITE_SETTING_NOT_PRESENT or SITE_SETTING_CONFIGURED
    return null;
};
const $fd6a8e99ca6e1d49$var$inlineStyles = (0, $8CUq3.xcss)({
    cursor: 'not-allowed'
});

});
parcelRegister("gQQEZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $959f1b20439dc3b2$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $959f1b20439dc3b2$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    chatToolsConnectTableConnectedTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.chat-tools-connect-table-connected-text-non-final",
        "defaultMessage": "Connected"
    },
    chatToolsConnectTableConnectButtonTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.chat-tools-connect-table-connect-button-text-non-final",
        "defaultMessage": "Connect"
    },
    redundantTenantTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.redundant-tenant-text-non-final",
        "defaultMessage": "Can't connect"
    },
    redundantTenantTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.redundant-tenant-tooltip-non-final",
        "defaultMessage": "You've already connected a Microsoft tenant with Jira Service Management."
    },
    givePermissionTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.give-permission-text-non-final",
        "defaultMessage": "Give permission"
    },
    givePermissionTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.give-permission-tooltip-non-final",
        "defaultMessage": "Microsoft Teams Administrator's permission is required to create chats, meetings, and post to channels in Microsoft Teams."
    },
    copyLinkTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.copy-link-text-non-final",
        "defaultMessage": "Copy link"
    },
    copyLinkTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.action.copy-link-tooltip-non-final",
        "defaultMessage": "Share the link with your Teams Administrator to give permission to Jira Service Management."
    }
});

});


parcelRegister("bqRub", function(module, exports) {

$parcel$export(module.exports, "messages", () => $59c3259f451207ca$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $59c3259f451207ca$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    chatToolsConnectTableWorkspaceHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.chat-tools-connect-table-workspace-head-non-final",
        "defaultMessage": "Workspace or tenant"
    },
    chatToolsConnectTableProductHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.chat-tools-connect-table-product-head-non-final",
        "defaultMessage": "Product"
    },
    chatToolsConnectTableStatusHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.chat-tools-connect-table-status-head-non-final",
        "defaultMessage": "Status"
    },
    chatToolsConnectTableStatusHeadTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.connect-chat-tools-table.chat-tools-connect-table-status-head-tooltip-non-final",
        "defaultMessage": "Make sure you're a member of the Slack workspace or Microsoft tenant."
    }
});

});


parcelRegister("U6d3c", function(module, exports) {

$parcel$export(module.exports, "CopyIntegrationsTable", () => $eb106d971363c3ad$export$4d903b39a9b39b21);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $fVnbM = parcelRequire("fVnbM");

var $k3qRI = parcelRequire("k3qRI");

var $7paD5 = parcelRequire("7paD5");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $fjrC9 = parcelRequire("fjrC9");

var $jVIls = parcelRequire("jVIls");

var $aauqn = parcelRequire("aauqn");
const $eb106d971363c3ad$export$4d903b39a9b39b21 = ({ integrations: integrations })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!integrations.data) throw new Error('CopyIntegrationsTable should be rendered when chat tools integrations are loaded');
    const rows = integrations.data.values.map((item, index)=>{
        const channelName = `${item.msTeamsName || item.channelName}, ${item.chatSpaceName}`;
        return {
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-chat-integration`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                        position: "top",
                        content: item.name
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        xcss: $eb106d971363c3ad$var$nameStyles,
                        paddingInlineStart: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                        space: "space.100",
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                        size: "xsmall",
                        src: item.chatSpaceType === 'slack' ? (0, $fjrC9.SLACK_IMAGE_URL) : (0, $fjrC9.MST_IMAGE_URL)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p",
                        maxLines: 1
                    }, item.name))))
                },
                {
                    key: `cell-${index}-connected-to`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                        position: "top",
                        content: channelName
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p",
                        maxLines: 1
                    }, channelName))
                },
                {
                    key: `cell-${index}-connected-to`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                        position: "top",
                        content: item.teamName
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p",
                        maxLines: 1
                    }, item.teamName))
                },
                {
                    key: `cell-${index}-status`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                        space: "space.050",
                        alignBlock: "center",
                        alignInline: "center",
                        xcss: $eb106d971363c3ad$var$inlineStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVIls.Action), {
                        item: item
                    }))
                },
                {
                    key: `cell-${index}-actions`,
                    content: item.status === 'COPIED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                        appearance: "subtle",
                        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                            spacing: "spacious",
                            label: ""
                        }),
                        href: item.teamId ? `/jira/ops/teams/${item.teamId}/integrations/${item.chatSpaceType === 'slack' ? 'slack-plugin' : 'msteams-plugin'}/${item.jsmIntegrationId}` : `/jira/settings/products/ops/integrations/${item.chatSpaceType === 'slack' ? 'slack-plugin' : 'msteams-plugin'}/${item.jsmIntegrationId}`,
                        target: "_blank"
                    })
                }
            ]
        };
    });
    const head = {
        cells: [
            {
                key: 'chat-integration',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, formatMessage((0, $aauqn.messages).chatIntegrationNonFinal)),
                isSortable: true
            },
            {
                key: 'connected-to',
                content: formatMessage((0, $aauqn.messages).connectedToNonFinal)
            },
            {
                key: 'responder-team',
                content: formatMessage((0, $aauqn.messages).responderTeamNonFinal),
                isSortable: true
            },
            {
                key: 'status',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                    alignInline: "center"
                }, formatMessage((0, $aauqn.messages).statusNonFinal))
            },
            {
                key: 'actions',
                content: null
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3qRI.default), {
        isLoading: integrations.loading,
        head: head,
        rows: rows,
        rowsPerPage: 5,
        defaultPage: 1
    });
};
const $eb106d971363c3ad$var$inlineStyles = (0, $8CUq3.xcss)({
    height: 'size.400',
    cursor: 'default'
});
const $eb106d971363c3ad$var$nameStyles = (0, $8CUq3.xcss)({
    maxWidth: '280px'
});

});
parcelRegister("jVIls", function(module, exports) {

$parcel$export(module.exports, "Action", () => $a7c959cb789cab79$export$e19cd5f9376f8cee);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
var $2rqOp = parcelRequire("2rqOp");

var $c2i4s = parcelRequire("c2i4s");

var $3Fq5M = parcelRequire("3Fq5M");

var $dD7Zc = parcelRequire("dD7Zc");

var $a3mGm = parcelRequire("a3mGm");

var $3bDjY = parcelRequire("3bDjY");

var $ousew = parcelRequire("ousew");

var $4iQaI = parcelRequire("4iQaI");

var $5P7gt = parcelRequire("5P7gt");
const $a7c959cb789cab79$export$e19cd5f9376f8cee = ({ item: item })=>{
    const { givePermissionToUser: givePermissionToUser, duplicateIntegration: duplicateIntegration } = (0, $4iQaI.useChatToolsActions)();
    const [{ loadingIntegrationId: loadingIntegrationId }] = (0, $4iQaI.useChatToolsStore)();
    if (item.status === 'COPIED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        LEGACY_size: "small",
        label: "",
        color: "var(--ds-icon-success, #22A06B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5P7gt.messages).copyIntegrationsTableCopiedTextNonFinal));
    if (item.status === 'UNCONNECTED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), item.chatSpaceType === 'slack' ? (0, $5P7gt.messages).slackUnconnectedTooltipNonFinal : (0, $5P7gt.messages).mstUnconnectedTooltipNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        isDisabled: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3mGm))), {
            LEGACY_size: "small",
            label: "",
            color: "var(--ds-icon-subtle, #626F86)"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5P7gt.messages).copyIntegrationsTableUnconnectedTextNonFinal)));
    if (item.status === 'AWAITED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), item.chatSpaceType === 'slack' ? (0, $5P7gt.messages).slackGivePermissionTooltipNonFinal : (0, $5P7gt.messages).mstGivePermissionTooltipNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        isLoading: loadingIntegrationId === item.id,
        onClick: ()=>givePermissionToUser(item),
        appearance: "subtle-link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            LEGACY_size: "small",
            label: "",
            color: "var(--ds-icon-subtle, #626F86)"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5P7gt.messages).givePermissionTextNonFinal)));
    if (item.status === 'GRANTED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        onClick: ()=>duplicateIntegration(item),
        isLoading: loadingIntegrationId === item.id,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
            label: "Copy",
            LEGACY_size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5P7gt.messages).copyToJiraNonFinal));
    // Only remaining case is FAILED and we users should be retry to copy again in this case
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        onClick: ()=>duplicateIntegration(item),
        isLoading: loadingIntegrationId === item.id,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
            label: "Copy",
            LEGACY_size: "small"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5P7gt.messages).copyToJiraNonFinal));
};

});
parcelRegister("a3mGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::766864a6ad12ee0b57d7ed41e0a75cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $751bc76853fe58bc$var$_react = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $751bc76853fe58bc$var$_lockLocked = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("bwyQI")));

var $751bc76853fe58bc$var$_lock = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("3G2gB")));
function $751bc76853fe58bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $751bc76853fe58bc$var$LockLockedIcon = (props)=>/*#__PURE__*/ $751bc76853fe58bc$var$_react.default.createElement($751bc76853fe58bc$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $751bc76853fe58bc$var$_lock.default
    }, props));
$751bc76853fe58bc$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $751bc76853fe58bc$var$_default = module.exports.default = $751bc76853fe58bc$var$LockLockedIcon;

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("3G2gB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ad70d7fd26028c0$var$_react = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2ad70d7fd26028c0$var$_lockLocked = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $2ad70d7fd26028c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ad70d7fd26028c0$var$LockIcon = (props)=>/*#__PURE__*/ $2ad70d7fd26028c0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $2ad70d7fd26028c0$var$_lockLocked.default
    }));
$2ad70d7fd26028c0$var$LockIcon.displayName = 'LockIcon';
var $2ad70d7fd26028c0$var$_default = module.exports.default = $2ad70d7fd26028c0$var$LockIcon;

});


parcelRegister("5P7gt", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0e9ba9c2362f922e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0e9ba9c2362f922e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    copyIntegrationsTableCopiedTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.copy-integrations-table-copied-text-non-final",
        "defaultMessage": "Copied"
    },
    copyIntegrationsTableUnconnectedTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.copy-integrations-table-unconnected-text-non-final",
        "defaultMessage": "Unconnected"
    },
    givePermissionTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.give-permission-text-non-final",
        "defaultMessage": "Give permission"
    },
    copyToJiraNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.copy-to-jira-non-final",
        "defaultMessage": "Copy to Jira"
    },
    slackUnconnectedTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.slack-unconnected-tooltip-non-final",
        "defaultMessage": "Connect the Slack workspace to Jira Service Management and then copy the integration."
    },
    mstUnconnectedTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.mst-unconnected-tooltip-non-final",
        "defaultMessage": "Connect the Microsoft tenant to Jira Service Management and then copy the integration."
    },
    slackGivePermissionTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.slack-give-permission-tooltip-non-final",
        "defaultMessage": "Give permission to create channels and post to channels in Slack."
    },
    mstGivePermissionTooltipNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.action.mst-give-permission-tooltip-non-final",
        "defaultMessage": "Give permission to create chats, meetings, and post to channels in Microsoft Teams."
    }
});

});


parcelRegister("aauqn", function(module, exports) {

$parcel$export(module.exports, "messages", () => $65fb5dc8af22b306$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $65fb5dc8af22b306$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    chatIntegrationNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.chat-integration-non-final",
        "defaultMessage": "Chat integration"
    },
    connectedToNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.connected-to-non-final",
        "defaultMessage": "Connected to"
    },
    responderTeamNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.responder-team-non-final",
        "defaultMessage": "Responder team"
    },
    statusNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.copy-integrations-table.status-non-final",
        "defaultMessage": "Status"
    }
});

});


parcelRegister("QWB3s", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ecdf3d25967d43f0$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ecdf3d25967d43f0$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    taskOneDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-one-description-non-final",
        "defaultMessage": "\nJira Service Management offers integrations with Slack and Microsoft Teams to help your on-call teams get alert notifications and manage alerts directly from chat channels.\n\n[Read more about chat tools for alerting](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Chat-tools-for-alerting)"
    },
    taskTwoDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-two-description-non-final",
        "defaultMessage": "\nYour chat tools are currently connected with Opsgenie. Connect them with Jira Service Management to let your on-call teams work on alerts from their existing chat channels."
    },
    taskTwoActionButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-two-action-button-non-final",
        "defaultMessage": "Manage chat tools in Jira"
    },
    taskThreeDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-three-description-non-final",
        "defaultMessage": "\nSelect the Opsgenie chat integrations that you want to copy to Jira Service Management. The integration will be copied without any changes, but the status will be **OFF** by default. You can make any changes to the integration's settings and then turn it on.\n\nMake sure you're a member of the channel connected to the chat integration, else you won't be able to copy it to Jira Service Management."
    },
    taskThreeActionButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-three-action-button-non-final",
        "defaultMessage": "Manage chat integrations in Jira"
    },
    taskFourDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-four-description-non-final",
        "defaultMessage": "\nTo avoid duplicate notifications from Jira and Opsgenie's chat integrations, you can turn off the integrations in Opsgenie.\n\nThis will only turn off your Opsgenie chat integrations, the integrations won't be deleted. You can turn it on at any time."
    },
    taskFourTeamAdminDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-four-team-admin-description-non-final",
        "defaultMessage": "\nTo avoid duplicate notifications from Jira and Opsgenie's chat integrations, turn off your teams' integrations in Opsgenie.\n\nFind your Opsgenie integrations by navigating to a team and select **Integrations**. Select your chat integration from the list and select the **Turn off** button.\n\nThis will only turn off your Opsgenie chat integrations, the integrations won't be deleted. You can turn it on at any time."
    },
    taskFourActionButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-four-action-button-non-final",
        "defaultMessage": "Manage chat integrations in Opsgenie"
    },
    taskFourTeamAdminActionButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.chat-tools-step.task-four-team-admin-action-button-non-final",
        "defaultMessage": "Go to teams in Opsgenie"
    }
});

});


parcelRegister("iAXXw", function(module, exports) {

$parcel$export(module.exports, "DeprecatedOnesStep", () => $4e8953068b6e2e12$export$ce0fe6d5fca0a967);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $eQfWH = parcelRequire("eQfWH");

var $5qRwM = parcelRequire("5qRwM");

var $luBm6 = parcelRequire("luBm6");

var $3bDjY = parcelRequire("3bDjY");
parcelRequire("1RRwK");
var $pivaF = parcelRequire("pivaF");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $4Fvtg = parcelRequire("4Fvtg");

var $lha8j = parcelRequire("lha8j");

var $3V4J8 = parcelRequire("3V4J8");

var $5JunY = parcelRequire("5JunY");

var $fEF5w = parcelRequire("fEF5w");

var $lLiTq = parcelRequire("lLiTq");

var $5fIfP = parcelRequire("5fIfP");

var $3prk8 = parcelRequire("3prk8");
const $4e8953068b6e2e12$export$ce0fe6d5fca0a967 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ deprecatedIntegrations: deprecatedIntegrations, hasDeprecatedIntegration: hasDeprecatedIntegration }] = (0, $5fIfP.useDeprecatedIntegrations)();
    const [{ groups: groups, hasDeprecatedGroups: hasDeprecatedGroups }] = (0, $lLiTq.useDeprecatedGroups)();
    const [{ heartbeats: heartbeats, hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats }] = (0, $lLiTq.useDeprecatedHeartbeats)();
    const [{ notificationPolicies: notificationPolicies, hasDeprecatedNotificationPolicies: hasDeprecatedNotificationPolicies }] = (0, $lLiTq.useDeprecatedNotificationPolicies)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isPrimaryAdmin = (0, $itmJb.useIsAdmin)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3V4J8.TransitionHomeHeader), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).deprecatedOnesTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).deprecatedOnesDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($pivaF))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($pivaF))),
            alt: "",
            width: 130
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, (0, $fEF5w.getDeprecatedOnesTasks)({
        isAdmin: isSiteAdmin || isPrimaryAdmin,
        hasDeprecatedIntegration: hasDeprecatedIntegration,
        hasDeprecatedGroups: hasDeprecatedGroups,
        hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats,
        hasDeprecatedNotificationPolicies: hasDeprecatedNotificationPolicies
    })[0].description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardList), null, hasDeprecatedIntegration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $3prk8.messages).integrationsTitleNonFinal),
        description: formatMessage((0, $3prk8.messages).integrationsDescriptionNonFinal, {
            deprecatedIntegrationCount: deprecatedIntegrations.data?.count
        }),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $3prk8.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                label: "",
                LEGACY_size: "small"
            }),
            "aria-label": formatMessage((0, $3prk8.messages).integrationsTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Integrations"
    }), hasDeprecatedGroups && (isSiteAdmin || isPrimaryAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $3prk8.messages).groupsTitleNonFinal),
        description: formatMessage((0, $3prk8.messages).groupsDescriptionNonFinal, {
            deprecatedGroupCount: groups.data?.count
        }),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $3prk8.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                label: "",
                LEGACY_size: "small"
            }),
            "aria-label": formatMessage((0, $3prk8.messages).groupsTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Groups"
    }), hasDeprecatedGlobalHeartbeats && (isSiteAdmin || isPrimaryAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $3prk8.messages).heartbeatsTitleNonFinal),
        description: formatMessage((0, $3prk8.messages).heartbeatsDescriptionNonFinal, {
            deprecatedGlobalHeartbeatCount: heartbeats.data?.globalHeartbeatCount
        }),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $3prk8.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                label: "",
                LEGACY_size: "small"
            }),
            "aria-label": formatMessage((0, $3prk8.messages).heartbeatsTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Heartbeats-V1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $3prk8.messages).teamsApiTitleNonFinal),
        description: formatMessage((0, $3prk8.messages).teamsApiDescriptionNonFinal),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $3prk8.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                label: "",
                LEGACY_size: "small"
            }),
            "aria-label": formatMessage((0, $3prk8.messages).teamsApiTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Teams-API"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $3prk8.messages).incidentTemplatesTitleNonFinal),
        description: formatMessage((0, $3prk8.messages).incidentTemplatesDescriptionNonFinal),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $3prk8.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                label: "",
                LEGACY_size: "small"
            }),
            "aria-label": formatMessage((0, $3prk8.messages).incidentTemplatesTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Incident-templates"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $3prk8.messages).iccAndBridgesTitleNonFinal),
        description: formatMessage((0, $3prk8.messages).iccAndBridgesDescriptionNonFinal),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $3prk8.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                label: "",
                LEGACY_size: "small"
            }),
            "aria-label": formatMessage((0, $3prk8.messages).iccAndBridgesTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Incident-Command-Center-and-Conference-Bridges"
    }), hasDeprecatedNotificationPolicies && (isSiteAdmin || isPrimaryAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $3prk8.messages).notificationPoliciesTitleNonFinal),
        description: formatMessage((0, $3prk8.messages).notificationPoliciesDescriptionNonFinal, {
            deprecatedNotificationPolicyCount: notificationPolicies.data?.count
        }),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $3prk8.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                label: "",
                LEGACY_size: "small"
            }),
            "aria-label": formatMessage((0, $3prk8.messages).notificationPoliciesTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Notification-policies-V1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $3prk8.messages).actionsAndIncidentRulesTitleNonFinal),
        description: formatMessage((0, $3prk8.messages).actionsAndIncidentRulesDescriptionNonFinal),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $3prk8.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                label: "",
                LEGACY_size: "small"
            }),
            "aria-label": formatMessage((0, $3prk8.messages).actionsAndIncidentRulesTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Actions-and-incident-rules"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $3prk8.messages).reportsTitleNonFinal),
        description: formatMessage((0, $3prk8.messages).reportsDescriptionNonFinal),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $3prk8.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                label: "",
                LEGACY_size: "small"
            }),
            "aria-label": formatMessage((0, $3prk8.messages).reportsTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Some-reports"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $3prk8.messages).oecTitleNonFinal),
        description: formatMessage((0, $3prk8.messages).oecDescriptionNonFinal),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $3prk8.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                label: "",
                LEGACY_size: "small"
            }),
            "aria-label": formatMessage((0, $3prk8.messages).oecTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Opsgenie-Edge-Connector"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $3prk8.messages).servicesTitleNonFinal),
        description: formatMessage((0, $3prk8.messages).servicesDescriptionNonFinal),
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $3prk8.messages).tooltipTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                label: "",
                LEGACY_size: "small"
            }),
            "aria-label": formatMessage((0, $3prk8.messages).servicesTitleNonFinal)
        })),
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#External-services"
    })))));
};

});
parcelRegister("1RRwK", function(module, exports) {

$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("pivaF")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("pivaF")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 28g4fxvt8gs4swgsfwsrm85
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/28g4fxvt8gs4swgsfwsrm85

var $dCLgq = parcelRequire("dCLgq");

var $pivaF = parcelRequire("pivaF");
const $81540271609ef9fe$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($pivaF)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($pivaF))
});
var $81540271609ef9fe$export$2e2bcd8739ae039 = $81540271609ef9fe$var$Illustration;
// for advanced use only
const $81540271609ef9fe$export$a179c88182cb9d56 = [
    0,
    0,
    249,
    239
];

});
parcelRegister("pivaF", function(module, exports) {
module.exports = new URL("trash.a4bf000c.svg", import.meta.url).toString();

});


parcelRegister("4Fvtg", function(module, exports) {

$parcel$export(module.exports, "CardList", () => $0a3c8a4567c17bff$export$bb29c16f5612603e);
$parcel$export(module.exports, "CardListItem", () => $0a3c8a4567c17bff$export$9156e7ca4e0589e5);

var $5uXOq = parcelRequire("5uXOq");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");
const $0a3c8a4567c17bff$export$bb29c16f5612603e = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        role: "list",
        xcss: $0a3c8a4567c17bff$var$wrapperStyles
    }, children);
const $0a3c8a4567c17bff$export$9156e7ca4e0589e5 = ({ title: title, description: description, href: href, afterIcon: afterIcon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        role: "listitem",
        xcss: $0a3c8a4567c17bff$var$listStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: href,
        target: "_blank",
        xcss: $0a3c8a4567c17bff$var$linkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "medium"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        color: "color.text.subtlest"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0a3c8a4567c17bff$var$afterIconStyles
    }, afterIcon))));
const $0a3c8a4567c17bff$var$afterIconStyles = (0, $8CUq3.xcss)({
    flexShrink: 0
});
const $0a3c8a4567c17bff$var$wrapperStyles = (0, $8CUq3.xcss)({
    border: '1px solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.200',
    overflow: 'hidden',
    width: '100%'
});
const $0a3c8a4567c17bff$var$listStyles = (0, $8CUq3.xcss)({
    cursor: 'pointer',
    listStyleType: 'none',
    borderBottom: '1px solid',
    backgroundColor: 'elevation.surface',
    borderBottomColor: 'color.border',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-child': {
        borderBottom: '0'
    }
});
const $0a3c8a4567c17bff$var$linkStyles = (0, $8CUq3.xcss)({
    display: 'block',
    padding: 'space.150',
    textDecoration: 'none',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        textDecoration: 'underline'
    },
    ':focus-within': {
        outline: 'none',
        backgroundColor: 'elevation.surface.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.pressed'
    }
});

});

parcelRegister("fEF5w", function(module, exports) {

$parcel$export(module.exports, "getUsersAndRolesTasks", () => $c1b89aff283ed871$export$f657c0bf669f7c6f);
$parcel$export(module.exports, "getAlertsTasks", () => $c1b89aff283ed871$export$c20dcc2e5bca31f);
$parcel$export(module.exports, "getNotificationsTasks", () => $c1b89aff283ed871$export$965e2a52789d9ed1);
$parcel$export(module.exports, "getTeamsTasks", () => $c1b89aff283ed871$export$1c78be8966011bdd);
$parcel$export(module.exports, "getChatToolsTasks", () => $c1b89aff283ed871$export$fb7096e57ecb71c0);
$parcel$export(module.exports, "getAutomateAlertAndIncidentResponseTasks", () => $c1b89aff283ed871$export$b7b04088d49bb385);
$parcel$export(module.exports, "getIntegrationsTasks", () => $c1b89aff283ed871$export$fd18e60487f7976e);
$parcel$export(module.exports, "getDeprecatedOnesTasks", () => $c1b89aff283ed871$export$3ac8fcaa0f45ffba);
$parcel$export(module.exports, "getHeartbeatsTasks", () => $c1b89aff283ed871$export$3c15015776773877);
$parcel$export(module.exports, "getIncidentsTasks", () => $c1b89aff283ed871$export$c8a56ca65a2b374f);
$parcel$export(module.exports, "getFindWhatYouAreLookingForTasks", () => $c1b89aff283ed871$export$6faaa4c808c4f178);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $1fGbK = parcelRequire("1fGbK");
const $c1b89aff283ed871$export$f657c0bf669f7c6f = ({ isOptimalTooling: isOptimalTooling, isSiteAdmin: isSiteAdmin, adminDifferenceCount: adminDifferenceCount, customRoleDifferenceCount: customRoleDifferenceCount, stakeholderCount: stakeholderCount })=>{
    const tasks = [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).usersAndRolesTaskOneNonFinal)
        },
        {
            isCompleted: adminDifferenceCount === 0,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                ...(0, $1fGbK.default).usersAndRolesTaskTwoNonFinal,
                values: {
                    count: adminDifferenceCount
                }
            })
        },
        {
            isCompleted: customRoleDifferenceCount === 0,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                ...(0, $1fGbK.default).usersAndRolesTaskThreeNonFinal,
                values: {
                    count: customRoleDifferenceCount
                }
            })
        }
    ];
    if (isOptimalTooling && isSiteAdmin && stakeholderCount > 0) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).usersAndRolesTaskFourNonFinal)
    });
    return tasks;
};
const $c1b89aff283ed871$export$c20dcc2e5bca31f = (isOptimalTooling)=>{
    const tasks = [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).alertsTaskOneNonFinal)
        },
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).alertsTaskTwoNonFinal)
        },
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).alertsTaskThreeNonFinal)
        }
    ];
    if (isOptimalTooling) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).alertsTaskFourNonFinal)
    });
    return tasks;
};
const $c1b89aff283ed871$var$getCardTwoTasks = ({ areOgAppsDeactivated: areOgAppsDeactivated, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart, isRBNEnabled: isRBNEnabled })=>{
    // No second card
    if (!ogAppExistsAtTransitioningStart && !isRBNEnabled) return [];
    // 2D
    if (!ogAppExistsAtTransitioningStart && isRBNEnabled) return [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).contactMethodTitleNonFinal)
        }
    ];
    // 2C
    if (ogAppExistsAtTransitioningStart && isRBNEnabled && areOgAppsDeactivated) return [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).preventPushTitleNonFinal)
        },
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).deleteOgContactMethodsTitleNonFinal)
        }
    ];
    // 2A & 2B & 2E
    return [
        {
            isCompleted: areOgAppsDeactivated,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).notificationsTaskThreeNonFinal)
        }
    ];
};
const $c1b89aff283ed871$export$965e2a52789d9ed1 = ({ isJnaAppDownloaded: isJnaAppDownloaded, areOgAppsDeactivated: areOgAppsDeactivated, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart, isRBNEnabled: isRBNEnabled, areOgRulesDuplicated: areOgRulesDuplicated })=>[
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).notificationsTaskOneNonFinal)
        },
        {
            isCompleted: isJnaAppDownloaded,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).notificationsTaskTwoNonFinal)
        },
        ...$c1b89aff283ed871$var$getCardTwoTasks({
            isJnaAppDownloaded: isJnaAppDownloaded,
            areOgAppsDeactivated: areOgAppsDeactivated,
            ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart,
            isRBNEnabled: isRBNEnabled,
            areOgRulesDuplicated: areOgRulesDuplicated
        })
    ];
const $c1b89aff283ed871$export$1c78be8966011bdd = (isOptimalTooling, hasItem)=>{
    const tasks = [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).teamsTaskOneNonFinal)
        }
    ];
    if (isOptimalTooling && hasItem) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).teamsTaskTwoNonFinal)
    });
    return tasks;
};
const $c1b89aff283ed871$export$fb7096e57ecb71c0 = ({ isChatToolsConnectedToJSM: isChatToolsConnectedToJSM, isOgIntegrationsCopiedToJSM: isOgIntegrationsCopiedToJSM, isDuplicateNotificationsPrevented: isDuplicateNotificationsPrevented, isPrimaryAdmin: isPrimaryAdmin, hasIntegration: hasIntegration })=>{
    const tasks = [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).chatToolsTaskOneNonFinal)
        },
        {
            isCompleted: isDuplicateNotificationsPrevented,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).chatToolsTaskFourNonFinal)
        }
    ];
    const integrationTasks = [
        {
            isCompleted: isOgIntegrationsCopiedToJSM,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).chatToolsTaskThreeNonFinal)
        }
    ];
    const primaryAdminTasks = [
        {
            isCompleted: isChatToolsConnectedToJSM,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).chatToolsTaskTwoNonFinal)
        }
    ];
    if (hasIntegration) tasks.splice(1, 0, ...integrationTasks);
    if (isPrimaryAdmin) tasks.splice(1, 0, ...primaryAdminTasks);
    return tasks;
};
const $c1b89aff283ed871$export$b7b04088d49bb385 = ()=>[
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).automateAlertsAndIncidentResponseTaskOneNonFinal)
        },
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).automateAlertsAndIncidentResponseTaskTwoNonFinal)
        }
    ];
const $c1b89aff283ed871$export$fd18e60487f7976e = ({ hasSyncedIntegration: hasSyncedIntegration, hasDiscontinuedIntegration: hasDiscontinuedIntegration, hasDeprecatedIntegration: hasDeprecatedIntegration, hasIncomingCallIntegration: hasIncomingCallIntegration, shouldHaveIncomingCallPermission: shouldHaveIncomingCallPermission })=>{
    const integrationTasks = [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).integrationsTaskOneNonFinal)
        }
    ];
    if (hasSyncedIntegration) integrationTasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).integrationsTaskTwoNonFinal)
    });
    if (hasDiscontinuedIntegration) integrationTasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).integrationsTaskThreeNonFinal)
    });
    if (hasDeprecatedIntegration) integrationTasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).integrationsTaskFourNonFinal)
    });
    if (hasIncomingCallIntegration && shouldHaveIncomingCallPermission) integrationTasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).integrationsTaskFiveNonFinal)
    });
    return integrationTasks;
};
const $c1b89aff283ed871$export$3ac8fcaa0f45ffba = ({ isAdmin: isAdmin, hasDeprecatedIntegration: hasDeprecatedIntegration, hasDeprecatedGroups: hasDeprecatedGroups, hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats, hasDeprecatedNotificationPolicies: hasDeprecatedNotificationPolicies })=>{
    // We have 7 static tasks which is displayed no matter what
    let totalCount = 7;
    // Deprecated integrations is dispplayed for admins and team admins
    if (hasDeprecatedIntegration) totalCount += 1;
    if (isAdmin) {
        if (hasDeprecatedGroups) totalCount += 1;
        if (hasDeprecatedGlobalHeartbeats) totalCount += 1;
        if (hasDeprecatedNotificationPolicies) totalCount += 1;
    }
    return [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                ...(0, $1fGbK.default).deprecatedOnesTaskOneNonFinal,
                values: {
                    deprecatedFeaturesCount: totalCount
                }
            })
        }
    ];
};
const $c1b89aff283ed871$export$3c15015776773877 = ({ hasDeprecatedTotalHeartbeats: hasDeprecatedTotalHeartbeats, hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats, isExceedHeartbeatLimit: isExceedHeartbeatLimit })=>{
    const tasks = [];
    if (hasDeprecatedTotalHeartbeats) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).heartbeatsTaskOneNonFinal)
    });
    if (hasDeprecatedGlobalHeartbeats) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).heartbeatsTaskTwoNonFinal)
    });
    if (isExceedHeartbeatLimit) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).heartbeatsTaskThreeNonFinal)
    });
    return tasks;
};
const $c1b89aff283ed871$export$c8a56ca65a2b374f = ({ isCopied: isCopied, shouldDisplaySuccessBanner: shouldDisplaySuccessBanner, isEligibleForCopy: isEligibleForCopy })=>{
    const tasks = [
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).incidentsTaskTwoNonFinal)
        },
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).incidentsTaskThreeNonFinal)
        }
    ];
    if (isCopied) tasks.unshift({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).incidentsTaskOneNonFinal)
    });
    if (isEligibleForCopy) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).incidentsTaskFourNonFinal)
    });
    if (shouldDisplaySuccessBanner) tasks.push({
        isCompleted: true,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).incidentsTaskFourSuccessNonFinal)
    });
    return tasks;
};
const $c1b89aff283ed871$export$6faaa4c808c4f178 = ()=>[
        {
            isCompleted: true,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).findWhatYouAreLookingForTaskOneNonFinal)
        }
    ];

});

parcelRegister("3prk8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f275fafee435340b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f275fafee435340b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    integrationsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.integrations-title-non-final",
        "defaultMessage": "Integrations"
    },
    integrationsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.integrations-description-non-final",
        "defaultMessage": "{deprecatedIntegrationCount, plural, one {{deprecatedIntegrationCount} integration} other {{deprecatedIntegrationCount} integrations}} weren't moved as they're not supported by Jira Service Management."
    },
    groupsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.groups-title-non-final",
        "defaultMessage": "Groups"
    },
    groupsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.groups-description-non-final",
        "defaultMessage": "{deprecatedGroupCount, plural, one {{deprecatedGroupCount} group} other {{deprecatedGroupCount} groups}} in Opsgenie weren't moved as they're now deprecated. You can recreate these groups as teams in Jira Service Management instead."
    },
    heartbeatsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.heartbeats-title-non-final",
        "defaultMessage": "Heartbeats (V1)"
    },
    heartbeatsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.heartbeats-description-non-final",
        "defaultMessage": "{deprecatedGlobalHeartbeatCount, plural, one {{deprecatedGlobalHeartbeatCount} heartbeat} other {{deprecatedGlobalHeartbeatCount} heartbeats}} in Opsgenie weren't moved as they're now deprecated. To move them to Jira Service Management, update to the latest version."
    },
    teamsApiTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.teams-api-title-non-final",
        "defaultMessage": "Teams API"
    },
    teamsApiDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.teams-api-description-non-final",
        "defaultMessage": "The Teams Opsgenie API doesn't work with Jira Service Management. You can use the alternative Jira Cloud Platform API."
    },
    incidentTemplatesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.incident-templates-title-non-final",
        "defaultMessage": "Incident templates"
    },
    incidentTemplatesDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.incident-templates-description-non-final",
        "defaultMessage": "Incident templates aren't supported by Jira Service Management, so they weren't moved. You can use incident request types instead."
    },
    iccAndBridgesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.icc-and-bridges-title-non-final",
        "defaultMessage": "Incident Command Center and Conference Bridges"
    },
    iccAndBridgesDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.icc-and-bridges-description-non-final",
        "defaultMessage": "The Incident Command Center and Conference Bridges aren't supported by Jira Service Management. You can use the Slack, Microsoft Teams, and Zoom apps instead."
    },
    notificationPoliciesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.notification-policies-title-non-final",
        "defaultMessage": "Notification policies (V1)"
    },
    notificationPoliciesDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.notification-policies-description-non-final",
        "defaultMessage": "{deprecatedNotificationPolicyCount, plural, one {{deprecatedNotificationPolicyCount} notification policy wasn't} other {{deprecatedNotificationPolicyCount} notification policies weren't}} moved as they're now deprecated. To move them to Jira Service Management, update to the latest version."
    },
    actionsAndIncidentRulesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.actions-and-incident-rules-title-non-final",
        "defaultMessage": "Actions and incident rules"
    },
    actionsAndIncidentRulesDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.actions-and-incident-rules-description-non-final",
        "defaultMessage": "Opsgenie actions and incident rules weren't moved. You can recreate actions and rules using Jira automation."
    },
    reportsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.reports-title-non-final",
        "defaultMessage": "Some reports"
    },
    reportsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.reports-description-non-final",
        "defaultMessage": "A few reports are not available in Jira Service Management as there are either not supported or are replaced by new reports."
    },
    oecTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.oec-title-non-final",
        "defaultMessage": "Opsgenie Edge Connector"
    },
    oecDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.oec-description-non-final",
        "defaultMessage": "Your existing OEC integrations will continue to work in Jira. You can create new integrations and actions with the new Jira Edge Connector."
    },
    servicesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.services-title-non-final",
        "defaultMessage": "External services"
    },
    servicesDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.services-description-non-final",
        "defaultMessage": "It's not possible to create an external service in Jira. You can simply add stakeholders to your services or incidents instead."
    },
    tooltipTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.deprecated-ones-step.tooltip-text-non-final",
        "defaultMessage": "Go to documentation"
    }
});

});


parcelRegister("9hz6f", function(module, exports) {

$parcel$export(module.exports, "FindStep", () => $9e7d511416be7f11$export$612db864546c088e);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $7paD5 = parcelRequire("7paD5");

var $5qRwM = parcelRequire("5qRwM");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");
parcelRequire("80P9l");
var $cTD1D = parcelRequire("cTD1D");

var $koVbs = parcelRequire("koVbs");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $4Fvtg = parcelRequire("4Fvtg");

var $lha8j = parcelRequire("lha8j");

var $3V4J8 = parcelRequire("3V4J8");

var $5JunY = parcelRequire("5JunY");

var $1fGbK = parcelRequire("1fGbK");

var $jbwqm = parcelRequire("jbwqm");

var $7ZM2V = parcelRequire("7ZM2V");
const $9e7d511416be7f11$export$612db864546c088e = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ isTeamAdmin: isTeamAdmin }] = (0, $jbwqm.useIsTeamAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isPrimaryAdmin = (0, $itmJb.useIsAdmin)();
    const showAllAdmins = isSiteAdmin || isPrimaryAdmin || isTeamAdmin;
    const showRealAdmins = isSiteAdmin || isPrimaryAdmin;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3V4J8.TransitionHomeHeader), {
        title: formatMessage((0, $5JunY.messages).findWhatYouAreLookingForTitleNonFinal),
        description: formatMessage((0, $5JunY.messages).findWhatYouAreLookingForDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($cTD1D))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($cTD1D))),
            width: 200,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        spread: "space-between",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $1fGbK.default).findWhatYouAreLookingForTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9e7d511416be7f11$var$fullWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $7ZM2V.messages).yourTeamsTitleNonFinal),
        description: formatMessage((0, $7ZM2V.messages).yourTeamsDescriptionNonFinal),
        href: "/jira/people/search/teams",
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $7ZM2V.messages).openTeamsNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                LEGACY_size: "small",
                label: ""
            }),
            "aria-label": formatMessage((0, $7ZM2V.messages).openTeamsNonFinal)
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $7ZM2V.messages).schedulesTitleNonFinal),
        description: formatMessage((0, $7ZM2V.messages).schedulesDescriptionNonFinal),
        href: "/jira/ops/who-is-on-call",
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $7ZM2V.messages).openSchedulesNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                LEGACY_size: "small",
                label: ""
            }),
            "aria-label": formatMessage((0, $7ZM2V.messages).openSchedulesNonFinal)
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $7ZM2V.messages).alertsTitleNonFinal),
        description: formatMessage((0, $7ZM2V.messages).alertsDescriptionNonFinal),
        href: "/jira/ops/alerts",
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $7ZM2V.messages).openAlertsNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                LEGACY_size: "small",
                label: ""
            }),
            "aria-label": formatMessage((0, $7ZM2V.messages).openAlertsNonFinal)
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $7ZM2V.messages).notificationSettingsTitleNonFinal),
        description: formatMessage((0, $7ZM2V.messages).notificationSettingsDescriptionNonFinal),
        href: "/jira/settings/personal/alert-notifications",
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $7ZM2V.messages).openNotificationsNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                LEGACY_size: "small",
                label: ""
            }),
            "aria-label": formatMessage((0, $7ZM2V.messages).openNotificationsNonFinal)
        }))
    }), showAllAdmins && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $7ZM2V.messages).reportsTitleNonFinal),
        description: formatMessage(isTeamAdmin ? (0, $7ZM2V.messages).reportsTeamAdminDescriptionNonFinal : (0, $7ZM2V.messages).reportsDescriptionNonFinal),
        href: isTeamAdmin ? '/jira/people/search/teams' : '/jira/settings/products/ops/reports',
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage(isTeamAdmin ? (0, $7ZM2V.messages).openTeamsNonFinal : (0, $7ZM2V.messages).viewReportsNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                LEGACY_size: "small",
                label: ""
            }),
            "aria-label": formatMessage(isTeamAdmin ? (0, $7ZM2V.messages).openTeamsNonFinal : (0, $7ZM2V.messages).viewReportsNonFinal)
        }))
    }), showRealAdmins && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $7ZM2V.messages).auditTitleNonFinal),
        description: formatMessage((0, $7ZM2V.messages).auditDescriptionNonFinal),
        href: "/jira/settings/products/ops/jira-service-management-audit-logs",
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $7ZM2V.messages).openAuditLogsNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                LEGACY_size: "small",
                label: ""
            }),
            "aria-label": formatMessage((0, $7ZM2V.messages).openAuditLogsNonFinal)
        }))
    }), showRealAdmins && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $7ZM2V.messages).rbnTitleNonFinal),
        description: formatMessage((0, $7ZM2V.messages).rbnDescriptionNonFinal),
        href: "/jira/settings/products/ops/role-based-notifications",
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $7ZM2V.messages).openRbnNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                LEGACY_size: "small",
                label: ""
            }),
            "aria-label": formatMessage((0, $7ZM2V.messages).openRbnNonFinal)
        }))
    }), showAllAdmins && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage(isTeamAdmin ? (0, $7ZM2V.messages).customTeamRolesTitleNonFinal : (0, $7ZM2V.messages).customRolesTitleNonFinal),
        description: formatMessage(isTeamAdmin ? (0, $7ZM2V.messages).customRolesTeamAdminDescriptionNonFinal : (0, $7ZM2V.messages).customRolesDescriptionNonFinal),
        href: isTeamAdmin ? '/jira/people/search/teams' : '/jira/settings/products/ops/roles',
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage(isTeamAdmin ? (0, $7ZM2V.messages).openTeamsNonFinal : (0, $7ZM2V.messages).openCustomRolesNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                LEGACY_size: "small",
                label: ""
            }),
            "aria-label": formatMessage(isTeamAdmin ? (0, $7ZM2V.messages).openTeamsNonFinal : (0, $7ZM2V.messages).openCustomRolesNonFinal)
        }))
    }), showAllAdmins && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $7ZM2V.messages).automationTitleNonFinal),
        description: formatMessage(isTeamAdmin ? (0, $7ZM2V.messages).automationTeamAdminDescriptionNonFinal : (0, $7ZM2V.messages).automationDescriptionNonFinal),
        href: isTeamAdmin ? '/jira/people/search/teams' : '/jira/settings/automation',
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage(isTeamAdmin ? (0, $7ZM2V.messages).openTeamsNonFinal : (0, $7ZM2V.messages).openAutomationNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                LEGACY_size: "small",
                label: ""
            }),
            "aria-label": formatMessage(isTeamAdmin ? (0, $7ZM2V.messages).openTeamsNonFinal : (0, $7ZM2V.messages).openAutomationNonFinal)
        }))
    }), showAllAdmins && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Fvtg.CardListItem), {
        title: formatMessage((0, $7ZM2V.messages).syncTitleNonFinal),
        description: formatMessage(isTeamAdmin ? (0, $7ZM2V.messages).syncTeamAdminDescriptionNonFinal : (0, $7ZM2V.messages).syncDescriptionNonFinal),
        href: isTeamAdmin ? '/jira/people/search/teams' : '/jira/settings/products/ops/syncs',
        afterIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage(isTeamAdmin ? (0, $7ZM2V.messages).openTeamsNonFinal : (0, $7ZM2V.messages).openSyncNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                LEGACY_size: "small",
                label: ""
            }),
            "aria-label": formatMessage(isTeamAdmin ? (0, $7ZM2V.messages).openTeamsNonFinal : (0, $7ZM2V.messages).openSyncNonFinal)
        }))
    }))))));
};
const $9e7d511416be7f11$var$fullWidthStyles = (0, $8CUq3.xcss)({
    width: '100%'
});

});
parcelRegister("80P9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $6043373c6b544137$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cTD1D")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cTD1D")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = nj3nrg7zrmxwrhh9fn9ftw5m
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/nj3nrg7zrmxwrhh9fn9ftw5m

var $dCLgq = parcelRequire("dCLgq");

var $cTD1D = parcelRequire("cTD1D");
const $6043373c6b544137$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($cTD1D)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cTD1D))
});
var $6043373c6b544137$export$2e2bcd8739ae039 = $6043373c6b544137$var$Illustration;
// for advanced use only
const $6043373c6b544137$export$a179c88182cb9d56 = [
    0,
    0,
    95,
    89
];

});
parcelRegister("cTD1D", function(module, exports) {
module.exports = new URL("magic-search.dbdce574.svg", import.meta.url).toString();

});


parcelRegister("7ZM2V", function(module, exports) {

$parcel$export(module.exports, "messages", () => $235de484aff71341$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $235de484aff71341$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    yourTeamsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.your-teams-title-non-final",
        "defaultMessage": "Your teams from Opsgenie"
    },
    yourTeamsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.your-teams-description-non-final",
        "defaultMessage": "Where to find it: Jira navigation > Teams > Go to operations"
    },
    schedulesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.schedules-title-non-final",
        "defaultMessage": "On-call schedules"
    },
    schedulesDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.schedules-description-non-final",
        "defaultMessage": "Where to find it: Your work > On-call"
    },
    alertsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.alerts-title-non-final",
        "defaultMessage": "Alerts"
    },
    alertsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.alerts-description-non-final",
        "defaultMessage": "Where to find it: Your work > Alerts"
    },
    notificationSettingsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.notification-settings-title-non-final",
        "defaultMessage": "Personal notification settings"
    },
    notificationSettingsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.notification-settings-description-non-final",
        "defaultMessage": "Where to find it: Your profile and settings > Personal settings > Alerts"
    },
    reportsTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.reports-title-non-final",
        "defaultMessage": "Reports"
    },
    reportsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.reports-description-non-final",
        "defaultMessage": "Where to find it: Settings > Products > Reports"
    },
    reportsTeamAdminDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.reports-team-admin-description-non-final",
        "defaultMessage": "Where to find it: Teams > Go to operations > Reports"
    },
    auditTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.audit-title-non-final",
        "defaultMessage": "Audit logs"
    },
    auditDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.audit-description-non-final",
        "defaultMessage": "Where to find it: Settings > Products > Audit logs"
    },
    rbnTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.rbn-title-non-final",
        "defaultMessage": "Role-based notifications"
    },
    rbnDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.rbn-description-non-final",
        "defaultMessage": "Where to find it: Settings > Products > Role-based notifications"
    },
    customRolesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.custom-roles-title-non-final",
        "defaultMessage": "Custom roles"
    },
    customTeamRolesTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.custom-team-roles-title-non-final",
        "defaultMessage": "Custom team roles"
    },
    customRolesDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.custom-roles-description-non-final",
        "defaultMessage": "Where to find it: Settings > Products > Custom roles"
    },
    customRolesTeamAdminDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.custom-roles-team-admin-description-non-final",
        "defaultMessage": "Where to find it: Teams > Go to operations > Member roles"
    },
    automationTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.automation-title-non-final",
        "defaultMessage": "Automation"
    },
    automationDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.automation-description-non-final",
        "defaultMessage": "Where to find it: Settings > System > Automation"
    },
    automationTeamAdminDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.automation-team-admin-description-non-final",
        "defaultMessage": "Where to find it: Teams > Go to operations > Automation"
    },
    syncTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.sync-title-non-final",
        "defaultMessage": "Sync"
    },
    syncDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.sync-description-non-final",
        "defaultMessage": "Where to find it: Settings > System > Sync"
    },
    syncTeamAdminDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.sync-team-admin-description-non-final",
        "defaultMessage": "Where to find it: Teams > Go to operations > Sync"
    },
    openTeamsNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-teams-non-final",
        "defaultMessage": "Open teams"
    },
    openAlertsNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-alerts-non-final",
        "defaultMessage": "Open alerts"
    },
    openSchedulesNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-schedules-non-final",
        "defaultMessage": "Open on-call schedules"
    },
    openNotificationsNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-notifications-non-final",
        "defaultMessage": "Open personal notification settings"
    },
    viewReportsNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.view-reports-non-final",
        "defaultMessage": "View documentation"
    },
    openAuditLogsNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-audit-logs-non-final",
        "defaultMessage": "Open audit logs"
    },
    openRbnNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-rbn-non-final",
        "defaultMessage": "Open role-based notifications"
    },
    openCustomRolesNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-custom-roles-non-final",
        "defaultMessage": "Open custom roles"
    },
    openAutomationNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-automation-non-final",
        "defaultMessage": "Open automation"
    },
    openSyncNonFinal: {
        "id": "eoc-changeboarding.transition-home.find-step.open-sync-non-final",
        "defaultMessage": "Open sync"
    }
});

});


parcelRegister("6t2QC", function(module, exports) {

$parcel$export(module.exports, "HeartbeatsStep", () => $b4004849cadcf402$export$7d42d8486f0042ef);

var $5uXOq = parcelRequire("5uXOq");

var $flpap = parcelRequire("flpap");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $5qRwM = parcelRequire("5qRwM");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");

var $7q5TP = parcelRequire("7q5TP");

var $koVbs = parcelRequire("koVbs");

var $aTClY = parcelRequire("aTClY");

var $lha8j = parcelRequire("lha8j");

var $3V4J8 = parcelRequire("3V4J8");

var $5JunY = parcelRequire("5JunY");

var $1fGbK = parcelRequire("1fGbK");

var $6BT89 = parcelRequire("6BT89");

var $lLiTq = parcelRequire("lLiTq");

var $3IPTl = parcelRequire("3IPTl");
const $b4004849cadcf402$export$7d42d8486f0042ef = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { opsgenieBaseUrl: opsgenieBaseUrl } = (0, $6BT89.useGlobalChangeboarding)();
    const [{ hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats, hasDeprecatedTotalHeartbeats: hasDeprecatedTotalHeartbeats, isExceedHeartbeatLimit: isExceedHeartbeatLimit, heartbeats: heartbeats }] = (0, $lLiTq.useDeprecatedHeartbeats)();
    if (!heartbeats.data) throw new Error('Heartbeats step - heartbeat counts data should be loaded at this point');
    const { globalHeartbeatCount: globalHeartbeatCount, totalHeartbeatCount: totalHeartbeatCount } = heartbeats.data;
    const ogHeartbeatsUrl = opsgenieBaseUrl ? `${opsgenieBaseUrl}/settings/heartbeat` : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3V4J8.TransitionHomeHeader), {
        title: formatMessage((0, $5JunY.messages).heartbeatsTitleNonFinal),
        description: formatMessage((0, $5JunY.messages).heartbeatsDescriptionNonFinal)
    }), hasDeprecatedTotalHeartbeats && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $1fGbK.default).heartbeatsTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $aTClY.Anchor)
                }
            }
        }
    }, formatMessage((0, $3IPTl.messages).taskOneDescriptionNonFinal, {
        totalHeartbeatCount: totalHeartbeatCount
    }))))), hasDeprecatedGlobalHeartbeats && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            width: "163px",
            src: (0, $7q5TP.srcLight),
            srcDark: (0, $7q5TP.srcDark),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $1fGbK.default).heartbeatsTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $aTClY.Anchor)
                }
            }
        }
    }, formatMessage((0, $3IPTl.messages).taskTwoDescriptionNonFinal, {
        globalHeartbeatCount: globalHeartbeatCount
    }))))), isExceedHeartbeatLimit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $1fGbK.default).heartbeatsTaskThreeNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $aTClY.Anchor)
                }
            }
        }
    }, formatMessage((0, $3IPTl.messages).taskThreeDescriptionNonFinal, {
        heartbeatToBeRemovedCount: totalHeartbeatCount - 2000
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: ogHeartbeatsUrl,
        target: "_blank"
    }, formatMessage((0, $3IPTl.messages).taskThreeButtonNonFinal))))));
};

});
parcelRegister("3IPTl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e16d8c890264aea6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e16d8c890264aea6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    taskOneDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.heartbeats-step.task-one-description-non-final",
        "defaultMessage": "We've moved {totalHeartbeatCount, plural, one {{totalHeartbeatCount} heartbeat} other {{totalHeartbeatCount} heartbeats}} from Opsgenie to Jira Service Management. They've now moved from Opsgenie address to a new Jira Service Management-based address.\n\nYou'll need to update the address of the heartbeats wherever they're used in your systems, to ensure the heartbeats work as expected.\n\n[Read more about the updated heartbeats](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Heartbeats)\n"
    },
    taskTwoDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.heartbeats-step.task-two-description-non-final",
        "defaultMessage": "Looks like {globalHeartbeatCount, plural, one {{globalHeartbeatCount} heartbeat} other {{globalHeartbeatCount} heartbeats}} in Opsgenie aren't assigned to any team. So they weren't synced with Jira Service Management. [Read more about heartbeats without an assigned team](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Heartbeats)\n"
    },
    taskThreeDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.heartbeats-step.task-three-description-non-final",
        "defaultMessage": "Looks like you've got more than 2,000 heartbeats in your Jira Service Management site, which are more than the allowed limit. You'll need to remove {heartbeatToBeRemovedCount} so you can add more heartbeats. [Read how to remove excess heartbeats](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Heartbeats)\n"
    },
    taskThreeButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.heartbeats-step.task-three-button-non-final",
        "defaultMessage": "Go to heartbeats in Opsgenie"
    }
});

});


parcelRegister("kFgpe", function(module, exports) {

$parcel$export(module.exports, "IncidentsStep", () => $6a837dd621074703$export$7da1951768bbe34c);

var $5uXOq = parcelRequire("5uXOq");

var $flpap = parcelRequire("flpap");

var $fVnbM = parcelRequire("fVnbM");
var $2rqOp = parcelRequire("2rqOp");

var $kkJfY = parcelRequire("kkJfY");

var $l1N8i = parcelRequire("l1N8i");

var $5qRwM = parcelRequire("5qRwM");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $jBfr7 = parcelRequire("jBfr7");
parcelRequire("7dtol");
var $aGIRG = parcelRequire("aGIRG");
parcelRequire("bTyOW");
var $9RNHv = parcelRequire("9RNHv");
var $iXuyj = parcelRequire("iXuyj");

var $7q5TP = parcelRequire("7q5TP");

var $koVbs = parcelRequire("koVbs");

var $fjrC9 = parcelRequire("fjrC9");

var $aTClY = parcelRequire("aTClY");

var $lha8j = parcelRequire("lha8j");

var $3V4J8 = parcelRequire("3V4J8");

var $5JunY = parcelRequire("5JunY");

var $ivPYu = parcelRequire("ivPYu");

var $1fGbK = parcelRequire("1fGbK");

var $luBum = parcelRequire("luBum");

var $dA0kC = parcelRequire("dA0kC");

var $2aKxa = parcelRequire("2aKxa");

var $Mpalr = parcelRequire("Mpalr");

var $bEo87 = parcelRequire("bEo87");

var $2EChC = parcelRequire("2EChC");

var $d25rc = parcelRequire("d25rc");

var $lFQbs = parcelRequire("lFQbs");

var $2gHuK = parcelRequire("2gHuK");
const $6a837dd621074703$export$7da1951768bbe34c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isChecked, setIsChecked] = (0, $5uXOq.useState)(false);
    const [isCopyManuallyInitiated, setIsCopyManuallyInitiated] = (0, $5uXOq.useState)(false);
    const [{ projectKey: projectKey, hasCopyOperationError: hasCopyOperationError, isCopied: isCopied, isCopying: isCopying, isEligibleForCopy: isEligibleForCopy, shouldDisplaySuccessBanner: shouldDisplaySuccessBanner }, { copyIncidents: copyIncidents, getIncidentsCopyStatus: getIncidentsCopyStatus }] = (0, $luBum.useIncidents)();
    // If the copy operation is in progress, we need to keep checking the status in the interval
    (0, $jBfr7.useInterval)(getIncidentsCopyStatus, (isCopying || isCopyManuallyInitiated) && !isCopied ? 3000 : null);
    const incidentsJiraWebUrl = `/jira/servicedesk/projects/${projectKey}/section/incidents`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3V4J8.TransitionHomeHeader), {
        title: formatMessage((0, $5JunY.messages).incidentsTitleNonFinal),
        description: formatMessage((0, $5JunY.messages).incidentsDescriptionNonFinal)
    }), isCopying && !isCopyManuallyInitiated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            width: "262px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($aGIRG))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($aGIRG))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $d25rc.messages).loadingTitleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, " ", formatMessage((0, $d25rc.messages).loadingDescriptionNonFinal)))), hasCopyOperationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            width: "80px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($iXuyj))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($9RNHv))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $d25rc.messages).errorDescriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: (0, $fjrC9.JIRA_SUPPORT_LINK),
        target: "_blank",
        appearance: "warning"
    }, formatMessage((0, $d25rc.messages).contactAtlassianSupportButtonNonFinal))))), isCopied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            width: "249px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($Mpalr))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($2aKxa))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $1fGbK.default).incidentsTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $d25rc.messages).taskOneDescriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: incidentsJiraWebUrl,
        target: "_blank"
    }, formatMessage((0, $d25rc.messages).taskOneButtonNonFinal)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            width: "293px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($2EChC))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($bEo87))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $1fGbK.default).incidentsTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $d25rc.messages).taskTwoDescriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lFQbs.PriorityTable), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gHuK.StatusTable), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            width: "118px",
            src: (0, $7q5TP.srcLight),
            srcDark: (0, $7q5TP.srcDark),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $1fGbK.default).incidentsTaskThreeNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                ul: {
                    component: (0, $ivPYu.UnorderedList)
                },
                li: {
                    component: (0, $ivPYu.UnorderedListItem)
                }
            }
        }
    }, formatMessage((0, $d25rc.messages).taskThreeDescriptionNonFinal)))), (isEligibleForCopy || isCopying && isCopyManuallyInitiated) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            width: "240px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dA0kC))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $1fGbK.default).incidentsTaskFourNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $d25rc.messages).taskFourDescriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        isChecked: isChecked,
        onChange: ()=>setIsChecked((current)=>!current),
        label: formatMessage((0, $d25rc.messages).taskFourConfirmationNonFinal),
        isDisabled: isCopying && isCopyManuallyInitiated,
        isRequired: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        onClick: ()=>{
            setIsCopyManuallyInitiated(true);
            if (!isCopying) copyIncidents();
        },
        isLoading: isCopying && isCopyManuallyInitiated,
        isDisabled: !isChecked || isCopying && isCopyManuallyInitiated
    }, formatMessage((0, $d25rc.messages).taskFourCopyButtonNonFinal)))))), shouldDisplaySuccessBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            width: "240px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dA0kC))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $1fGbK.default).incidentsTaskFourSuccessNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $aTClY.Anchor)
                }
            }
        }
    }, formatMessage((0, $d25rc.messages).taskFourDescriptionSuccessNonFinal)))));
};

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    $3106eb14f9b0a593$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("jBfr7", function(module, exports) {

$parcel$export(module.exports, "useInterval", () => $2787df8675887336$export$f4b266cd2aae9cb1);

var $5uXOq = parcelRequire("5uXOq");
const $2787df8675887336$export$f4b266cd2aae9cb1 = (callback, delay)=>{
    const savedCallbackRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        savedCallbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handler = (...args)=>savedCallbackRef.current(...args);
        if (delay !== null) {
            const intervalId = setInterval(handler, delay);
            return ()=>clearInterval(intervalId);
        }
    }, [
        delay
    ]);
};

});

parcelRegister("7dtol", function(module, exports) {

$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("aGIRG")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("aGIRG")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = f3wqzmppnmtv35kjw7795k
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/f3wqzmppnmtv35kjw7795k

var $dCLgq = parcelRequire("dCLgq");

var $aGIRG = parcelRequire("aGIRG");
const $5790ba4da3e42a9f$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($aGIRG)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($aGIRG))
});
var $5790ba4da3e42a9f$export$2e2bcd8739ae039 = $5790ba4da3e42a9f$var$Illustration;
// for advanced use only
const $5790ba4da3e42a9f$export$a179c88182cb9d56 = [
    0,
    0,
    583,
    280
];

});
parcelRegister("aGIRG", function(module, exports) {
module.exports = new URL("moving.ac8b8afe.svg", import.meta.url).toString();

});


parcelRegister("bTyOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073396748f92b4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $5073396748f92b4e$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("iXuyj")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("9RNHv")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $dCLgq = parcelRequire("dCLgq");

var $9RNHv = parcelRequire("9RNHv");

var $iXuyj = parcelRequire("iXuyj");
const $5073396748f92b4e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($iXuyj)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($9RNHv))
});
var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
// for advanced use only
const $5073396748f92b4e$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("9RNHv", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("iXuyj", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("ivPYu", function(module, exports) {

$parcel$export(module.exports, "UnorderedList", () => $625057dcb268bd52$export$30b2abb1ad323770);
$parcel$export(module.exports, "UnorderedListItem", () => $625057dcb268bd52$export$4418ead52cf036a8);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $625057dcb268bd52$export$30b2abb1ad323770 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "ul",
        xcss: $625057dcb268bd52$var$unorderedListBoxStyles
    }, children);
const $625057dcb268bd52$export$4418ead52cf036a8 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        xcss: $625057dcb268bd52$var$listItemBoxStyles
    }, children);
const $625057dcb268bd52$var$unorderedListBoxStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100',
    listStyle: 'none'
});
const $625057dcb268bd52$var$listItemBoxStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        content: '"\u2022"',
        font: 'font.body',
        paddingRight: 'space.100'
    }
});

});

parcelRegister("dA0kC", function(module, exports) {
module.exports = new URL("incidents-task-four-illustration.6d765e71.png", import.meta.url).toString();

});

parcelRegister("2aKxa", function(module, exports) {
module.exports = new URL("incidents-task-one-illustration-dark.acd0e053.png", import.meta.url).toString();

});

parcelRegister("Mpalr", function(module, exports) {
module.exports = new URL("incidents-task-one-illustration.f43c3365.png", import.meta.url).toString();

});

parcelRegister("bEo87", function(module, exports) {
module.exports = new URL("incidents-task-two-illustration-dark.8b5496cd.png", import.meta.url).toString();

});

parcelRegister("2EChC", function(module, exports) {
module.exports = new URL("incidents-task-two-illustration.28222a25.png", import.meta.url).toString();

});

parcelRegister("d25rc", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cf4f9294779ce588$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $cf4f9294779ce588$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.error-description-non-final",
        "defaultMessage": "We've bumped into an issue while copying incidents. Please get in touch with the Atlassian support team for help."
    },
    contactAtlassianSupportButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.contact-atlassian-support-button-non-final",
        "defaultMessage": "Contact Atlassian support"
    },
    loadingTitleNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.loading-title-non-final",
        "defaultMessage": "We're copying your Opsgenie incidents to Jira Service Management"
    },
    loadingDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.loading-description-non-final",
        "defaultMessage": "Your Opsgenie incidents, linked alerts, and relevant data like PIRs are being copied to a new service project in Jira Service Management. Once it's complete, you'll be able to manage your incidents directly in Jira Service Management."
    },
    taskOneDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-one-description-non-final",
        "defaultMessage": "We've copied your Opsgenie incidents, linked alerts, and relevant data like PIRs to a new service project named **Opsgenie Migrated Incidents** in Jira Service Management, using the Incidents issue type. They'll now look and work the same way other issues do in Jira, with a more tailored experience for incident management.\n\nGo on, take a look."
    },
    taskOneButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-one-button-non-final",
        "defaultMessage": "View your incidents in Jira"
    },
    taskTwoDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-two-description-non-final",
        "defaultMessage": "We've made incident statuses and priorities simpler in Jira Service Management. Here's the mapping between Opsgenie and Jira's statuses and priorities:"
    },
    taskThreeDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-three-description-non-final",
        "defaultMessage": "These incident fields aren't copied from Opsgenie to Jira Service Management:\n\n- Actions\n- Responder roles\n- Stakeholder filters\n- Stakeholder templates\n"
    },
    taskFourDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-four-description-non-final",
        "defaultMessage": "We've copied your existing Opsgenie incidents and PIRs to Jira Service Management. It's recommend that you create and manage your incidents and PIRs directly in Jira Service Management from now on, as it's easier and more efficient.\n\nIf you create new incidents and PIRs in Opsgenie, you'll get only one chance to copy them to Jira Service Management."
    },
    taskFourConfirmationNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-four-confirmation-non-final",
        "defaultMessage": "I understand I can copy Opsgenie incidents only once"
    },
    taskFourCopyButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-four-copy-button-non-final",
        "defaultMessage": "Copy Opsgenie incidents to Jira"
    },
    taskFourDescriptionSuccessNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.task-four-description-success-non-final",
        "defaultMessage": "You successfully copied all your incidents to Jira Service Management.\n\nIf you need to copy any new incidents and PIRs again, get in touch with Atlassian Support team. [Contact Atlassian support](https://support.atlassian.com/contact/#/)"
    }
});

});

parcelRegister("lFQbs", function(module, exports) {

$parcel$export(module.exports, "PriorityTable", () => $49480c0c95d20096$export$67ef5b89c4a3c145);

var $5uXOq = parcelRequire("5uXOq");

var $k3qRI = parcelRequire("k3qRI");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $jHIcx = parcelRequire("jHIcx");

var $6eRj5 = parcelRequire("6eRj5");
const $49480c0c95d20096$export$67ef5b89c4a3c145 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const Priorities = (0, $6eRj5.getPriorities)(formatMessage);
    const rows = Object.values(Priorities).map((priority, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-priority-in-Opsgenie`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.150"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
                        // eslint-disable-next-line jira/react/no-style-attribute
                        style: {
                            backgroundColor: priority.bgColor,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            color: "var(--ds-text-inverse, #FFFFFF)"
                        }
                    }, priority.ogPriority))
                },
                {
                    key: `cell-${index}-priority-in-Jira`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                        justifyContent: "end"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                        columnGap: "space.050",
                        alignItems: "center",
                        xcss: $49480c0c95d20096$var$priorityInJiraCellStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                        xcss: $49480c0c95d20096$var$IconContainer,
                        alignItems: "center",
                        justifyContent: "center"
                    }, priority.Icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p"
                    }, priority.jiraPriority)))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'priority-in-Opsgenie',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, formatMessage((0, $jHIcx.messages).priortiyInOpsgenieNonFinal))
            },
            {
                key: 'priority-in-Jira',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                    justifyContent: "end"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $49480c0c95d20096$var$priorityInJiraHeadStyles
                }, formatMessage((0, $jHIcx.messages).priortiyInJiraNonFinal)))
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3qRI.default), {
        head: head,
        rows: rows,
        isFixedSize: true
    });
};
// In order to place priority in Jira column to the right, we need to set the width of the column.
const $49480c0c95d20096$var$priorityInJiraHeadStyles = (0, $8CUq3.xcss)({
    width: '127px'
});
const $49480c0c95d20096$var$priorityInJiraCellStyles = (0, $8CUq3.xcss)({
    width: '127px',
    paddingInlineStart: 'space.100'
});
const $49480c0c95d20096$var$IconContainer = (0, $8CUq3.xcss)({
    width: '20px',
    height: '20px'
});

});
parcelRegister("jHIcx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $99624992e3b2046e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $99624992e3b2046e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    priortiyInOpsgenieNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.priority-table.priortiy-in-opsgenie-non-final",
        "defaultMessage": "Priority in Opsgenie"
    },
    priortiyInJiraNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.priority-table.priortiy-in-jira-non-final",
        "defaultMessage": "Priority in Jira"
    },
    highestPriorityNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.priority-table.highest-priority-non-final",
        "defaultMessage": "Highest"
    },
    highPriorityNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.priority-table.high-priority-non-final",
        "defaultMessage": "High"
    },
    mediumPriorityNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.priority-table.medium-priority-non-final",
        "defaultMessage": "Medium"
    },
    lowPriorityNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.priority-table.low-priority-non-final",
        "defaultMessage": "Low"
    },
    lowestPriorityNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.priority-table.lowest-priority-non-final",
        "defaultMessage": "Lowest"
    }
});

});

parcelRegister("6eRj5", function(module, exports) {

$parcel$export(module.exports, "getPriorities", () => $f7bbe306983197c5$export$489e9c0d7da0a5e2);

var $5uXOq = parcelRequire("5uXOq");

var $5qRwM = parcelRequire("5qRwM");

var $6CLq4 = parcelRequire("6CLq4");

var $6PuvC = parcelRequire("6PuvC");

var $jIRJX = parcelRequire("jIRJX");

var $7uXMi = parcelRequire("7uXMi");

var $5ZzQ0 = parcelRequire("5ZzQ0");

var $jHIcx = parcelRequire("jHIcx");
const $f7bbe306983197c5$export$489e9c0d7da0a5e2 = (formatMessage)=>({
        P1: {
            ogPriority: 'P1',
            bgColor: "var(--ds-icon-danger, #C9372C)",
            jiraPriority: formatMessage((0, $jHIcx.messages).highestPriorityNonFinal),
            Icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6PuvC))),
                alt: ""
            })
        },
        P2: {
            ogPriority: 'P2',
            bgColor: "var(--ds-background-accent-red-subtle, #F87168)",
            jiraPriority: formatMessage((0, $jHIcx.messages).highPriorityNonFinal),
            Icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6CLq4))),
                alt: ""
            })
        },
        P3: {
            ogPriority: 'P3',
            bgColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
            jiraPriority: formatMessage((0, $jHIcx.messages).mediumPriorityNonFinal),
            Icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5ZzQ0))),
                alt: ""
            })
        },
        P4: {
            ogPriority: 'P4',
            bgColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
            jiraPriority: formatMessage((0, $jHIcx.messages).lowPriorityNonFinal),
            Icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($jIRJX))),
                alt: ""
            })
        },
        P5: {
            ogPriority: 'P5',
            bgColor: "var(--ds-background-accent-green-bolder, #1F845A)",
            jiraPriority: formatMessage((0, $jHIcx.messages).lowestPriorityNonFinal),
            Icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($7uXMi))),
                alt: ""
            })
        }
    });

});
parcelRegister("6CLq4", function(module, exports) {
module.exports = new URL("high-priority.427a170e.svg", import.meta.url).toString();

});

parcelRegister("6PuvC", function(module, exports) {
module.exports = new URL("highest-priority.32f80175.svg", import.meta.url).toString();

});

parcelRegister("jIRJX", function(module, exports) {
module.exports = new URL("low-priority.2e35e1bc.svg", import.meta.url).toString();

});

parcelRegister("7uXMi", function(module, exports) {
module.exports = new URL("lowest-priority.c391bcb1.svg", import.meta.url).toString();

});

parcelRegister("5ZzQ0", function(module, exports) {
module.exports = new URL("medium-priority.e0880a26.svg", import.meta.url).toString();

});



parcelRegister("2gHuK", function(module, exports) {

$parcel$export(module.exports, "StatusTable", () => $832c80b9335eb741$export$c849b5d47a9c2fe0);

var $5uXOq = parcelRequire("5uXOq");

var $k3qRI = parcelRequire("k3qRI");

var $eGdV2 = parcelRequire("eGdV2");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");

var $koVbs = parcelRequire("koVbs");

var $laDV1 = parcelRequire("laDV1");

var $gGrOF = parcelRequire("gGrOF");
const $832c80b9335eb741$export$c849b5d47a9c2fe0 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const Status = (0, $gGrOF.getStatus)(formatMessage);
    const rows = Object.values(Status).map((status, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-status-in-Opsgenie`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.150"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p"
                    }, status.ogStatus))
                },
                {
                    key: `cell-${index}-status-in-Jira`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.150"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                        alignItems: "center",
                        justifyContent: "space-between"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p"
                    }, status.jiraStatus), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                        columnGap: "space.025"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
                        label: "",
                        LEGACY_size: "small"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
                        appearance: status.appearance
                    }, status.lozengeContent))))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'priority-in-Opsgenie',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, formatMessage((0, $laDV1.messages).statusInOpsgenieNonFinal))
            },
            {
                key: 'priority-in-Jira',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, formatMessage((0, $laDV1.messages).statusInJiraNonFinal))
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3qRI.default), {
        head: head,
        rows: rows,
        isFixedSize: true
    });
};

});
parcelRegister("eGdV2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aaffc8f190d8dd35$var$_react = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aaffc8f190d8dd35$var$_arrowRight = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("h1TKi")));

var $aaffc8f190d8dd35$var$_arrowRight2 = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("8RBk4")));
function $aaffc8f190d8dd35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aaffc8f190d8dd35$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $aaffc8f190d8dd35$var$_react.default.createElement($aaffc8f190d8dd35$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $aaffc8f190d8dd35$var$_arrowRight2.default
    }, props));
$aaffc8f190d8dd35$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $aaffc8f190d8dd35$var$_default = module.exports.default = $aaffc8f190d8dd35$var$ArrowRightIcon;

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});

parcelRegister("8RBk4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $6740397d4ba98b13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $6740397d4ba98b13$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $6740397d4ba98b13$var$_arrowRight.default
    }));
$6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;

});


parcelRegister("laDV1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $09884c73a8702d48$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $09884c73a8702d48$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    statusInOpsgenieNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.status-in-opsgenie-non-final",
        "defaultMessage": "Status in Opsgenie"
    },
    statusInJiraNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.status-in-jira-non-final",
        "defaultMessage": "Status in Jira"
    },
    openNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.open-non-final",
        "defaultMessage": "Open"
    },
    resolveNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.resolve-non-final",
        "defaultMessage": "Resolve"
    },
    closeNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.close-non-final",
        "defaultMessage": "Close"
    },
    deleteNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.delete-non-final",
        "defaultMessage": "Delete"
    },
    pendingNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.pending-non-final",
        "defaultMessage": "Pending"
    },
    investigateNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.investigate-non-final",
        "defaultMessage": "Investigate"
    },
    cancelNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.cancel-non-final",
        "defaultMessage": "Cancel"
    },
    workInProgressNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.work-in-progress-non-final",
        "defaultMessage": "Work In Progress"
    },
    canceledNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.canceled-non-final",
        "defaultMessage": "Canceled"
    },
    completedNonFinal: {
        "id": "eoc-changeboarding.transition-home.incidents-step.status-table.completed-non-final",
        "defaultMessage": "Completed"
    }
});

});

parcelRegister("gGrOF", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $860709ec9b1714bd$export$b70265791d2079d4);

var $laDV1 = parcelRequire("laDV1");
const $860709ec9b1714bd$export$b70265791d2079d4 = (formatMessage)=>({
        Open: {
            ogStatus: formatMessage((0, $laDV1.messages).openNonFinal),
            jiraStatus: formatMessage((0, $laDV1.messages).pendingNonFinal),
            lozengeContent: formatMessage((0, $laDV1.messages).pendingNonFinal),
            appearance: 'inprogress'
        },
        Resolve: {
            ogStatus: formatMessage((0, $laDV1.messages).resolveNonFinal),
            jiraStatus: formatMessage((0, $laDV1.messages).investigateNonFinal),
            lozengeContent: formatMessage((0, $laDV1.messages).workInProgressNonFinal),
            appearance: 'inprogress'
        },
        Close: {
            ogStatus: formatMessage((0, $laDV1.messages).closeNonFinal),
            jiraStatus: formatMessage((0, $laDV1.messages).cancelNonFinal),
            lozengeContent: formatMessage((0, $laDV1.messages).canceledNonFinal),
            appearance: 'success'
        },
        Delete: {
            ogStatus: formatMessage((0, $laDV1.messages).deleteNonFinal),
            jiraStatus: formatMessage((0, $laDV1.messages).resolveNonFinal),
            lozengeContent: formatMessage((0, $laDV1.messages).completedNonFinal),
            appearance: 'success'
        }
    });

});



parcelRegister("lurvh", function(module, exports) {

$parcel$export(module.exports, "IntegrationsStep", () => $fb0b4197efd74f42$export$d87d670a1449abbf);

var $5uXOq = parcelRequire("5uXOq");

var $flpap = parcelRequire("flpap");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $5qRwM = parcelRequire("5qRwM");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
parcelRequire("9TLBW");
var $cffXA = parcelRequire("cffXA");
parcelRequire("e7Js0");
var $5qtKg = parcelRequire("5qtKg");
var $fbC19 = parcelRequire("fbC19");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $aTClY = parcelRequire("aTClY");

var $lha8j = parcelRequire("lha8j");

var $3V4J8 = parcelRequire("3V4J8");

var $5JunY = parcelRequire("5JunY");

var $1fGbK = parcelRequire("1fGbK");

var $5fIfP = parcelRequire("5fIfP");

var $1zy7h = parcelRequire("1zy7h");

var $k3gpE = parcelRequire("k3gpE");

var $CenV2 = parcelRequire("CenV2");

var $a3Q9i = parcelRequire("a3Q9i");

var $Xu9Uh = parcelRequire("Xu9Uh");
const $fb0b4197efd74f42$export$d87d670a1449abbf = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ counts: counts }] = (0, $5fIfP.useIntegrationCounts)();
    const [{ syncedIntegrations: syncedIntegrations, hasSyncedIntegration: hasSyncedIntegration }] = (0, $5fIfP.useSyncedIntegrations)();
    const [{ deprecatedIntegrations: deprecatedIntegrations, hasDeprecatedIntegration: hasDeprecatedIntegration }] = (0, $5fIfP.useDeprecatedIntegrations)();
    const [{ discontinuedIntegrations: discontinuedIntegrations, hasDiscontinuedIntegration: hasDiscontinuedIntegration }] = (0, $5fIfP.useDiscontinuedIntegrations)();
    const [{ incomingCallIntegrations: incomingCallIntegrations, hasIncomingCallIntegration: hasIncomingCallIntegration }] = (0, $5fIfP.useIncomingCallIntegrations)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isPrimaryAdmin = (0, $itmJb.useIsAdmin)();
    if (!counts.data || !deprecatedIntegrations.data || !syncedIntegrations.data || !discontinuedIntegrations.data) throw new Error('IntegrationsStep - integrations data should be loaded at this point');
    const totalCount = counts.data.totalCount;
    const notSyncedIntegrationCount = counts.data.chatCount + deprecatedIntegrations.data?.count;
    const syncedIntegrationCount = counts.data.totalCount - notSyncedIntegrationCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3V4J8.TransitionHomeHeader), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).integrationsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).integrationsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($fbC19))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($5qtKg))),
            alt: "",
            width: 130
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).integrationsTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $a3Q9i.messages).taskOneDescriptionNonFinal, {
        totalCount: totalCount,
        syncedIntegrationCount: syncedIntegrationCount,
        notSyncedIntegrationCount: notSyncedIntegrationCount
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "/jira/settings/products/ops/integrations",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $a3Q9i.messages).taskOneActionButtonNonFinal))))), hasSyncedIntegration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1zy7h))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).integrationsTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $aTClY.Anchor)
                }
            }
        }
    }, formatMessage((0, $a3Q9i.messages).taskTwoDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Xu9Uh.SyncedIntegrationsTable), {
        syncedIntegrations: syncedIntegrations
    }))), hasDiscontinuedIntegration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).integrationsTaskThreeNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $a3Q9i.messages).taskThreeDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $CenV2.DiscontinuedIntegrationsTable), {
        discontinuedIntegrations: discontinuedIntegrations
    }))), hasDeprecatedIntegration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).integrationsTaskFourNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $a3Q9i.messages).taskFourDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3gpE.DeprecatedIntegrationsTable), {
        deprecatedIntegrations: deprecatedIntegrations
    }))), hasIncomingCallIntegration && (isSiteAdmin || isPrimaryAdmin) && incomingCallIntegrations.data && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($cffXA))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($cffXA))),
            alt: "",
            width: 139
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).integrationsTaskFiveNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $a3Q9i.messages).taskFiveDescriptionNonFinal, {
        incomingCallIntegrations: incomingCallIntegrations.data.count
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "/jira/settings/products/ops/incoming-call",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $a3Q9i.messages).taskFiveActionButtonNonFinal))))));
};

});
parcelRegister("9TLBW", function(module, exports) {

$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cffXA")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("cffXA")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = fn5hfx2htbhq8ggtqmfxfk7
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/fn5hfx2htbhq8ggtqmfxfk7

var $dCLgq = parcelRequire("dCLgq");

var $cffXA = parcelRequire("cffXA");
const $7350bb6a808de070$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($cffXA)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cffXA))
});
var $7350bb6a808de070$export$2e2bcd8739ae039 = $7350bb6a808de070$var$Illustration;
// for advanced use only
const $7350bb6a808de070$export$a179c88182cb9d56 = [
    0,
    0,
    191,
    239
];

});
parcelRegister("cffXA", function(module, exports) {
module.exports = new URL("android-black-chat.8170c98f.svg", import.meta.url).toString();

});


parcelRegister("e7Js0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2276befd25e4cab$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("fbC19")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5qtKg")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tkm7rmprbgw57n9vt8r59gw
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tkm7rmprbgw57n9vt8r59gw

var $dCLgq = parcelRequire("dCLgq");

var $5qtKg = parcelRequire("5qtKg");

var $fbC19 = parcelRequire("fbC19");
const $d2276befd25e4cab$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($fbC19)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($5qtKg))
});
var $d2276befd25e4cab$export$2e2bcd8739ae039 = $d2276befd25e4cab$var$Illustration;
// for advanced use only
const $d2276befd25e4cab$export$a179c88182cb9d56 = [
    0,
    0,
    221,
    207
];

});
parcelRegister("5qtKg", function(module, exports) {
module.exports = new URL("integrations-darkmode.c1854228.svg", import.meta.url).toString();

});

parcelRegister("fbC19", function(module, exports) {
module.exports = new URL("integrations.a739abe5.svg", import.meta.url).toString();

});


parcelRegister("1zy7h", function(module, exports) {
module.exports = new URL("integrations-task-two-illustration.1ec667da.svg", import.meta.url).toString();

});

parcelRegister("k3gpE", function(module, exports) {

$parcel$export(module.exports, "DeprecatedIntegrationsTable", () => $cf7950303528d8e2$export$69e4937f38d9a6ae);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $k3qRI = parcelRequire("k3qRI");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $3bDjY = parcelRequire("3bDjY");

var $ousew = parcelRequire("ousew");

var $4t6w8 = parcelRequire("4t6w8");
const $cf7950303528d8e2$export$69e4937f38d9a6ae = ({ deprecatedIntegrations: deprecatedIntegrations })=>{
    if (!deprecatedIntegrations.data) throw new Error('DeprecatedIntegrationsTable should be rendered when synced integrations are loaded');
    const rows = deprecatedIntegrations.data.values.map((item, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-deprecated-integration`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                        space: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                        size: "xsmall",
                        src: item.logoUrl
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                        position: "top",
                        content: item.integrationName
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p",
                        maxLines: 1
                    }, item.integrationName))))
                },
                {
                    key: `cell-${index}-product-name`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p",
                        maxLines: 1
                    }, item.integrationTypeName))
                },
                {
                    key: `cell-${index}-team-name`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p",
                        maxLines: 1
                    }, item.teamName))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'deprecated-integration',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4t6w8.messages).deprecatedIntegrationsTableIntegrationNameHeadNonFinal)),
                isSortable: true
            },
            {
                key: 'product-name',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4t6w8.messages).deprecatedIntegrationsProductNameHeadNonFinal))
            },
            {
                key: 'team-name',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4t6w8.messages).deprecatedIntegrationsTeamNameHeadNonFinal))
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $4t6w8.messages).deprecatedIntegrationCountNonFinal,
        values: {
            count: deprecatedIntegrations.data.count
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3qRI.default), {
        isLoading: deprecatedIntegrations.loading,
        isFixedSize: true,
        head: head,
        rows: rows,
        rowsPerPage: 5,
        defaultPage: 1
    }));
};

});
parcelRegister("4t6w8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5766fd63911f62fa$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5766fd63911f62fa$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    deprecatedIntegrationsTableIntegrationNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.deprecated-integrations-table.deprecated-integrations-table-integration-name-head-non-final",
        "defaultMessage": "Integration"
    },
    deprecatedIntegrationsProductNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.deprecated-integrations-table.deprecated-integrations-product-name-head-non-final",
        "defaultMessage": "Product"
    },
    deprecatedIntegrationsTeamNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.deprecated-integrations-table.deprecated-integrations-team-name-head-non-final",
        "defaultMessage": "Team"
    },
    deprecatedIntegrationCountNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.deprecated-integrations-table.deprecated-integration-count-non-final",
        "defaultMessage": "{count, plural, one {{count} integration} other {{count} integrations}} were left behind in Opsgenie:"
    }
});

});


parcelRegister("CenV2", function(module, exports) {

$parcel$export(module.exports, "DiscontinuedIntegrationsTable", () => $a7b0eede1bd21e81$export$3b69d6ab3073278b);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $k3qRI = parcelRequire("k3qRI");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $3bDjY = parcelRequire("3bDjY");

var $ousew = parcelRequire("ousew");

var $2YG0Z = parcelRequire("2YG0Z");
const $a7b0eede1bd21e81$export$3b69d6ab3073278b = ({ discontinuedIntegrations: discontinuedIntegrations })=>{
    if (!discontinuedIntegrations.data) throw new Error('DiscontinuedIntegrationsTable should be rendered when synced integrations are loaded');
    const rows = discontinuedIntegrations.data.values.map((item, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-discontinued-integration`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                        space: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                        size: "xsmall",
                        src: item.logoUrl
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                        position: "top",
                        content: item.integrationName
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p",
                        maxLines: 1
                    }, item.integrationName))))
                },
                {
                    key: `cell-${index}-product-name`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p",
                        maxLines: 1
                    }, item.integrationTypeName))
                },
                {
                    key: `cell-${index}-team-name`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p",
                        maxLines: 1
                    }, item.teamName))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'discontinued-integration',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $2YG0Z.messages).discontinuedIntegrationsTableIntegrationNameHeadNonFinal)),
                isSortable: true
            },
            {
                key: 'product-name',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $2YG0Z.messages).discontinuedIntegrationsProductNameHeadNonFinal))
            },
            {
                key: 'team-name',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $2YG0Z.messages).discontinuedIntegrationsTeamNameHeadNonFinal))
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $2YG0Z.messages).discontinuedIntegrationCountNonFinal,
        values: {
            count: discontinuedIntegrations.data.count
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3qRI.default), {
        isLoading: discontinuedIntegrations.loading,
        isFixedSize: true,
        head: head,
        rows: rows,
        rowsPerPage: 5,
        defaultPage: 1
    }));
};

});
parcelRegister("2YG0Z", function(module, exports) {

$parcel$export(module.exports, "messages", () => $63c3ef1d91cbfdf4$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $63c3ef1d91cbfdf4$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    discontinuedIntegrationsTableIntegrationNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.discontinued-integrations-table.discontinued-integrations-table-integration-name-head-non-final",
        "defaultMessage": "Integration"
    },
    discontinuedIntegrationsProductNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.discontinued-integrations-table.discontinued-integrations-product-name-head-non-final",
        "defaultMessage": "Product"
    },
    discontinuedIntegrationsTeamNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.discontinued-integrations-table.discontinued-integrations-team-name-head-non-final",
        "defaultMessage": "Team"
    },
    discontinuedIntegrationCountNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.discontinued-integrations-table.discontinued-integration-count-non-final",
        "defaultMessage": "{count, plural, one {{count} integration} other {{count} integrations}} that are unavailable in Jira:"
    }
});

});


parcelRegister("a3Q9i", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b9e1462190334ff8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b9e1462190334ff8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    taskOneDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.task-one-description-non-final",
        "defaultMessage": "\nOut of {totalCount, plural, one {{totalCount} Opsgenie integration} other {{totalCount} Opsgenie integrations}}, {syncedIntegrationCount, plural, one {{syncedIntegrationCount} integration is} other {{syncedIntegrationCount} integrations are}}  fully synced with Jira Service Management.\n{notSyncedIntegrationCount, plural, =0 {} one {{notSyncedIntegrationCount} integration wasn't synced either because it isn't supported in Jira Service Management or is a chat integration that you'll need to configure manually.} other {{notSyncedIntegrationCount} integrations weren't synced either because they aren't supported in Jira Service Management or are chat integrations that you'll need to configure manually.}} \n\nTo manage your integrations, go to **Settings > Products > Integrations**.\n        "
    },
    taskOneActionButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.task-one-action-button-non-final",
        "defaultMessage": "View your integrations"
    },
    taskTwoDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.task-two-description-non-final",
        "defaultMessage": "\nYour Opsgenie's integrations with Jira and Jira Service Management are now available as Sync in **Settings > Products > Syncs**.\n\nYou can set up more syncs with your service and software projects on the same site, or a different site. [Read more about sync](https://support.atlassian.com/jira-service-management-cloud/docs/what-is-sync/).\n        "
    },
    taskThreeDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.task-three-description-non-final",
        "defaultMessage": "These are Opsgenie integrations with products that are unavailable for addition in Jira Service Management. You can edit existing instances that are synced with Jira Service Management but can't add new ones."
    },
    taskFourDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.task-four-description-non-final",
        "defaultMessage": "\nThese integrations weren't moved to Jira Service Management as we're ending support for some of them. They'll continue to work in Opsgenie until you turn off Opsgenie."
    },
    taskFiveDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.task-five-description-non-final",
        "defaultMessage": "\nAll {incomingCallIntegrations, plural, one {{incomingCallIntegrations} incoming call integration} other {{incomingCallIntegrations} incoming call integrations}} incoming call integrations in Opsgenie are now available in Jira Service Management as a native feature, not integrations. You'll find it in **Settings > Products > Incoming call routing**."
    },
    taskFiveActionButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.task-five-action-button-non-final",
        "defaultMessage": "Go to incoming call routing"
    }
});

});

parcelRegister("Xu9Uh", function(module, exports) {

$parcel$export(module.exports, "SyncedIntegrationsTable", () => $fca2525415ed7520$export$4e5f47ba6988d9d2);

var $5uXOq = parcelRequire("5uXOq");

var $k3qRI = parcelRequire("k3qRI");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $ousew = parcelRequire("ousew");

var $03Ye4 = parcelRequire("03Ye4");
const $fca2525415ed7520$export$4e5f47ba6988d9d2 = ({ syncedIntegrations: syncedIntegrations })=>{
    if (!syncedIntegrations.data) throw new Error('SyncedIntegrationsTable should be rendered when synced integrations are loaded');
    const rows = syncedIntegrations.data.values.map((item, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-sync-integration`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p",
                        maxLines: 1
                    }, item.integrationName))
                },
                {
                    key: `cell-${index}-team-name`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        paddingInlineStart: "space.100",
                        paddingBlock: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "p",
                        maxLines: 1
                    }, item.teamName))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'sync-integration',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $03Ye4.messages).syncedIntegrationsTableIntegrationNameHeadNonFinal)),
                isSortable: true
            },
            {
                key: 'team-name',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $03Ye4.messages).syncedIntegrationsTableTeamNameHeadNonFinal))
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $03Ye4.messages).syncedIntegrationCountNonFinal,
        values: {
            count: syncedIntegrations.data.count
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3qRI.default), {
        isLoading: syncedIntegrations.loading,
        isFixedSize: true,
        head: head,
        rows: rows,
        rowsPerPage: 5,
        defaultPage: 1
    }));
};

});
parcelRegister("03Ye4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $098b3a4dc02c7f29$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $098b3a4dc02c7f29$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    syncedIntegrationsTableIntegrationNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.synced-integrations-table.synced-integrations-table-integration-name-head-non-final",
        "defaultMessage": "Sync"
    },
    syncedIntegrationsTableTeamNameHeadNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.synced-integrations-table.synced-integrations-table-team-name-head-non-final",
        "defaultMessage": "Team name"
    },
    syncedIntegrationCountNonFinal: {
        "id": "eoc-changeboarding.transition-home.integrations-step.synced-integrations-table.synced-integration-count-non-final",
        "defaultMessage": "{count, plural, one {{count} Opsgenie integration} other {{count} Opsgenie integrations}} are now syncs:"
    }
});

});



parcelRegister("fKCt1", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeLeft", () => $dd608018ca69c8f9$export$2e4f33c9d0d1e59b);

var $5uXOq = parcelRequire("5uXOq");

var $5qRwM = parcelRequire("5qRwM");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $jhmo0 = parcelRequire("jhmo0");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $8vBfb = parcelRequire("8vBfb");

var $2sy1m = parcelRequire("2sy1m");

var $fmzcs = parcelRequire("fmzcs");

var $4N1X1 = parcelRequire("4N1X1");

var $gQWBh = parcelRequire("gQWBh");

var $OupRL = parcelRequire("OupRL");

var $68TJ3 = parcelRequire("68TJ3");

var $aljub = parcelRequire("aljub");

var $3kn0C = parcelRequire("3kn0C");

var $fwDj4 = parcelRequire("fwDj4");

var $4xeFY = parcelRequire("4xeFY");

var $3V4J8 = parcelRequire("3V4J8");

var $bgGxi = parcelRequire("bgGxi");

var $5JunY = parcelRequire("5JunY");

var $fEF5w = parcelRequire("fEF5w");

var $4kqRp = parcelRequire("4kqRp");

var $eSMWy = parcelRequire("eSMWy");

var $4iQaI = parcelRequire("4iQaI");

var $lLiTq = parcelRequire("lLiTq");

var $luBum = parcelRequire("luBum");

var $5fIfP = parcelRequire("5fIfP");

var $jbwqm = parcelRequire("jbwqm");

var $4UyCK = parcelRequire("4UyCK");

var $91lou = parcelRequire("91lou");

var $k9ufy = parcelRequire("k9ufy");

var $lp7PB = parcelRequire("lp7PB");
const $dd608018ca69c8f9$export$2e4f33c9d0d1e59b = ()=>{
    const { changeActiveContent: changeActiveContent } = (0, $4kqRp.useProgressActions)();
    const [{ latestContent: latestContent }] = (0, $4kqRp.useProgressStore)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const stepsRef = (0, $5uXOq.useRef)({
        [(0, $eSMWy.ProgressContents).Home]: null,
        [(0, $eSMWy.ProgressContents).UsersAndRoles]: null,
        [(0, $eSMWy.ProgressContents).Alerts]: null,
        [(0, $eSMWy.ProgressContents).Notifications]: null,
        [(0, $eSMWy.ProgressContents).Teams]: null,
        [(0, $eSMWy.ProgressContents).ChatTools]: null,
        [(0, $eSMWy.ProgressContents).AutomateAlertAndIncidentResponse]: null,
        [(0, $eSMWy.ProgressContents).Integrations]: null,
        [(0, $eSMWy.ProgressContents).Heartbeats]: null,
        [(0, $eSMWy.ProgressContents).Find]: null,
        [(0, $eSMWy.ProgressContents).DeprecatedOnes]: null,
        [(0, $eSMWy.ProgressContents).Incidents]: null
    });
    (0, $5uXOq.useEffect)(()=>{
        stepsRef.current[latestContent]?.focus();
    }, [
        latestContent
    ]);
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isPrimaryAdmin = (0, $itmJb.useIsAdmin)();
    const [{ isTeamAdmin: isTeamAdmin }] = (0, $jbwqm.useIsTeamAdmin)();
    const [usersWithoutAdminRole] = (0, $k9ufy.useGetUsersWithoutAdminRole)();
    const [usersWithoutCustomRole] = (0, $k9ufy.useGetUsersWithoutCustomRole)();
    const [stakeholders] = (0, $k9ufy.useStakeholders)();
    const [connections] = (0, $4iQaI.useChatToolsConnections)();
    const [{ hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats, hasDeprecatedTotalHeartbeats: hasDeprecatedTotalHeartbeats, isExceedHeartbeatLimit: isExceedHeartbeatLimit }] = (0, $lLiTq.useDeprecatedHeartbeats)();
    const [{ hasIntegrations: hasIntegrations }] = (0, $5fIfP.useIntegrationCounts)();
    const [{ hasTeams: hasTeams }] = (0, $4UyCK.useTeams)();
    const [{ hasSyncedIntegration: hasSyncedIntegration }] = (0, $5fIfP.useSyncedIntegrations)();
    const [{ hasDeprecatedIntegration: hasDeprecatedIntegration }] = (0, $5fIfP.useDeprecatedIntegrations)();
    const [{ hasDiscontinuedIntegration: hasDiscontinuedIntegration }] = (0, $5fIfP.useDiscontinuedIntegrations)();
    const [{ hasIncomingCallIntegration: hasIncomingCallIntegration }] = (0, $5fIfP.useIncomingCallIntegrations)();
    const [{ hasDeprecatedGroups: hasDeprecatedGroups }] = (0, $lLiTq.useDeprecatedGroups)();
    const [{ hasDeprecatedNotificationPolicies: hasDeprecatedNotificationPolicies }] = (0, $lLiTq.useDeprecatedNotificationPolicies)();
    const [{ isCopied: isCopied, shouldDisplaySuccessBanner: shouldDisplaySuccessBanner, isEligibleForCopy: isEligibleForCopy }] = (0, $luBum.useIncidents)();
    const [integrations] = (0, $4iQaI.useChatToolsIntegrations)();
    const [{ isRBNEnabled: isRBNEnabled, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart, areOgAppsDeactivated: areOgAppsDeactivated, isJnaAppDownloaded: isJnaAppDownloaded, areOgRulesDuplicated: areOgRulesDuplicated, error: error, loading: loading }] = (0, $91lou.useTransitioningStatus)();
    if (error || loading) // Users should not see this screen if one of the requests is still loading or error
    throw new Error('TransitionHomeLeft should not be rendered if transitioning status is still loading or errored');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.400",
        paddingBlock: "space.300",
        xcss: $dd608018ca69c8f9$var$wrapperBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3V4J8.TransitionHomeHeader), {
        title: formatMessage((0, $lp7PB.messages).titleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $lp7PB.messages).descriptionNonFinal, {
            link: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
                    href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/",
                    target: "_blank"
                }, text)
        }))
    }), (isSiteAdmin || isPrimaryAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgGxi.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $eSMWy.ProgressContents).UsersAndRoles] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $eSMWy.ProgressContents).UsersAndRoles, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: [
                $dd608018ca69c8f9$var$iconBoxStyles,
                $dd608018ca69c8f9$var$blueBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($fwDj4))),
            alt: ""
        })),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).usersAndRolesTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).usersAndRolesDescriptionNonFinal),
        // content will changeActiveContent when count is 0
        tasks: (0, $fEF5w.getUsersAndRolesTasks)({
            isOptimalTooling: true,
            isSiteAdmin: isSiteAdmin,
            adminDifferenceCount: usersWithoutAdminRole?.data?.count || 0,
            customRoleDifferenceCount: usersWithoutCustomRole?.data?.count || 0,
            stakeholderCount: stakeholders?.data?.userCount || 0
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgGxi.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $eSMWy.ProgressContents).Alerts] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $eSMWy.ProgressContents).Alerts, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: [
                $dd608018ca69c8f9$var$iconBoxStyles,
                $dd608018ca69c8f9$var$orangeBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8vBfb))),
            alt: ""
        })),
        title: formatMessage((0, $5JunY.messages).alertsAndOnCallTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).alertsDescriptionNonFinal),
        tasks: (0, $fEF5w.getAlertsTasks)(true)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgGxi.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $eSMWy.ProgressContents).Notifications] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $eSMWy.ProgressContents).Notifications, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: [
                $dd608018ca69c8f9$var$iconBoxStyles,
                $dd608018ca69c8f9$var$redSubtlerBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3kn0C))),
            alt: ""
        })),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).notificationsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).notificationsDescriptionNonFinal),
        tasks: (0, $fEF5w.getNotificationsTasks)({
            isRBNEnabled: isRBNEnabled,
            ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart,
            areOgAppsDeactivated: areOgAppsDeactivated,
            isJnaAppDownloaded: isJnaAppDownloaded,
            areOgRulesDuplicated: areOgRulesDuplicated
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgGxi.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $eSMWy.ProgressContents).Teams] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $eSMWy.ProgressContents).Teams, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: [
                $dd608018ca69c8f9$var$iconBoxStyles,
                $dd608018ca69c8f9$var$yellowBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4xeFY))),
            alt: ""
        })),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).teamsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).teamsDescriptionNonFinal),
        tasks: (0, $fEF5w.getTeamsTasks)(true, hasTeams)
    }), (isPrimaryAdmin || isTeamAdmin) && connections?.data?.count !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgGxi.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $eSMWy.ProgressContents).ChatTools] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $eSMWy.ProgressContents).ChatTools, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: [
                $dd608018ca69c8f9$var$iconBoxStyles,
                $dd608018ca69c8f9$var$blueSublestBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($fmzcs))),
            alt: ""
        })),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).chatToolsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).chatToolsDescriptionNonFinal),
        tasks: (0, $fEF5w.getChatToolsTasks)({
            isChatToolsConnectedToJSM: false,
            isOgIntegrationsCopiedToJSM: false,
            isDuplicateNotificationsPrevented: false,
            isPrimaryAdmin: isPrimaryAdmin,
            hasIntegration: (integrations?.data?.count || 0) > 0
        })
    }), (isPrimaryAdmin || isSiteAdmin || isTeamAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgGxi.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $eSMWy.ProgressContents).AutomateAlertAndIncidentResponse] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $eSMWy.ProgressContents).AutomateAlertAndIncidentResponse, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: [
                $dd608018ca69c8f9$var$iconBoxStyles,
                $dd608018ca69c8f9$var$yellowWarningBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($2sy1m))),
            alt: ""
        })),
        title: formatMessage((0, $5JunY.messages).automateAlertAndIncidentResponseTitleNonFinal),
        description: formatMessage((0, $5JunY.messages).automateAlertAndIncidentResponseDescriptionNonFinal),
        tasks: (0, $fEF5w.getAutomateAlertAndIncidentResponseTasks)()
    }), (isPrimaryAdmin || isSiteAdmin || isTeamAdmin) && hasIntegrations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgGxi.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $eSMWy.ProgressContents).Integrations] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $eSMWy.ProgressContents).Integrations, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: [
                $dd608018ca69c8f9$var$iconBoxStyles,
                $dd608018ca69c8f9$var$opaqSublestBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($aljub))),
            alt: ""
        })),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).integrationsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).integrationsDescriptionNonFinal),
        tasks: (0, $fEF5w.getIntegrationsTasks)({
            hasSyncedIntegration: hasSyncedIntegration,
            hasDiscontinuedIntegration: hasDiscontinuedIntegration,
            hasDeprecatedIntegration: hasDeprecatedIntegration,
            hasIncomingCallIntegration: hasIncomingCallIntegration,
            shouldHaveIncomingCallPermission: isSiteAdmin || isPrimaryAdmin
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgGxi.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $eSMWy.ProgressContents).Incidents] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $eSMWy.ProgressContents).Incidents, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: [
                $dd608018ca69c8f9$var$iconBoxStyles,
                $dd608018ca69c8f9$var$yellowBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($68TJ3))),
            width: 40,
            alt: ""
        })),
        title: formatMessage((0, $5JunY.messages).incidentsTitleNonFinal),
        description: formatMessage((0, $5JunY.messages).incidentsDescriptionNonFinal),
        tasks: (0, $fEF5w.getIncidentsTasks)({
            isCopied: isCopied,
            shouldDisplaySuccessBanner: shouldDisplaySuccessBanner,
            isEligibleForCopy: isEligibleForCopy
        })
    }), (hasDeprecatedGlobalHeartbeats || hasDeprecatedTotalHeartbeats) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgGxi.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $eSMWy.ProgressContents).Heartbeats] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $eSMWy.ProgressContents).Heartbeats, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: [
                $dd608018ca69c8f9$var$iconBoxStyles,
                $dd608018ca69c8f9$var$blueBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($OupRL))),
            width: 40,
            alt: ""
        })),
        title: formatMessage((0, $5JunY.messages).heartbeatsTitleNonFinal),
        description: formatMessage((0, $5JunY.messages).heartbeatsDescriptionNonFinal),
        tasks: (0, $fEF5w.getHeartbeatsTasks)({
            hasDeprecatedTotalHeartbeats: hasDeprecatedTotalHeartbeats,
            hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats,
            isExceedHeartbeatLimit: isExceedHeartbeatLimit
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgGxi.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $eSMWy.ProgressContents).Find] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $eSMWy.ProgressContents).Find, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: [
                $dd608018ca69c8f9$var$iconBoxStyles,
                $dd608018ca69c8f9$var$yellowBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($gQWBh))),
            width: 40,
            alt: ""
        })),
        title: formatMessage((0, $5JunY.messages).findWhatYouAreLookingForTitleNonFinal),
        description: formatMessage((0, $5JunY.messages).findWhatYouAreLookingForDescriptionNonFinal),
        tasks: (0, $fEF5w.getFindWhatYouAreLookingForTasks)()
    }), (isPrimaryAdmin || isSiteAdmin || isTeamAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgGxi.TransitionHomeStep), {
        ref: (element)=>{
            stepsRef.current[(0, $eSMWy.ProgressContents).DeprecatedOnes] = element;
        },
        onClick: (taskIndex)=>changeActiveContent((0, $eSMWy.ProgressContents).DeprecatedOnes, taskIndex),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: [
                $dd608018ca69c8f9$var$iconBoxStyles,
                $dd608018ca69c8f9$var$redSubtlestBackgroundStyles
            ],
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4N1X1))),
            alt: ""
        })),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).deprecatedOnesTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).deprecatedOnesDescriptionNonFinal),
        tasks: (0, $fEF5w.getDeprecatedOnesTasks)({
            isAdmin: isSiteAdmin || isPrimaryAdmin,
            hasDeprecatedIntegration: hasDeprecatedIntegration,
            hasDeprecatedGroups: hasDeprecatedGroups,
            hasDeprecatedGlobalHeartbeats: hasDeprecatedGlobalHeartbeats,
            hasDeprecatedNotificationPolicies: hasDeprecatedNotificationPolicies
        })
    })));
};
const $dd608018ca69c8f9$var$iconBoxStyles = (0, $8CUq3.xcss)({
    flexShrink: 0,
    borderRadius: 'border.radius.200',
    width: '56px',
    height: '56px'
});
const $dd608018ca69c8f9$var$orangeBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.orange.subtler'
});
const $dd608018ca69c8f9$var$blueBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.blue.subtler'
});
const $dd608018ca69c8f9$var$redSubtlerBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.red.subtler'
});
const $dd608018ca69c8f9$var$redSubtlestBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.red.subtlest'
});
const $dd608018ca69c8f9$var$yellowBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.yellow.subtler'
});
const $dd608018ca69c8f9$var$yellowWarningBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.warning'
});
const $dd608018ca69c8f9$var$blueSublestBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.blue.subtlest'
});
const $dd608018ca69c8f9$var$opaqSublestBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.gray.subtler'
});
const $dd608018ca69c8f9$var$wrapperBoxStyles = (0, $8CUq3.xcss)({
    height: '100%',
    overflow: 'auto'
});

});
parcelRegister("8vBfb", function(module, exports) {
module.exports = new URL("step-alerts.ab099e16.svg", import.meta.url).toString();

});

parcelRegister("2sy1m", function(module, exports) {
module.exports = new URL("step-automate-alert-and-incident-response.04583c29.svg", import.meta.url).toString();

});

parcelRegister("fmzcs", function(module, exports) {
module.exports = new URL("step-chat-tools.459c0abf.svg", import.meta.url).toString();

});

parcelRegister("4N1X1", function(module, exports) {
module.exports = new URL("step-deprecated-ones.cf47a65c.svg", import.meta.url).toString();

});

parcelRegister("gQWBh", function(module, exports) {
module.exports = new URL("step-find-what-you-are-looking-for.38be2391.svg", import.meta.url).toString();

});

parcelRegister("OupRL", function(module, exports) {
module.exports = new URL("step-heartbeats.5fa6a10d.svg", import.meta.url).toString();

});

parcelRegister("68TJ3", function(module, exports) {
module.exports = new URL("step-incidents.bbada1c7.svg", import.meta.url).toString();

});

parcelRegister("aljub", function(module, exports) {
module.exports = new URL("step-integrations.2c6dc384.svg", import.meta.url).toString();

});

parcelRegister("3kn0C", function(module, exports) {
module.exports = new URL("step-notifications.0206673e.svg", import.meta.url).toString();

});

parcelRegister("fwDj4", function(module, exports) {
module.exports = new URL("step-permissions.1da1f2d5.svg", import.meta.url).toString();

});

parcelRegister("4xeFY", function(module, exports) {
module.exports = new URL("step-teams-concept.3ee797f6.svg", import.meta.url).toString();

});

parcelRegister("bgGxi", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeStep", () => $d356dc5ca81d14ca$export$14cf80e1c8ab4f8);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $lMvsO = parcelRequire("lMvsO");
const $d356dc5ca81d14ca$export$14cf80e1c8ab4f8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ icon: icon, title: title, description: description, tasks: tasks, onClick: onClick }, ref)=>{
    const onKeyDown = (0, $5uXOq.useCallback)((e, taskIndex)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick(taskIndex);
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: ref,
        xcss: $d356dc5ca81d14ca$var$wrapperBoxStyles,
        padding: "space.250",
        onClick: ()=>onClick(),
        onKeyDown: onKeyDown,
        role: "button",
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.200"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, title), description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, tasks.map((task, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            role: "button",
            xcss: $d356dc5ca81d14ca$var$taskBoxStyles,
            padding: "space.100",
            key: index,
            tabIndex: 0,
            onClick: (e)=>{
                e.stopPropagation();
                onClick(index);
            },
            onKeyDown: (e)=>{
                e.stopPropagation();
                onKeyDown(e, index);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lMvsO.ArrowRightCircleOutline), null), task.description)))))));
});
const $d356dc5ca81d14ca$var$wrapperBoxStyles = (0, $8CUq3.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderRadius: 'border.radius.200',
    cursor: 'pointer'
});
const $d356dc5ca81d14ca$var$taskBoxStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.raised',
    borderRadius: 'border.radius.100',
    transition: '0.2s ease all',
    ':hover': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    },
    ':focus': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    }
});

});
parcelRegister("lMvsO", function(module, exports) {

$parcel$export(module.exports, "ArrowRightCircleOutline", () => $089ea57d731b0660$export$bcf2c0707dacd14a);

var $5uXOq = parcelRequire("5uXOq");
const $089ea57d731b0660$export$bcf2c0707dacd14a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        role: "presentation",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        width: "20",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-chart-gray-bold, #8590A2)",
        d: "M17.5 10c0 4.1421-3.3579 7.5-7.5 7.5S2.5 14.1421 2.5 10 5.8579 2.5 10 2.5s7.5 3.3579 7.5 7.5Zm-1.6667 0c0-3.2217-2.6116-5.8333-5.8333-5.8333-3.2217 0-5.8333 2.6116-5.8333 5.8333 0 3.2217 2.6116 5.8333 5.8333 5.8333 3.2217 0 5.8333-2.6116 5.8333-5.8333Zm-2.6773-.514-.0668-.0753a.8359.8359 0 0 1 .1848.2798.767.767 0 0 1 .0295.0878.776.776 0 0 1 .0206.098.8203.8203 0 0 1 .0092.1237l-.0001.0161a.896.896 0 0 1-.0032.0591L13.3333 10a.8482.8482 0 0 1-.0287.2178.9379.9379 0 0 1-.0315.0939.8159.8159 0 0 1-.1145.199.8807.8807 0 0 1-.0412.049l-.0282.0296-2.5 2.5a.8333.8333 0 0 1-1.2478-1.1l.0694-.0786 1.0767-1.0774H7.5a.8333.8333 0 0 1-.1045-1.6601L7.5 9.1667h2.9891L9.4108 8.0893a.8335.8335 0 0 1-.0694-1.1l.0694-.0786a.8335.8335 0 0 1 1.1-.0693l.0784.0693 2.5024 2.5024a.8205.8205 0 0 1 .0644.073Z"
    }));

});


parcelRegister("lp7PB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $058295ed4e9ffbf1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $058295ed4e9ffbf1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.transition-home.left.title-non-final",
        "defaultMessage": "Moving from Opsgenie to Jira Service Management"
    },
    descriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.left.description-non-final",
        "defaultMessage": "Here's a guide with everything that you must know and do to complete your move from Opsgenie to Jira Service Management. <link>Get more help with the move</link>"
    }
});

});


parcelRegister("l2kza", function(module, exports) {

$parcel$export(module.exports, "default", () => $b60c18bb46420e49$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b60c18bb46420e49$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.back-button-non-final",
        "defaultMessage": "Back"
    },
    closeButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.close-button-non-final",
        "defaultMessage": "Close"
    },
    minimizeNonFinal: {
        "id": "eoc-changeboarding.transition-home.minimize-non-final",
        "defaultMessage": "Minimize"
    },
    giveFeedbackButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.give-feedback-button-non-final",
        "defaultMessage": "Give feedback"
    }
});

});

parcelRegister("gsf0a", function(module, exports) {

$parcel$export(module.exports, "NotificationsStep", () => $493faa55f2c761c0$export$1318b037d331dd3a);

var $5uXOq = parcelRequire("5uXOq");

var $luBm6 = parcelRequire("luBm6");

var $ousew = parcelRequire("ousew");

var $3V4J8 = parcelRequire("3V4J8");

var $5JunY = parcelRequire("5JunY");

var $91lou = parcelRequire("91lou");

var $42dN9 = parcelRequire("42dN9");

var $3uJ1L = parcelRequire("3uJ1L");

var $dREdL = parcelRequire("dREdL");
const $493faa55f2c761c0$export$1318b037d331dd3a = ()=>{
    const [{ isRBNEnabled: isRBNEnabled, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart, loading: loading }] = (0, $91lou.useTransitioningStatus)();
    if (loading) throw new Error('NotificationsStep - Data should be loaded at this point.');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3V4J8.TransitionHomeHeader), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).notificationsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).notificationsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dREdL.CardZero), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42dN9.CardOne), null), (ogAppExistsAtTransitioningStart || isRBNEnabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3uJ1L.CardTwo), null));
};

});
parcelRegister("42dN9", function(module, exports) {

$parcel$export(module.exports, "CardOne", () => $f102e6ac56977b26$export$d129961cedc364a0);

var $5uXOq = parcelRequire("5uXOq");

var $flpap = parcelRequire("flpap");

var $l1N8i = parcelRequire("l1N8i");

var $c2i4s = parcelRequire("c2i4s");

var $96UJI = parcelRequire("96UJI");

var $5qRwM = parcelRequire("5qRwM");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $lha8j = parcelRequire("lha8j");

var $1fGbK = parcelRequire("1fGbK");

var $91lou = parcelRequire("91lou");

var $cEFEX = parcelRequire("cEFEX");

var $fEyoS = parcelRequire("fEyoS");

var $kqUre = parcelRequire("kqUre");
const $f102e6ac56977b26$var$Layout = ({ children: children, isRBNEnabled: isRBNEnabled, isJnaAppDownloaded: isJnaAppDownloaded, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            alignInline: "center",
            space: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($cEFEX))),
            alt: "https://atlassian.app.link/jswc-mobile-app-text"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            xcss: [
                $f102e6ac56977b26$var$inlineStyles,
                $f102e6ac56977b26$var$qrTextStyles
            ]
        }, formatMessage((0, $fEyoS.default).downloadJna)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).notificationsTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $fEyoS.default).descriptionNonFinal, {
        hideMiddleParagraph: isJnaAppDownloaded && !isRBNEnabled && !ogAppExistsAtTransitioningStart,
        isRBNEnabled: isRBNEnabled
    }))), children));
};
const $f102e6ac56977b26$export$d129961cedc364a0 = ()=>{
    const [{ isJnaAppDownloaded: isJnaAppDownloaded, isRBNEnabled: isRBNEnabled, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart }] = (0, $91lou.useTransitioningStatus)();
    if (/* 1A & 1B */ !isJnaAppDownloaded || /* 1G */ isJnaAppDownloaded && isRBNEnabled || /* 1F */ isJnaAppDownloaded && !isRBNEnabled && !ogAppExistsAtTransitioningStart) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f102e6ac56977b26$var$Layout, {
        isJnaAppDownloaded: isJnaAppDownloaded,
        isRBNEnabled: isRBNEnabled,
        ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $f102e6ac56977b26$var$inlineStyles,
        alignBlock: "baseline",
        space: "space.050"
    }, isJnaAppDownloaded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96UJI))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), isJnaAppDownloaded ? (0, $fEyoS.default).addedJnaNonFinal : (0, $fEyoS.default).couldntDetectJnaNonFinal)));
    // 1E & 1D
    if (isJnaAppDownloaded && !isRBNEnabled && ogAppExistsAtTransitioningStart) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f102e6ac56977b26$var$Layout, {
        isJnaAppDownloaded: isJnaAppDownloaded,
        isRBNEnabled: isRBNEnabled,
        ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kqUre.MobileDeviceList), null));
    throw new Error('CardOne - unexpected state');
};
const $f102e6ac56977b26$var$inlineStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest'
});
const $f102e6ac56977b26$var$qrTextStyles = (0, $8CUq3.xcss)({
    textAlign: 'center',
    width: '148px'
});

});
parcelRegister("96UJI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c283363b764d34f6b30155eda3eaef46>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a20af3e274078d5$var$_react = $6a20af3e274078d5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6a20af3e274078d5$var$_information = $6a20af3e274078d5$var$_interopRequireDefault((parcelRequire("2Yv61")));

var $6a20af3e274078d5$var$_info = $6a20af3e274078d5$var$_interopRequireDefault((parcelRequire("iRH6p")));
function $6a20af3e274078d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorInfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a20af3e274078d5$var$InformationIcon = (props)=>/*#__PURE__*/ $6a20af3e274078d5$var$_react.default.createElement($6a20af3e274078d5$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $6a20af3e274078d5$var$_info.default
    }, props));
$6a20af3e274078d5$var$InformationIcon.Name = 'InformationIconMigration';
var $6a20af3e274078d5$var$_default = module.exports.default = $6a20af3e274078d5$var$InformationIcon;

});
parcelRegister("iRH6p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbbe9c7ad934f1e0$var$_react = $dbbe9c7ad934f1e0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $dbbe9c7ad934f1e0$var$_information = $dbbe9c7ad934f1e0$var$_interopRequireDefault((parcelRequire("2Yv61")));
function $dbbe9c7ad934f1e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dbbe9c7ad934f1e0$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $dbbe9c7ad934f1e0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $dbbe9c7ad934f1e0$var$_information.default
    }));
$dbbe9c7ad934f1e0$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $dbbe9c7ad934f1e0$var$_default = module.exports.default = $dbbe9c7ad934f1e0$var$EditorInfoIcon;

});


parcelRegister("cEFEX", function(module, exports) {
module.exports = new URL("qr.8585fc42.png", import.meta.url).toString();

});

parcelRegister("fEyoS", function(module, exports) {

$parcel$export(module.exports, "default", () => $676e80a45fa72ccc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $676e80a45fa72ccc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    descriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.description-non-final",
        "defaultMessage": "Get notified of alerts, check on-call schedules, and manage your notifications on the go, with the Jira Cloud mobile app.\n\n{hideMiddleParagraph, select,\n    true {}\n    other {{isRBNEnabled, select,\n        true {A central notification template applies to you, so you need the Jira Cloud mobile app to receive push notifications for alerts and on-call. Central notification templates are called role-based notifications in Jira Service Management.}\n        other {Once you've installed it, you can add it as a notification method to start receiving push notifications for alerts and on-call. Your notification rules from Opsgenie will be copied to your Jira Cloud mobile app, without any changes.}\n    }}\n}\n\nMake sure your Jira Cloud mobile app is up-to-date and that you allow it to send you push notifications in your mobile settings."
    },
    couldntDetectJnaNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.couldnt-detect-jna-non-final",
        "defaultMessage": "Couldn't detect any mobile device with Jira Cloud app installed"
    },
    addedJnaNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.added-jna-non-final",
        "defaultMessage": "Added. You'll now get push notifications from the Jira Cloud mobile app."
    },
    downloadJna: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.download-jna",
        "defaultMessage": "Scan to download the Jira Cloud mobile app"
    }
});

});

parcelRegister("kqUre", function(module, exports) {

$parcel$export(module.exports, "MobileDeviceList", () => $b21456cb54d03c48$export$c47ee992c358ec22);

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $kkJfY = parcelRequire("kkJfY");

var $k3qRI = parcelRequire("k3qRI");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $gPfYl = parcelRequire("gPfYl");

var $91lou = parcelRequire("91lou");

var $eBANO = parcelRequire("eBANO");

var $7XH0A = parcelRequire("7XH0A");
const $b21456cb54d03c48$var$ROWS_PER_PAGE = 5;
const $b21456cb54d03c48$export$c47ee992c358ec22 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ values: values }] = (0, $gPfYl.useJNAAppStatus)();
    const [{ areOgRulesDuplicated: areOgRulesDuplicated }] = (0, $91lou.useTransitioningStatus)();
    const { sync: sync, loading: syncLoading, syncStarted: syncStarted } = (0, $eBANO.useSyncDevices)();
    if (!values) throw new Error('MobileDeviceList - data should be loaded when you render this component');
    const [ids, setIds] = (0, $5uXOq.useState)(new Set());
    const lastCheckbox = (0, $5uXOq.useRef)();
    const handleCopy = ()=>{
        const items = [
            ...ids.values()
        ];
        const isValid = items.length > 0;
        if (!isValid) {
            lastCheckbox.current?.setCustomValidity(formatMessage((0, $7XH0A.default).noSelectionNonFinal));
            lastCheckbox.current?.reportValidity();
            return;
        }
        sync(items);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $b21456cb54d03c48$var$fullWidthWrapperStyles,
            ...values.length > $b21456cb54d03c48$var$ROWS_PER_PAGE ? [] : [
                $b21456cb54d03c48$var$fixBottomMarginStyles
            ]
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3qRI.default), {
        head: {
            cells: [
                // Without a space in content, the styles break visually
                ...!areOgRulesDuplicated ? [
                    {
                        content: ' '
                    }
                ] : [],
                {
                    content: formatMessage((0, $7XH0A.default).mobileDeviceNonFinal),
                    isSortable: true,
                    key: 'string'
                },
                {
                    content: formatMessage((0, $7XH0A.default).appVersionNonFinal)
                },
                ...areOgRulesDuplicated ? [
                    {
                        content: formatMessage((0, $7XH0A.default).statusNonFinal)
                    }
                ] : []
            ]
        },
        rows: values.filter((device)=>!areOgRulesDuplicated || device.synced).map((value)=>({
                key: value.name + value.id,
                cells: [
                    ...!areOgRulesDuplicated ? [
                        {
                            content: !areOgRulesDuplicated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
                                onChange: (e)=>{
                                    if (e.target.checked) {
                                        e.target?.setCustomValidity('');
                                        setIds((prev)=>new Set(prev).add(value.id));
                                    } else setIds((prev)=>{
                                        const newSet = new Set(prev);
                                        newSet.delete(value.id);
                                        return newSet;
                                    });
                                },
                                ref: (r)=>{
                                    if (r && !r.checked) lastCheckbox.current = r;
                                },
                                value: value.id,
                                isDisabled: syncStarted || syncLoading,
                                isChecked: ids.has(value.id)
                            })
                        }
                    ] : [],
                    {
                        content: value.name
                    },
                    {
                        content: value.appVersion
                    },
                    ...areOgRulesDuplicated ? [
                        {
                            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
                                appearance: value.synced ? 'success' : 'removed'
                            }, formatMessage(value.synced ? (0, $7XH0A.default).statusOnNonFinal : (0, $7XH0A.default).statusOffNonFinal))
                        }
                    ] : []
                ]
            })),
        rowsPerPage: $b21456cb54d03c48$var$ROWS_PER_PAGE,
        defaultPage: 1,
        defaultSortKey: "string",
        defaultSortOrder: "ASC"
    })), !areOgRulesDuplicated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        onClick: handleCopy,
        isLoading: syncLoading,
        isDisabled: syncStarted
    }, formatMessage((0, $7XH0A.default).duplicateButtonNonFinal)));
};
const $b21456cb54d03c48$var$fullWidthWrapperStyles = (0, $8CUq3.xcss)({
    width: '100%'
});
const $b21456cb54d03c48$var$fixBottomMarginStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.negative.200'
});

});
parcelRegister("eBANO", function(module, exports) {

$parcel$export(module.exports, "useSyncDevices", () => $18483a99873e5dbc$export$53be5cda9a22cfe3);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $koeKL = parcelRequire("koeKL");

var $6dPSJ = parcelRequire("6dPSJ");

var $6aG3L = parcelRequire("6aG3L");
const $18483a99873e5dbc$export$53be5cda9a22cfe3 = ()=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [syncStarted, setSyncStarted] = (0, $5uXOq.useState)(false);
    const cloudId = (0, $koeKL.useCloudId)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    return {
        sync: (items)=>{
            if (loading) return;
            setLoading(true);
            (0, $6dPSJ.syncDevicesEndpoint)(cloudId, items).then(()=>{
                setSyncStarted(true);
            }).catch(()=>{
                showFlag({
                    type: 'error',
                    title: (0, $6aG3L.default).errorTitleNonFinal,
                    description: (0, $6aG3L.default).errorDescriptionNonFinal,
                    messageId: 'eoc-changeboarding.services.use-sync-devices.show-flag.error',
                    messageType: 'transactional'
                });
            }).finally(()=>setLoading(false));
        },
        loading: loading,
        syncStarted: syncStarted
    };
};

});
parcelRegister("6dPSJ", function(module, exports) {

$parcel$export(module.exports, "syncDevicesEndpoint", () => $839fb6e8d9ca7144$export$7ae6daa69946ab0c);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $839fb6e8d9ca7144$export$7ae6daa69946ab0c = (cloudId, values)=>(0, $eusud.performPostRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/notification-preferences/sync-devices`, {
        body: JSON.stringify({
            values: values
        })
    }).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'syncDevicesEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });

});

parcelRegister("6aG3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $638c2910639eb4fa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $638c2910639eb4fa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-sync-devices.error-title-non-final",
        "defaultMessage": "Couldn't update notification methods"
    },
    errorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-sync-devices.error-description-non-final",
        "defaultMessage": "Make sure your Jira Cloud mobile app is up-to-date, and try again."
    }
});

});


parcelRegister("7XH0A", function(module, exports) {

$parcel$export(module.exports, "default", () => $c41f6da614df89a5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c41f6da614df89a5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    mobileDeviceNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.mobile-device-non-final",
        "defaultMessage": "Mobile device"
    },
    appVersionNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.app-version-non-final",
        "defaultMessage": "App version"
    },
    statusNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.status-non-final",
        "defaultMessage": "Status"
    },
    statusOnNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.status-on-non-final",
        "defaultMessage": "ON"
    },
    statusOffNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.status-off-non-final",
        "defaultMessage": "OFF"
    },
    duplicateButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.duplicate-button-non-final",
        "defaultMessage": "Add Jira Cloud app as notification method"
    },
    noSelectionNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-one.mobile-device-list.no-selection-non-final",
        "defaultMessage": "No mobile devices selected. Select mobile devices to add Jira Cloud as the notification method."
    }
});

});



parcelRegister("3uJ1L", function(module, exports) {

$parcel$export(module.exports, "CardTwo", () => $a5761ee272365133$export$59c392903286a545);

var $5uXOq = parcelRequire("5uXOq");

var $flpap = parcelRequire("flpap");

var $fVnbM = parcelRequire("fVnbM");
var $2rqOp = parcelRequire("2rqOp");

var $kkJfY = parcelRequire("kkJfY");

var $l1N8i = parcelRequire("l1N8i");

var $c2i4s = parcelRequire("c2i4s");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $lha8j = parcelRequire("lha8j");

var $1fGbK = parcelRequire("1fGbK");

var $91lou = parcelRequire("91lou");

var $dhbx3 = parcelRequire("dhbx3");

var $5gmdP = parcelRequire("5gmdP");
const $a5761ee272365133$var$Layout = ({ children: children, heading: heading })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, heading ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).notificationsTaskThreeNonFinal)), children));
const $a5761ee272365133$export$59c392903286a545 = ()=>{
    const [{ isRBNEnabled: isRBNEnabled, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart, areOgAppsDeactivated: areOgAppsDeactivated }] = (0, $91lou.useTransitioningStatus)();
    const { deactivate: deactivate, loading: loading } = (0, $dhbx3.useDeactivateOG)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const checkbox = (0, $5uXOq.useRef)(null);
    const handleDeactivate = ()=>{
        checkbox.current?.reportValidity();
        if (!checkbox.current?.validity.valid) return;
        deactivate();
    };
    // #region ogAppExistsAtTransitioningStart === false
    if (!ogAppExistsAtTransitioningStart && !isRBNEnabled) throw new Error('CardTwo - unexpected state');
    // 2D
    if (!ogAppExistsAtTransitioningStart && isRBNEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5761ee272365133$var$Layout, {
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).contactMethodTitleNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $5gmdP.default).contactMethodDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "/jira/settings/personal/alert-notifications",
        target: "_blank"
    }, formatMessage((0, $5gmdP.default).manageContactMethodsNonFinal)));
    // #endregion
    // #region ogAppExistsAtTransitioningStart === true
    // 2A & 2B
    if (ogAppExistsAtTransitioningStart && !isRBNEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5761ee272365133$var$Layout, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $5gmdP.default).avoidDuplicateNotificationsNonFinal))), !areOgAppsDeactivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        ref: checkbox,
        isRequired: true,
        label: formatMessage((0, $5gmdP.default).acknowledgeTurnOffOgNonFinal)
    }), !areOgAppsDeactivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        onClick: handleDeactivate,
        isLoading: loading
    }, formatMessage((0, $5gmdP.default).turnOffOgCtaNonFinal)), areOgAppsDeactivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $a5761ee272365133$var$inlineStyles,
        alignBlock: "baseline",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5gmdP.default).ogTurnedOffNonFinal)));
    // 2C
    if (ogAppExistsAtTransitioningStart && isRBNEnabled && areOgAppsDeactivated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5761ee272365133$var$Layout, {
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).preventPushTitleNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $5gmdP.default).preventPushDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $a5761ee272365133$var$inlineStyles,
        alignBlock: "baseline",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5gmdP.default).ogTurnedOffNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5761ee272365133$var$Layout, {
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).deleteOgContactMethodsTitleNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $5gmdP.default).deleteOgCantactMethodsDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "/jira/settings/personal/alert-notifications",
        target: "_blank"
    }, formatMessage((0, $5gmdP.default).manageContactMethodsNonFinal))));
    // 2E
    if (ogAppExistsAtTransitioningStart && isRBNEnabled && !areOgAppsDeactivated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a5761ee272365133$var$Layout, {
        heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).preventPushTitleNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $5gmdP.default).preventPushDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        ref: checkbox,
        isRequired: true,
        label: formatMessage((0, $5gmdP.default).acknowledgeTurnOffOgNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        onClick: handleDeactivate,
        isLoading: loading
    }, formatMessage((0, $5gmdP.default).turnOffOgCtaNonFinal)));
    // #endregion
    throw new Error('CardOne - unexpected state');
};
const $a5761ee272365133$var$inlineStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest'
});

});
parcelRegister("dhbx3", function(module, exports) {

$parcel$export(module.exports, "useDeactivateOG", () => $128f6fc07b99e060$export$17946bfaf216a108);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $koeKL = parcelRequire("koeKL");

var $iTES4 = parcelRequire("iTES4");

var $91lou = parcelRequire("91lou");

var $lJ9Kp = parcelRequire("lJ9Kp");
const $128f6fc07b99e060$export$17946bfaf216a108 = ()=>{
    const { deactivateOgApps: deactivateOgApps } = (0, $91lou.useTransitioningStatusActions)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    return {
        deactivate: ()=>{
            if (loading) return;
            setLoading(true);
            (0, $iTES4.deactivateOGEndpoint)(cloudId).then(deactivateOgApps).catch(()=>{
                showFlag({
                    type: 'error',
                    title: (0, $lJ9Kp.default).errorTitleNonFinal,
                    description: (0, $lJ9Kp.default).errorDescriptionNonFinal,
                    actions: [
                        {
                            content: (0, $lJ9Kp.default).errorActionNonFinal,
                            href: '/jira/settings/personal/alert-notifications',
                            target: '_blank'
                        }
                    ],
                    messageId: 'eoc-changeboarding.services.use-deactivate-og.show-flag.error.eoc-changeboarding.services.use-mst-connection.show-flag',
                    messageType: 'transactional'
                });
            }).finally(()=>setLoading(false));
        },
        loading: loading
    };
};

});
parcelRegister("iTES4", function(module, exports) {

$parcel$export(module.exports, "deactivateOGEndpoint", () => $411a172886af0754$export$4f3458f9d2959064);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $411a172886af0754$export$4f3458f9d2959064 = (cloudId)=>(0, $eusud.performPostRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/users/contact/og-devices/deactivate`, {
        method: 'POST'
    }).catch((err)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'deactivateOGEndpoint',
                packageName: 'jiraEocChangeboarding',
                teamName: 'alexstrasza'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    });

});

parcelRegister("lJ9Kp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac28a47c90addeb3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ac28a47c90addeb3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitleNonFinal: {
        "id": "eoc-changeboarding.services.use-deactivate-og.error-title-non-final",
        "defaultMessage": "Couldn't turn off Opsgenie contact methods"
    },
    errorDescriptionNonFinal: {
        "id": "eoc-changeboarding.services.use-deactivate-og.error-description-non-final",
        "defaultMessage": "Please try again. If that doesn't work, you can manually turn off your Opsgenie mobile app in contact methods."
    },
    errorActionNonFinal: {
        "id": "eoc-changeboarding.services.use-deactivate-og.error-action-non-final",
        "defaultMessage": "Manage contact methods"
    }
});

});


parcelRegister("5gmdP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad957adc1079f75d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ad957adc1079f75d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    preventPushDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.prevent-push-description-non-final",
        "defaultMessage": "To receive all your notifications from the Jira Cloud mobile app instead of Opsgenie, you can turn off the Opsgenie mobile app in your contact methods."
    },
    ogTurnedOffNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.og-turned-off-non-final",
        "defaultMessage": "Turned off. You'll no longer get push notifications from the Opsgenie mobile app."
    },
    contactMethodDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.contact-method-description-non-final",
        "defaultMessage": "Check and update any missing contact methods, so that you get all the alert notifications as configured in the central notification template that's applied to you."
    },
    manageContactMethodsNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.manage-contact-methods-non-final",
        "defaultMessage": "Manage contact methods"
    },
    deleteOgCantactMethodsDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.delete-og-cantact-methods-description-non-final",
        "defaultMessage": "To ensure your notifications aren't pushed to your Opsgenie mobile app (which is now turned off), delete your Opsgenie contact method.\n\nThis makes Jira Mobile Cloud mobile app your primary contact method in central-notification templates."
    },
    turnOffOgCtaNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.turn-off-og-cta-non-final",
        "defaultMessage": "Turn off Opsgenie mobile app contact method"
    },
    acknowledgeTurnOffOgNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.acknowledge-turn-off-og-non-final",
        "defaultMessage": "I understand I'll stop getting alert notifications from Opsgenie mobile app"
    },
    avoidDuplicateNotificationsNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-two.avoid-duplicate-notifications-non-final",
        "defaultMessage": "To avoid duplicate notifications from Jira and Opsgenie mobile apps, you can turn off the Opsgenie mobile app in your contact methods. This will only turn off your Opsgenie mobile app as a contact method, so your notification rules and preferences will not be affected."
    }
});

});


parcelRegister("dREdL", function(module, exports) {

$parcel$export(module.exports, "CardZero", () => $123504a7452ddff3$export$2fa4bd80d48310be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $flpap = parcelRequire("flpap");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $2FEDA = parcelRequire("2FEDA");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $1fGbK = parcelRequire("1fGbK");

var $8suBg = parcelRequire("8suBg");
const $123504a7452ddff3$var$BlueText = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), {
        color: "color.link"
    }, children);
const $123504a7452ddff3$export$2fa4bd80d48310be = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        grow: "fill",
        alignInline: "center",
        alignBlock: "center",
        xcss: $123504a7452ddff3$var$wrapperInlineStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        padding: "space.300"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $luBm6.default), {
        space: "space.200",
        alignInline: "start"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), (0, $1fGbK.default).notificationsTaskOneNonFinal)), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), null, /*#__PURE__*/ $5uXOq.createElement((0, $flpap.default), {
        options: {
            overrides: {
                BlueText: {
                    component: $123504a7452ddff3$var$BlueText
                }
            }
        }
    }, formatMessage((0, $8suBg.default).descriptionNonFinal))), /*#__PURE__*/ $5uXOq.createElement((0, $fVnbM.default), {
        href: "/jira/settings/personal/alert-notifications",
        target: "_blank"
    }, formatMessage((0, $8suBg.default).manageYourAlertNotificationsNonFinal)))), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $123504a7452ddff3$var$illustrationWrapperBoxStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $kgoHi.default), {
        xcss: $123504a7452ddff3$var$iphoneContainerStyles,
        alignItems: "center",
        justifyContent: "end"
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_t9ecrz87 _ca0q9qu9 _19bv9qu9"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $2FEDA.default), {
        width: 154,
        alt: ""
    })))));
};
const $123504a7452ddff3$var$iphoneContainerStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden'
});
const $123504a7452ddff3$var$iphoneStyles = null;
const $123504a7452ddff3$var$illustrationWrapperBoxStyles = (0, $8CUq3.xcss)({
    alignSelf: 'end',
    width: '320px',
    flexShrink: 0
});
const $123504a7452ddff3$var$wrapperInlineStyles = (0, $8CUq3.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderRadius: 'border.radius.200'
});

});
parcelRegister("2FEDA", function(module, exports) {

$parcel$export(module.exports, "default", () => $396510424011790e$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = nx9r83bw45698nschcs6kxsg
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/nx9r83bw45698nschcs6kxsg

var $dCLgq = parcelRequire("dCLgq");

var $7a7Ws = parcelRequire("7a7Ws");
const $396510424011790e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($7a7Ws)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($7a7Ws))
});
var $396510424011790e$export$2e2bcd8739ae039 = $396510424011790e$var$Illustration;
// for advanced use only
const $396510424011790e$export$a179c88182cb9d56 = [
    0,
    0,
    155,
    230
];

});
parcelRegister("7a7Ws", function(module, exports) {
module.exports = new URL("iphone-black-delete.6b26517f.svg", import.meta.url).toString();

});


parcelRegister("8suBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4531e6983df25666$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4531e6983df25666$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    descriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-zero.description-non-final",
        "defaultMessage": "Your contact methods, notification and forwarding rules from Opsgenie are now synced with Jira Service Management, without any changes.\n\nYou'll continue to get your alert and on-call notifications as usual, but they will now be sent by Jira Service Management and not Opsgenie. Update your filters and blocklist in your email client to ensure that you have access to email notifications from '<BlueText>'no-reply@jsm-notifications.atlassian.net'</BlueText>'.\n\nTo manage your alert notification settings, go to **Personal settings** and select Alerts in **Notification settings**."
    },
    manageYourAlertNotificationsNonFinal: {
        "id": "eoc-changeboarding.transition-home.notifications-step.card-zero.manage-your-alert-notifications-non-final",
        "defaultMessage": "Manage your alert notifications"
    }
});

});



parcelRegister("dA5lS", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeRight", () => $6b8dc59a5cf518ca$export$cd93c3d31025c7e8);

var $5uXOq = parcelRequire("5uXOq");

var $h9rhI = parcelRequire("h9rhI");

var $e78BF = parcelRequire("e78BF");

var $e4yMr = parcelRequire("e4yMr");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $91lou = parcelRequire("91lou");

var $ldwd2 = parcelRequire("ldwd2");

var $g8vxM = parcelRequire("g8vxM");

var $hWWkH = parcelRequire("hWWkH");
const $6b8dc59a5cf518ca$export$cd93c3d31025c7e8 = ()=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $koVbs.default)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isPrimaryAdmin = (0, $itmJb.useIsAdmin)();
    const [{ isJnaAppDownloaded: isJnaAppDownloaded, areOgRulesDuplicated: areOgRulesDuplicated, areOgAppsDeactivated: areOgAppsDeactivated, jnaAppDownloadedRatio: jnaAppDownloadedRatio, jnaAppDownloadedUsersCount: jnaAppDownloadedUsersCount, ogAppExistsAtTransitioningStart: ogAppExistsAtTransitioningStart }] = (0, $91lou.useTransitioningStatus)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockStart: "space.600",
        paddingBlockEnd: "space.300",
        paddingInline: "space.500",
        xcss: $6b8dc59a5cf518ca$var$rightSideWrapperBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "h2",
        xcss: $6b8dc59a5cf518ca$var$titleHeadingBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $g8vxM.messages).titleNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWWkH.TodoItem), {
        description: formatMessage((0, $g8vxM.messages).appDownloadNonFinal),
        isChecked: isJnaAppDownloaded
    }), ogAppExistsAtTransitioningStart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWWkH.TodoItem), {
        description: formatMessage((0, $g8vxM.messages).jiraCloudContactMethodNonFinal),
        isChecked: areOgRulesDuplicated
    }), ogAppExistsAtTransitioningStart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWWkH.TodoItem), {
        description: formatMessage((0, $g8vxM.messages).turnOffOgNonFinal),
        isChecked: areOgAppsDeactivated
    }), jnaAppDownloadedUsersCount > 0 && (isPrimaryAdmin || isSiteAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.075",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e78BF))), {
        label: formatMessage((0, $g8vxM.messages).doneNonFinal),
        color: "var(--ds-link, #0C66E4)",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtlest"
    }, formatMessage((0, $g8vxM.messages).numberOfUsersJnaDownloadedWithLozengeNonFinal, {
        numberOfUsers: jnaAppDownloadedUsersCount,
        allUsers: formatNumber(jnaAppDownloadedRatio, {
            style: 'percent',
            maximumFractionDigits: 0
        }),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        lozenge: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), null, str)
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "hr",
        role: "presentation",
        xcss: $6b8dc59a5cf518ca$var$dividerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "h2",
        xcss: $6b8dc59a5cf518ca$var$titleHeadingBoxStyles
    }, formatMessage((0, $g8vxM.messages).documentationNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h9rhI))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/",
        target: "_blank",
        rel: "noopener noreferrer",
        appearance: "subtle"
    }, formatMessage((0, $g8vxM.messages).unlockOperationsInJsmNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6b8dc59a5cf518ca$var$cloudStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldwd2.Clouds), null))));
};
const $6b8dc59a5cf518ca$var$cloudStyles = (0, $8CUq3.xcss)({
    width: '85px',
    position: 'absolute',
    bottom: 'space.0',
    right: 'space.0'
});
const $6b8dc59a5cf518ca$var$rightSideWrapperBoxStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    width: '340px',
    height: '100%',
    flexShrink: 0,
    backgroundColor: 'color.background.accent.blue.subtlest',
    borderBottomRightRadius: 'border.radius',
    borderTopRightRadius: 'border.radius'
});
const $6b8dc59a5cf518ca$var$titleHeadingBoxStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase'
});
const $6b8dc59a5cf518ca$var$dividerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    border: '1px solid',
    borderColor: 'color.border'
});

});
parcelRegister("h9rhI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83cc862a6ce0fb1f7d8883d625af8c63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7c8712306b53637$var$_react = $c7c8712306b53637$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7c8712306b53637$var$_baseNew = $c7c8712306b53637$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c7c8712306b53637$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7c8712306b53637$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $c7c8712306b53637$var$_react.default.createElement($c7c8712306b53637$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$c7c8712306b53637$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $c7c8712306b53637$var$_default = module.exports.default = $c7c8712306b53637$var$BookWithBookmarkIcon;

});

parcelRegister("ldwd2", function(module, exports) {

$parcel$export(module.exports, "Clouds", () => $227eab25ed53b305$export$517de9992f3047ca);
/* eslint-disable jira/react/no-style-attribute */ 
var $5uXOq = parcelRequire("5uXOq");
const $227eab25ed53b305$export$517de9992f3047ca = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        role: "presentation",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 85 200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        style: {
            mixBlendMode: 'screen'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M205.165 216c-12.255 0-22.195-9.637-22.212-21.537v-.01c-.004-11.91-9.954-21.561-22.219-21.558h-23.86c-12.265-.003-22.205-9.665-22.201-21.575v-.01c-.004-11.91-9.954-21.561-22.2191-21.558H22.1622C9.8969 129.728-.0248 120.049 0 108.14v-.297c0-11.9097 9.943-21.5644 22.2084-21.5644h5.5254c12.2654 0 22.2084-9.6547 22.2084-21.5645v-.0103c0-11.9098 9.943-21.5645 22.2083-21.5645h13.7817c12.2654 0 22.2088-9.6547 22.2088-21.5645C108.141 9.6582 118.087 0 130.36 0H373.69c6.627 0 12 5.3726 12 12v192c0 6.627-5.373 12-12 12H205.161h.004Z",
        opacity: ".35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
        d: "M230.473 216c-12.255 0-22.194-9.637-22.212-21.537v-.01c-.003-11.91-9.953-21.561-22.219-21.558h-23.859c-12.266-.003-22.205-9.665-22.202-21.575v-.01c-.003-11.91-9.953-21.561-22.219-21.558H47.4708c-12.2653-.024-22.187-9.703-22.1622-21.612v-.297c0-11.9097 9.943-21.5644 22.2084-21.5644h5.5254c12.2654 0 22.2084-9.6547 22.2084-21.5645v-.0103c0-11.9098 9.943-21.5645 22.2083-21.5645h13.7819c12.265 0 22.208-9.6547 22.208-21.5645C133.449 9.6582 143.396 0 155.668 0h243.331c6.627 0 12 5.3726 12 12v192c0 6.627-5.373 12-12 12H230.47h.003Z",
        opacity: ".45"
    })));

});

parcelRegister("g8vxM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $647c7911cf58c44e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $647c7911cf58c44e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    titleNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.title-non-final",
        "defaultMessage": "Get alerts on Jira Cloud mobile"
    },
    appDownloadNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.app-download-non-final",
        "defaultMessage": "Get the Jira Cloud mobile app"
    },
    jiraCloudContactMethodNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.jira-cloud-contact-method-non-final",
        "defaultMessage": "Add Jira Cloud mobile app as your notification method"
    },
    turnOffOgNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.turn-off-og-non-final",
        "defaultMessage": "Turn off Opsgenie mobile app in your contact methods"
    },
    numberOfUsersJnaDownloadedNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.number-of-users-jna-downloaded-non-final",
        "defaultMessage": "{numberOfUsers, plural, one {{numberOfUsers} team member} other {{numberOfUsers} team members}} already have the Jira Cloud mobile app."
    },
    jnaAppDownloadPercentNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.jna-app-download-percent-non-final",
        "defaultMessage": "{percent}%"
    },
    doneNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.done-non-final",
        "defaultMessage": "Done"
    },
    todoNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.todo-non-final",
        "defaultMessage": "To do"
    },
    documentationNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.documentation-non-final",
        "defaultMessage": "Get help with the move"
    },
    unlockOperationsInJsmNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.unlock-operations-in-jsm-non-final",
        "defaultMessage": "Set up operations and complete your move to Jira Service Management"
    },
    numberOfUsersJnaDownloadedWithLozengeNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.number-of-users-jna-downloaded-with-lozenge-non-final",
        "defaultMessage": "<lozenge>{numberOfUsers}</lozenge> {numberOfUsers, plural, one {team member} other {team members}} already have the Jira Cloud mobile app, <lozenge>{allUsers}</lozenge> of all users"
    }
});

});

parcelRegister("hWWkH", function(module, exports) {

$parcel$export(module.exports, "TodoItem", () => $171f5908b2b34d6d$export$de515f7f7fedd6e3);

var $5uXOq = parcelRequire("5uXOq");

var $32I2y = parcelRequire("32I2y");

var $b0JGA = parcelRequire("b0JGA");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $9KgwG = parcelRequire("9KgwG");
const $171f5908b2b34d6d$export$de515f7f7fedd6e3 = ({ isChecked: isChecked, description: description })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.075",
        alignBlock: "start"
    }, isChecked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b0JGA))), {
        label: formatMessage((0, $9KgwG.messages).doneNonFinal),
        color: "var(--ds-icon-success, #22A06B)",
        spacing: "spacious"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($32I2y))), {
        label: formatMessage((0, $9KgwG.messages).todoNonFinal),
        color: "var(--ds-icon-accent-gray, #758195)",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $171f5908b2b34d6d$var$descriptionStyles
    }, description));
};
const $171f5908b2b34d6d$var$descriptionStyles = (0, $8CUq3.xcss)({
    font: 'font.body',
    color: 'color.text.subtlest',
    paddingBlock: 'space.025'
});

});
parcelRegister("32I2y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a07ad30cb23397c7e73cd518688da00d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2373b87d62ec54ad$var$_react = $2373b87d62ec54ad$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2373b87d62ec54ad$var$_baseNew = $2373b87d62ec54ad$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2373b87d62ec54ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RadioUnchecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the unselected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2373b87d62ec54ad$var$RadioUncheckedIcon = (props)=>/*#__PURE__*/ $2373b87d62ec54ad$var$_react.default.createElement($2373b87d62ec54ad$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
    }, props));
$2373b87d62ec54ad$var$RadioUncheckedIcon.displayName = 'RadioUncheckedIcon';
var $2373b87d62ec54ad$var$_default = module.exports.default = $2373b87d62ec54ad$var$RadioUncheckedIcon;

});

parcelRegister("9KgwG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $70d4880e5b7ca91d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $70d4880e5b7ca91d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    doneNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.todo-item.done-non-final",
        "defaultMessage": "Done"
    },
    todoNonFinal: {
        "id": "eoc-changeboarding.transition-home.right.todo-item.todo-non-final",
        "defaultMessage": "To do"
    }
});

});



parcelRegister("avRjR", function(module, exports) {

$parcel$export(module.exports, "TeamsConceptStep", () => $262c503825f1b155$export$75bf0627b755c06d);

var $5uXOq = parcelRequire("5uXOq");

var $flpap = parcelRequire("flpap");

var $l1N8i = parcelRequire("l1N8i");

var $5qRwM = parcelRequire("5qRwM");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $jhmo0 = parcelRequire("jhmo0");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $lha8j = parcelRequire("lha8j");

var $3V4J8 = parcelRequire("3V4J8");

var $5JunY = parcelRequire("5JunY");

var $ivPYu = parcelRequire("ivPYu");

var $1fGbK = parcelRequire("1fGbK");

var $4UyCK = parcelRequire("4UyCK");

var $2BmZa = parcelRequire("2BmZa");

var $fwoFb = parcelRequire("fwoFb");

var $kKMX5 = parcelRequire("kKMX5");

var $fL4TM = parcelRequire("fL4TM");
const $262c503825f1b155$export$75bf0627b755c06d = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ hasTeams: hasTeams, teams: teams }] = (0, $4UyCK.useTeams)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3V4J8.TransitionHomeHeader), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).teamsTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).teamsDescriptionNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($fwoFb))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($2BmZa))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).teamsTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                ul: {
                    component: (0, $ivPYu.UnorderedList)
                },
                li: {
                    component: (0, $ivPYu.UnorderedListItem)
                }
            }
        }
    }, formatMessage((0, $kKMX5.messages).taskOneDescriptionNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: "https://support.atlassian.com/jira-service-management-cloud/docs/launch-your-team-operations/",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kKMX5.messages).taskOneCtaNonFinal))))), hasTeams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).teamsTaskTwoNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $kKMX5.messages).taskTwoDescriptionNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p",
        color: "color.text.subtlest"
    }, formatMessage((0, $kKMX5.messages).tableDescriptionTextNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fL4TM.TeamsTable), {
        teams: teams
    }))))));
};

});
parcelRegister("2BmZa", function(module, exports) {
module.exports = new URL("task-one-illustration-dark.bf6c9f4d.png", import.meta.url).toString();

});

parcelRegister("fwoFb", function(module, exports) {
module.exports = new URL("task-one-illustration.d1a41afc.png", import.meta.url).toString();

});

parcelRegister("kKMX5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4bb98e7fda6c129f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4bb98e7fda6c129f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    taskOneDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.teams-concept-step.task-one-description-non-final",
        "defaultMessage": "You can build your own on-call teams and optimize alerting and on-call settings for your team's purpose and way of working.\n\nWhat you can do with on-call teams:\n\n- assign teams as a responder to alerts\n- create on-call schedules for teams\n- build team-based policies, integrations, automation, maintenance, and more.\n\nThe team admins can manage operations for the team while others can only respond to alerts.\n"
    },
    taskOneCtaNonFinal: {
        "id": "eoc-changeboarding.transition-home.teams-concept-step.task-one-cta-non-final",
        "defaultMessage": "Read how to launch operations for your team"
    },
    taskTwoDescriptionNonFinal: {
        "id": "eoc-changeboarding.transition-home.teams-concept-step.task-two-description-non-final",
        "defaultMessage": "All the teams from Opsgenie have been synced as Atlassian teams, so they'll now be visible on all products on your Atlassian site.\n\nJust so you know, only team members with a Jira Service Management license can use alerting and on-call.\n\nTo browse your teams, select **Teams > Search people and teams** from Jira navigation. On the team's profile page, select **Go to operations** to access alerting and on-call features.\n"
    },
    tableDescriptionTextNonFinal: {
        "id": "eoc-changeboarding.transition-home.teams-concept-step.table-description-text-non-final",
        "defaultMessage": "Here are some of the teams you're a member of:"
    }
});

});

parcelRegister("fL4TM", function(module, exports) {

$parcel$export(module.exports, "TeamsTable", () => $57e05c1c934e422b$export$8e18da410be5e057);

var $5uXOq = parcelRequire("5uXOq");

var $7sUFC = parcelRequire("7sUFC");
var $ujWmd = parcelRequire("ujWmd");

var $fVnbM = parcelRequire("fVnbM");

var $k3qRI = parcelRequire("k3qRI");

var $7paD5 = parcelRequire("7paD5");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");

var $koVbs = parcelRequire("koVbs");

var $aBeRp = parcelRequire("aBeRp");
const $57e05c1c934e422b$export$8e18da410be5e057 = ({ teams: teams })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!teams.data) return null;
    const rows = teams.data.entities.map((item, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-name`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7sUFC.default), {
                        avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                            name: item.displayName,
                            src: item.smallAvatarImageUrl
                        }),
                        primaryText: item.displayName,
                        secondaryText: formatMessage((0, $aBeRp.messages).memberCountNonFinal, {
                            count: item.memberCount
                        })
                    })
                },
                {
                    key: `cell-${index}-name`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
                        justifyContent: "end"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                        appearance: "subtle-link",
                        href: `/jira/people/team/${item.id}`,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                            label: ""
                        })
                    }, formatMessage((0, $aBeRp.messages).viewNonFinal)))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'name',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, formatMessage((0, $aBeRp.messages).teamNonFinal)),
                isSortable: true
            },
            {
                key: 'type',
                content: null
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3qRI.default), {
        isLoading: teams.loading,
        head: head,
        rows: rows,
        rowsPerPage: 5,
        defaultPage: 1
    });
};

});
parcelRegister("7sUFC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fee6a3655f9d2d5$export$2e2bcd8739ae039);
/* avatar-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $dS3PR = parcelRequire("dS3PR");

var $kyyq3 = parcelRequire("kyyq3");
const $0fee6a3655f9d2d5$var$bgColorCssVar = '--avatar-item-bg-color';
const $0fee6a3655f9d2d5$var$styles = {
    root: "_2rko1l7b _12ji1r31 _1qu2glyw _12y31o36 _4bfu18uv _1hmsglyw _ajmmnqa1 _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1txw _vchhusvi _1bsb1osq _4cvr1h6o _bfhk1g13 _syaz1kw7 _1wyb1kw7 _zg8l4jg8 _k48pi7a9 _vwz4kb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i51b66 _1q511b66 _y4ti1b66 _bozg1b66 _y3gn1e5h",
    rootDisabled: "_80om13gf _tzy41e4z _lcxvglyw",
    rootInteractive: "_nt751r31 _49pcglyw _1hvw1o36 _858u194a _9oik18uv _1bnxglyw _jf4cnqa1 _irr314ae _d0altlke _1di61l7b",
    avatarItem: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _vwz419ii _bozgu2gc",
    baseText: "_1e0c1ule _syaz1fxt",
    truncation: "_1reo15vq _1bto1l2s _o5721q9c",
    secondaryTextLegacy: "_syaz131l _1wyb181o"
};
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ const $0fee6a3655f9d2d5$var$AvatarItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
    const Container = (0, $kyyq3.getCustomElement)(isDisabled, href, onClick);
    const isInteractive = Boolean(onClick || href);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(Container, {
        style: {
            [$0fee6a3655f9d2d5$var$bgColorCssVar]: backgroundColor
        },
        ref: ref,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        disabled: isDisabled,
        "data-testid": testId ? `${testId}--itemInner` : undefined,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $bwpsq.default)([
            $0fee6a3655f9d2d5$var$styles.root,
            isInteractive && $0fee6a3655f9d2d5$var$styles.rootInteractive,
            isDisabled && $0fee6a3655f9d2d5$var$styles.rootDisabled
        ]),
        children: [
            avatar,
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $0fee6a3655f9d2d5$var$styles.avatarItem
                ]),
                children: (0, $VSDnB.fg)('platform.design-system-team.avatar-item-font-size_830x6') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            maxLines: isTruncationDisabled ? undefined : 1,
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            color: "color.text.subtlest",
                            maxLines: isTruncationDisabled ? undefined : 1,
                            size: "UNSAFE_small",
                            children: secondaryText
                        })
                    ]
                }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            className: (0, $bwpsq.default)([
                                $0fee6a3655f9d2d5$var$styles.baseText,
                                !isTruncationDisabled && $0fee6a3655f9d2d5$var$styles.truncation
                            ]),
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            className: (0, $bwpsq.default)([
                                $0fee6a3655f9d2d5$var$styles.baseText,
                                $0fee6a3655f9d2d5$var$styles.secondaryTextLegacy,
                                !isTruncationDisabled && $0fee6a3655f9d2d5$var$styles.truncation
                            ]),
                            children: secondaryText
                        })
                    ]
                })
            })
        ]
    });
});
$0fee6a3655f9d2d5$var$AvatarItem.displayName = 'AvatarItem';
var $0fee6a3655f9d2d5$export$2e2bcd8739ae039 = $0fee6a3655f9d2d5$var$AvatarItem;

});

parcelRegister("aBeRp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ff0ee1bbdedff562$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ff0ee1bbdedff562$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    teamNonFinal: {
        "id": "eoc-changeboarding.transition-home.teams-concept-step.teams-table.team-non-final",
        "defaultMessage": "Team"
    },
    viewNonFinal: {
        "id": "eoc-changeboarding.transition-home.teams-concept-step.teams-table.view-non-final",
        "defaultMessage": "View team"
    },
    memberCountNonFinal: {
        "id": "eoc-changeboarding.transition-home.teams-concept-step.teams-table.member-count-non-final",
        "defaultMessage": "{count, plural, one {{count} member} other {{count} members}}"
    }
});

});



parcelRegister("8rMbg", function(module, exports) {

$parcel$export(module.exports, "UsersAndRolesStep", () => $59d17cf32020f91b$export$26e472ebfeed082e);

var $5uXOq = parcelRequire("5uXOq");

var $luBm6 = parcelRequire("luBm6");

var $ousew = parcelRequire("ousew");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $3V4J8 = parcelRequire("3V4J8");

var $5JunY = parcelRequire("5JunY");

var $jGiAX = parcelRequire("jGiAX");

var $dWKPk = parcelRequire("dWKPk");
const $59d17cf32020f91b$export$26e472ebfeed082e = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isPrimaryAdmin = (0, $itmJb.useIsAdmin)();
    if (!isSiteAdmin && !isPrimaryAdmin) throw new Error('UsersAndRolesStep should be rendered only for primary or site admin');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3V4J8.TransitionHomeHeader), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).usersAndRolesTitleNonFinal),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5JunY.messages).usersAndRolesDescriptionNonFinal)
    }), isSiteAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWKPk.UsersAndRolesStepSiteAdmin), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jGiAX.UsersAndRolesStepPrimaryAdmin), null));
};

});
parcelRegister("jGiAX", function(module, exports) {

$parcel$export(module.exports, "UsersAndRolesStepPrimaryAdmin", () => $645a219631928239$export$91726114d3504de7);

var $5uXOq = parcelRequire("5uXOq");

var $flpap = parcelRequire("flpap");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");

var $4R6GH = parcelRequire("4R6GH");

var $2JXc1 = parcelRequire("2JXc1");

var $5uVXW = parcelRequire("5uVXW");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $aTClY = parcelRequire("aTClY");

var $lha8j = parcelRequire("lha8j");

var $1fGbK = parcelRequire("1fGbK");

var $k9ufy = parcelRequire("k9ufy");

var $lCqi6 = parcelRequire("lCqi6");
const $645a219631928239$export$91726114d3504de7 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [usersWithoutAdminRole] = (0, $k9ufy.useGetUsersWithoutAdminRole)();
    const [usersWithoutCustomRole] = (0, $k9ufy.useGetUsersWithoutCustomRole)();
    if (usersWithoutAdminRole.data === null || usersWithoutCustomRole.data === null) // Users should not see this screen if one of the requests is still loading or error
    throw new Error('UsersAndRolesStepPrimaryAdmin should not be rendered if users are still loading');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVXW.default), {
            width: 168,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).usersAndRolesTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $lCqi6.messages).taskOneDescriptionPrimaryAdminNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JXc1.default), {
            width: 100,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $4R6GH.fg)('ops_admin_role_release') ? (0, $1fGbK.default).usersAndRolesTaskTwoV2NonFinal : (0, $1fGbK.default).usersAndRolesTaskTwoNonFinal,
        values: {
            count: usersWithoutAdminRole.data.count
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $aTClY.Anchor)
                }
            }
        }
    }, usersWithoutAdminRole.data.count > 0 ? formatMessage((0, $4R6GH.fg)('ops_admin_role_release') ? (0, $lCqi6.messages).taskTwoDescriptionPrimaryAdminV2NonFinal : (0, $lCqi6.messages).taskTwoDescriptionPrimaryAdminNonFinal) : formatMessage((0, $4R6GH.fg)('ops_admin_role_release') ? (0, $lCqi6.messages).taskTwoEmptyDescriptionPrimaryAdminV2NonFinal : (0, $lCqi6.messages).taskTwoEmptyDescriptionPrimaryAdminNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JXc1.default), {
            width: 100,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $1fGbK.default).usersAndRolesTaskThreeNonFinal,
        values: {
            count: usersWithoutCustomRole.data.count
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $aTClY.Anchor)
                }
            }
        }
    }, usersWithoutCustomRole.data.count > 0 ? formatMessage((0, $lCqi6.messages).taskThreeDescriptionPrimaryAdminNonFinal) : formatMessage((0, $lCqi6.messages).taskThreeEmptyDescriptionPrimaryAdminNonFinal))))));
};

});
parcelRegister("5uVXW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dcf9228f35f9351$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = gb2mq7c36fg799bs6rmv7tbm
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/gb2mq7c36fg799bs6rmv7tbm

var $dCLgq = parcelRequire("dCLgq");

var $iMrbn = parcelRequire("iMrbn");
const $4dcf9228f35f9351$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($iMrbn)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($iMrbn))
});
var $4dcf9228f35f9351$export$2e2bcd8739ae039 = $4dcf9228f35f9351$var$Illustration;
// for advanced use only
const $4dcf9228f35f9351$export$a179c88182cb9d56 = [
    0,
    0,
    275,
    254
];

});
parcelRegister("iMrbn", function(module, exports) {
module.exports = new URL("rope-stanchion.597fab6c.svg", import.meta.url).toString();

});


parcelRegister("lCqi6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8048052826a674cb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8048052826a674cb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    taskOneDescriptionPrimaryAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-one-description-primary-admin-non-final",
        "defaultMessage": "\nYou can manage users' access to operations by giving them an **Admin**, **User**, or a **custom role**.\n**Admins** can create and manage on-call teams, while **Users** can use their team's operations without any admin permissions.\n\nTo manage users and roles, go to **Jira settings > Products > Role assignment** or **Custom roles**.\n        "
    },
    taskTwoDescriptionPrimaryAdminV2NonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-two-description-primary-admin-v2-non-final",
        "defaultMessage": "\nUsers who were admins in Opsgenie now have the Operations global admin role in Jira Service Management. They can manage features across your operations such as role-based notifications, custom roles, audit logs, and more.\n[Read how to make someone a product admin](https://support.atlassian.com/user-management/docs/give-users-admin-permissions/#Make-someone-a-product-admin)\n"
    },
    taskTwoDescriptionPrimaryAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-two-description-primary-admin-non-final",
        "defaultMessage": "\nThey are an admin in Opsgenie but aren't a product admin in Jira Service Management.\n\nContact your organization admin to give them the **product admin** role in Jira Service Management so they can continue to have the access to configure operations.\n[Read how to make someone a product admin](https://support.atlassian.com/user-management/docs/give-users-admin-permissions/#Make-someone-a-product-admin)\n"
    },
    taskTwoEmptyDescriptionPrimaryAdminV2NonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-two-empty-description-primary-admin-v2-non-final",
        "defaultMessage": "Users who were an Opsgenie admin are now a **Operations global admin** in Jira Service Management. They have the access to configure operations."
    },
    taskTwoEmptyDescriptionPrimaryAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-two-empty-description-primary-admin-non-final",
        "defaultMessage": "Users who were an Opsgenie admin are now a product admin in Jira Service Management. They have the access to configure operations."
    },
    taskThreeDescriptionPrimaryAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-three-description-primary-admin-non-final",
        "defaultMessage": "\nThey have a custom role in Opsgenie that isn't supported by Jira Service Management, so they currently have a User role.\n\nContact your organization admin to give them the **product admin** role in Jira Service Management so they can continue to have the access to configure operations.\n[Read how to make someone a product admin](https://support.atlassian.com/user-management/docs/give-users-admin-permissions/#Make-someone-a-product-admin)\n"
    },
    taskThreeEmptyDescriptionPrimaryAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-three-empty-description-primary-admin-non-final",
        "defaultMessage": "Users who had a custom role in Opsgenie that isn't supported by Jira Service Management are now given a different role."
    }
});

});


parcelRegister("dWKPk", function(module, exports) {

$parcel$export(module.exports, "UsersAndRolesStepSiteAdmin", () => $c2222a6dcd266d90$export$e2f0ae870b18b439);

var $5uXOq = parcelRequire("5uXOq");

var $flpap = parcelRequire("flpap");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $eGdV2 = parcelRequire("eGdV2");

var $5qRwM = parcelRequire("5qRwM");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");

var $4R6GH = parcelRequire("4R6GH");

var $2JXc1 = parcelRequire("2JXc1");

var $5uVXW = parcelRequire("5uVXW");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $aTClY = parcelRequire("aTClY");

var $lha8j = parcelRequire("lha8j");

var $9l7fA = parcelRequire("9l7fA");

var $eDIO1 = parcelRequire("eDIO1");

var $1fGbK = parcelRequire("1fGbK");

var $k9ufy = parcelRequire("k9ufy");

var $NIIvK = parcelRequire("NIIvK");
const $c2222a6dcd266d90$export$e2f0ae870b18b439 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [usersWithoutAdminRole] = (0, $k9ufy.useGetUsersWithoutAdminRole)();
    const [usersWithoutCustomRole] = (0, $k9ufy.useGetUsersWithoutCustomRole)();
    const [stakeholders] = (0, $k9ufy.useStakeholders)();
    if (usersWithoutAdminRole.data === null || usersWithoutCustomRole.data === null) // Users should not see this screen if one of the requests is still loading or error
    throw new Error('UsersAndRolesStepSiteAdmin should not be rendered if users are still loading');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVXW.default), {
            width: 168,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $1fGbK.default).usersAndRolesTaskOneNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, (0, $4R6GH.fg)('ops_admin_role_release') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $NIIvK.messages).taskOneDescriptionSiteAdminV2NonFinal)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), null, formatMessage((0, $NIIvK.messages).taskOneDescriptionSiteAdminNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "https://admin.atlassian.com/",
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $NIIvK.messages).goToAtlassianAdministrationButtonNonFinal))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JXc1.default), {
            width: 100,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $4R6GH.fg)('ops_admin_role_release') ? (0, $1fGbK.default).usersAndRolesTaskTwoV2NonFinal : (0, $1fGbK.default).usersAndRolesTaskTwoNonFinal,
        values: {
            count: usersWithoutAdminRole.data.count
        }
    })), usersWithoutAdminRole.data.count > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, $4R6GH.fg)('ops_admin_role_release') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $aTClY.Anchor)
                }
            }
        }
    }, formatMessage((0, $NIIvK.messages).taskTwoDescriptionSiteAdminNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "https://admin.atlassian.com/",
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $NIIvK.messages).goToAtlassianAdministrationButtonNonFinal)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eDIO1.UsersAndRolesStepTable), {
        data: usersWithoutAdminRole.data,
        description: !(0, $4R6GH.fg)('ops_admin_role_release') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $NIIvK.messages).taskTwoTableDescriptionSiteAdminNonFinal)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $NIIvK.messages).taskTwoEmptyStateSiteAdminNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "https://admin.atlassian.com/",
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $NIIvK.messages).goToAtlassianAdministrationButtonNonFinal)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JXc1.default), {
            width: 100,
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $1fGbK.default).usersAndRolesTaskThreeNonFinal,
        values: {
            count: usersWithoutCustomRole.data.count
        }
    })), usersWithoutCustomRole.data.count > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $aTClY.Anchor)
                }
            }
        }
    }, formatMessage((0, $NIIvK.messages).taskThreeDescriptionSiteAdminNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "https://admin.atlassian.com/",
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $NIIvK.messages).goToAtlassianAdministrationButtonNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eDIO1.UsersAndRolesStepTable), {
        data: usersWithoutCustomRole.data,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $NIIvK.messages).taskThreeTableDescriptionSiteAdminNonFinal)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $NIIvK.messages).taskThreeEmptyStateSiteAdminNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "https://admin.atlassian.com/",
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $NIIvK.messages).goToAtlassianAdministrationButtonNonFinal)))))), (stakeholders.data?.userCount || 0) > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lha8j.TransitionHomeContentBox), {
        illustration: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9l7fA))),
            alt: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, formatMessage((0, $1fGbK.default).usersAndRolesTaskFourNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flpap.default), {
        options: {
            overrides: {
                a: {
                    component: (0, $aTClY.Anchor)
                }
            }
        }
    }, formatMessage((0, $NIIvK.messages).taskFourDescriptionSiteAdminNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: "https://admin.atlassian.com/",
        target: "_blank"
    }, formatMessage((0, $NIIvK.messages).goToAtlassianAdministrationButtonNonFinal))))));
};

});
parcelRegister("9l7fA", function(module, exports) {
module.exports = new URL("users-and-roles-task-four-illustration.5598079a.svg", import.meta.url).toString();

});

parcelRegister("eDIO1", function(module, exports) {

$parcel$export(module.exports, "UsersAndRolesStepTable", () => $de0b1cffe7a15efd$export$b79ee632f1e89073);

var $5uXOq = parcelRequire("5uXOq");

var $7sUFC = parcelRequire("7sUFC");
var $ujWmd = parcelRequire("ujWmd");

var $fVnbM = parcelRequire("fVnbM");

var $k3qRI = parcelRequire("k3qRI");

var $7paD5 = parcelRequire("7paD5");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $3JMAK = parcelRequire("3JMAK");
const $de0b1cffe7a15efd$export$b79ee632f1e89073 = ({ description: description, data: data })=>{
    const rows = data.values.map((item, index)=>({
            key: `row-${index}`,
            cells: [
                {
                    key: `cell-${index}-user`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        paddingInlineStart: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                        grow: "fill",
                        spread: "space-between",
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7sUFC.default), {
                        avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                            target: "_blank",
                            href: `/jira/people/${item.id}`,
                            src: item.avatarUrl
                        }),
                        primaryText: item.name,
                        secondaryText: item.role
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        xcss: $de0b1cffe7a15efd$var$viewProfileButtonBoxStyles
                    }, item.role === 'Admin' && (0, $4R6GH.fg)('ops_admin_role_release') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $3JMAK.messages).tableUserCellGlobalOperationsAdminNonFinal)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                        href: `/jira/people/${item.id}`,
                        target: "_blank",
                        appearance: "subtle-link",
                        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $3JMAK.messages).tableUserCellActionNonFinal)))))
                }
            ]
        }));
    const head = {
        cells: [
            {
                key: 'user',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $3JMAK.messages).tableUserCellNonFinal)),
                isSortable: true
            }
        ]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p",
        color: "color.text.subtlest"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3qRI.default), {
        head: head,
        rows: rows,
        rowsPerPage: 5,
        defaultPage: 1
    }));
};
const $de0b1cffe7a15efd$var$viewProfileButtonBoxStyles = (0, $8CUq3.xcss)({
    flexShrink: 0
});

});
parcelRegister("3JMAK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d74da3205090b28f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d74da3205090b28f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    tableUserCellNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.users-and-roles.table.table-user-cell-non-final",
        "defaultMessage": "User"
    },
    tableUserCellActionNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.users-and-roles.table.table-user-cell-action-non-final",
        "defaultMessage": "View profile"
    },
    tableUserCellGlobalOperationsAdminNonFinal: {
        "id": "eoc-changeboarding.common.transition-home.users-and-roles.table.table-user-cell-global-operations-admin-non-final",
        "defaultMessage": "Global Operations Admin"
    }
});

});


parcelRegister("NIIvK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $209a036ec91aed76$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $209a036ec91aed76$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    taskOneDescriptionSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-one-description-site-admin-non-final",
        "defaultMessage": "\nUse **Atlassian Administration** to manage your teams' access to Jira Service Management and other cloud products.\n\nUsers with the **product admin** role in Jira Service Management can manage the product's settings, including operations, while Users can use the product without any admin permissions.\n        "
    },
    taskOneDescriptionSiteAdminV2NonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-one-description-site-admin-v2-non-final",
        "defaultMessage": "\nUse **Atlassian Administration** to manage your teams' access to Jira Service Management and other cloud products.\n\nUsers with the **Product admin** role in Jira Service Management can manage the product\u2019s settings.\n\n**Operations global admins** have permissions to manage features across your operations such as role-based notifications, custom roles, audit logs, and more.\n\n**Operations admins** oversee team-specific operations, such as team policies and on-call schedules. Users can access the product without any admin permissions.\n        "
    },
    goToAtlassianAdministrationButtonNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.go-to-atlassian-administration-button-non-final",
        "defaultMessage": "Go to Atlassian Administration"
    },
    taskTwoDescriptionSiteAdminV2NonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-two-description-site-admin-v2-non-final",
        "defaultMessage": "\nUsers who were admins in Opsgenie now have the **Operations global admin** role in Jira Service Management. They can manage features across your operations such as role-based notifications, custom roles, audit logs, and more.\n\n[Read how to make someone a product admin](https://support.atlassian.com/user-management/docs/give-users-admin-permissions/#Make-someone-a-product-admin)\n"
    },
    taskTwoDescriptionSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-two-description-site-admin-non-final",
        "defaultMessage": "\nThey are an admin in Opsgenie but aren't a product admin in Jira Service Management.\n\nYou can give them the **Product admin** role in Jira Service Management so they can continue to have the access to configure operations.\n[Read how to make someone a product admin](https://support.atlassian.com/user-management/docs/give-users-admin-permissions/#Make-someone-a-product-admin)\n"
    },
    taskTwoTableDescriptionSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-two-table-description-site-admin-non-final",
        "defaultMessage": "Opsgenie admins who don't have the product admin role:"
    },
    taskTwoEmptyStateSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-two-empty-state-site-admin-non-final",
        "defaultMessage": "Users who were an Opsgenie admin are now a product admin in Jira Service Management. They have the access to configure operations."
    },
    taskThreeDescriptionSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-three-description-site-admin-non-final",
        "defaultMessage": "\nThey have a custom role in Opsgenie that isn't supported by Jira Service Management, so they currently have a User role.\n\nYou can give them the **product admin** role in Jira Service Management so they can continue to have the access to configure operations.\n[Read how to make someone a product admin](https://support.atlassian.com/user-management/docs/give-users-admin-permissions/#Make-someone-a-product-admin)\n"
    },
    taskThreeTableDescriptionSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-three-table-description-site-admin-non-final",
        "defaultMessage": "Opsgenie users who no longer have custom roles:"
    },
    taskThreeEmptyStateSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-three-empty-state-site-admin-non-final",
        "defaultMessage": "Users who had a custom role in Opsgenie that isn't supported by Jira Service Management are now given a different role."
    },
    taskFourDescriptionSiteAdminNonFinal: {
        "id": "eoc-changeboarding.transition-home.users-and-roles-step.site-admin.task-four-description-site-admin-non-final",
        "defaultMessage": "All the stakeholders from Opsgenie were synced with Jira Service Management as agents, so they'll continue to have product access.\n\nYou can invite more stakeholders to Jira Service Management via Atlassian Administration. They don't need an agent license to join Jira Service Management, if you're on the Premium or Enterprise plan. [Read how to invite stakeholders](https://support.atlassian.com/jira-service-management-cloud/docs/how-can-i-add-and-manage-internal-stakeholders/#Invite-stakeholders-to-Jira-Service-Management)"
    }
});

});




parcelRegister("ajgbf", function(module, exports) {

$parcel$export(module.exports, "TransitionHomeButton", () => $71234b0c0ff4e401$export$9f72b02411896f7a);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jZ4fr = parcelRequire("jZ4fr");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $84THj = parcelRequire("84THj");

var $5qRwM = parcelRequire("5qRwM");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $fjrC9 = parcelRequire("fjrC9");

var $8vBfb = parcelRequire("8vBfb");

var $2sy1m = parcelRequire("2sy1m");

var $fmzcs = parcelRequire("fmzcs");

var $4N1X1 = parcelRequire("4N1X1");

var $gQWBh = parcelRequire("gQWBh");

var $OupRL = parcelRequire("OupRL");

var $68TJ3 = parcelRequire("68TJ3");

var $aljub = parcelRequire("aljub");

var $3kn0C = parcelRequire("3kn0C");

var $fwDj4 = parcelRequire("fwDj4");

var $4xeFY = parcelRequire("4xeFY");

var $5JunY = parcelRequire("5JunY");

var $4kqRp = parcelRequire("4kqRp");

var $eSMWy = parcelRequire("eSMWy");

var $ez5GD = parcelRequire("ez5GD");

var $lxp5k = parcelRequire("lxp5k");

var $fw7JT = parcelRequire("fw7JT");
const $71234b0c0ff4e401$export$9f72b02411896f7a = ({ onClick: onClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { update: update } = (0, $ez5GD.useOgConsolidationUserState)();
    const [{ activeContent: activeContent }] = (0, $4kqRp.useProgressStore)();
    const { src: floatingButtonSrc, xcssOverrides: xcssOverrides, stepDescription: stepDescription } = $71234b0c0ff4e401$var$floatingButtonAttributes[activeContent];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $fjrC9.TRANSITION_HOME_BUTTON_SPOTLIGHT_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        actionSubjectId: "eoc-changeboarding_transition_home_lozenge"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $71234b0c0ff4e401$var$buttonWrapperBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $71234b0c0ff4e401$var$outerBoxStyles,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClick: !isLoading ? onClick : ()=>{},
        role: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        grow: "fill",
        alignInline: "start",
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: [
            $71234b0c0ff4e401$var$iconWrapperInlineStyles,
            ...xcssOverrides
        ],
        alignBlock: "center",
        alignInline: "center"
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
        src: floatingButtonSrc,
        width: 24,
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: stepDescription ? 'xxsmall' : 'xsmall',
        as: "h2",
        color: "color.text.inverse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $fw7JT.default).getStartedNonFinal)), stepDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.inverse",
        maxLines: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), stepDescription))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $71234b0c0ff4e401$var$closeButtonBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $fw7JT.default).hideTransitionHomeNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "aria-label": formatMessage((0, $fw7JT.default).hideTransitionHomeNonFinal),
        spacing: "none",
        onClick: (e, analyticEvent)=>{
            e.stopPropagation();
            (0, $8zOmE.fireUIAnalytics)(analyticEvent, 'dismissTransitionHomeButton');
            // If an error occurs, do nothing
            update({
                isTransitionHomeHidden: true
            }).catch((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            label: formatMessage((0, $fw7JT.default).hideTransitionHomeNonFinal),
            color: "var(--ds-icon-inverse, #FFFFFF)",
            LEGACY_size: "small"
        }),
        appearance: "subtle"
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: (0, $fjrC9.TRANSITION_HOME_BUTTON_SPOTLIGHT_NAME)
    }));
};
const $71234b0c0ff4e401$var$closeButtonBoxStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    right: 'space.250',
    top: 'space.250'
});
const $71234b0c0ff4e401$var$buttonWrapperBoxStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    width: '340px'
});
const $71234b0c0ff4e401$var$outerBoxStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.blue.bolder',
    padding: 'space.100',
    borderRadius: 'border.radius.circle',
    color: 'color.text.inverse',
    boxShadow: 'elevation.shadow.overlay',
    cursor: 'pointer',
    boxSizing: 'border-box',
    paddingRight: 'space.600',
    width: '100%'
});
const $71234b0c0ff4e401$var$iconWrapperInlineStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    flexShrink: 0,
    width: 'size.400',
    height: 'size.400',
    borderRadius: 'border.radius.circle',
    background: `${"var(--ds-background-accent-blue-subtlest, #E9F2FF)"}`,
    border: `2px solid ${"var(--ds-icon-inverse, #FFFFFF)"}`,
    overflow: 'hidden'
});
const $71234b0c0ff4e401$var$orangeBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.orange.subtler'
});
const $71234b0c0ff4e401$var$blueBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.blue.subtler'
});
const $71234b0c0ff4e401$var$redSubtlerBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.red.subtler'
});
const $71234b0c0ff4e401$var$redSubtlestBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.red.subtlest'
});
const $71234b0c0ff4e401$var$yellowBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.yellow.subtler'
});
const $71234b0c0ff4e401$var$yellowWarningBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.warning'
});
const $71234b0c0ff4e401$var$blueSublestBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.blue.subtlest'
});
const $71234b0c0ff4e401$var$opaqSublestBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.gray.subtler'
});
const $71234b0c0ff4e401$var$floatingButtonAttributes = {
    [(0, $eSMWy.ProgressContents).Home]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lxp5k))),
        xcssOverrides: [],
        stepDescription: undefined
    },
    [(0, $eSMWy.ProgressContents).UsersAndRoles]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fwDj4))),
        xcssOverrides: [
            $71234b0c0ff4e401$var$blueBackgroundStyles
        ],
        stepDescription: (0, $5JunY.messages).usersAndRolesTitleNonFinal
    },
    [(0, $eSMWy.ProgressContents).Alerts]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8vBfb))),
        xcssOverrides: [
            $71234b0c0ff4e401$var$orangeBackgroundStyles
        ],
        stepDescription: (0, $5JunY.messages).alertsAndOnCallTitleNonFinal
    },
    [(0, $eSMWy.ProgressContents).Notifications]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3kn0C))),
        xcssOverrides: [
            $71234b0c0ff4e401$var$redSubtlerBackgroundStyles
        ],
        stepDescription: (0, $5JunY.messages).notificationsTitleNonFinal
    },
    [(0, $eSMWy.ProgressContents).Teams]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4xeFY))),
        xcssOverrides: [
            $71234b0c0ff4e401$var$yellowBackgroundStyles
        ],
        stepDescription: (0, $5JunY.messages).teamsTitleNonFinal
    },
    [(0, $eSMWy.ProgressContents).ChatTools]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fmzcs))),
        xcssOverrides: [
            $71234b0c0ff4e401$var$blueSublestBackgroundStyles
        ],
        stepDescription: (0, $5JunY.messages).chatToolsTitleNonFinal
    },
    [(0, $eSMWy.ProgressContents).AutomateAlertAndIncidentResponse]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2sy1m))),
        xcssOverrides: [
            $71234b0c0ff4e401$var$yellowWarningBackgroundStyles
        ],
        stepDescription: (0, $5JunY.messages).automateAlertAndIncidentResponseTitleNonFinal
    },
    [(0, $eSMWy.ProgressContents).Integrations]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aljub))),
        xcssOverrides: [
            $71234b0c0ff4e401$var$opaqSublestBackgroundStyles
        ],
        stepDescription: (0, $5JunY.messages).integrationsTitleNonFinal
    },
    [(0, $eSMWy.ProgressContents).Find]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gQWBh))),
        xcssOverrides: [
            $71234b0c0ff4e401$var$yellowBackgroundStyles
        ],
        stepDescription: (0, $5JunY.messages).findWhatYouAreLookingForTitleNonFinal
    },
    [(0, $eSMWy.ProgressContents).DeprecatedOnes]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4N1X1))),
        xcssOverrides: [
            $71234b0c0ff4e401$var$redSubtlestBackgroundStyles
        ],
        stepDescription: (0, $5JunY.messages).deprecatedOnesTitleNonFinal
    },
    [(0, $eSMWy.ProgressContents).Incidents]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($68TJ3))),
        xcssOverrides: [
            $71234b0c0ff4e401$var$yellowBackgroundStyles
        ],
        stepDescription: (0, $5JunY.messages).incidentsTitleNonFinal
    },
    [(0, $eSMWy.ProgressContents).Heartbeats]: {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($OupRL))),
        xcssOverrides: [
            $71234b0c0ff4e401$var$blueSublestBackgroundStyles
        ],
        stepDescription: (0, $5JunY.messages).heartbeatsTitleNonFinal
    }
};

});
parcelRegister("lxp5k", function(module, exports) {
module.exports = new URL("left-icon.9d0fb470.svg", import.meta.url).toString();

});

parcelRegister("fw7JT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3cc01cd21f630b4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b3cc01cd21f630b4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    getStartedNonFinal: {
        "id": "eoc-changeboarding.transition-home.transition-home-button.get-started-non-final",
        "defaultMessage": "Moving from Opsgenie"
    },
    hideTransitionHomeNonFinal: {
        "id": "eoc-changeboarding.transition-home.transition-home-button.hide-transition-home-non-final",
        "defaultMessage": "Hide guide"
    }
});

});




//# sourceMappingURL=async-eoc-changeboarding-layout-transition-home-renderer.2609f665.js.map
